const icons = {
  'small-add-1': () => Promise.resolve().then(function () { return smallAdd1; }).then(d => d.default),
  'small-add-circle': () => Promise.resolve().then(function () { return smallAddCircle; }).then(d => d.default),
  'small-alert-circle': () => Promise.resolve().then(function () { return smallAlertCircle; }).then(d => d.default),
  'small-alert-triangle': () => Promise.resolve().then(function () { return smallAlertTriangle; }).then(d => d.default),
  'small-align-back': () => Promise.resolve().then(function () { return smallAlignBack; }).then(d => d.default),
  'small-arrows-down-small': () => Promise.resolve().then(function () { return smallArrowsDownSmall; }).then(d => d.default),
  'small-arrows-expand': () => Promise.resolve().then(function () { return smallArrowsExpand; }).then(d => d.default),
  'small-arrows-left-small': () => Promise.resolve().then(function () { return smallArrowsLeftSmall; }).then(d => d.default),
  'small-arrows-reload': () => Promise.resolve().then(function () { return smallArrowsReload; }).then(d => d.default),
  'small-arrows-right-small': () => Promise.resolve().then(function () { return smallArrowsRightSmall; }).then(d => d.default),
  'small-arrows-up-small': () => Promise.resolve().then(function () { return smallArrowsUpSmall; }).then(d => d.default),
  'small-arrows-up': () => Promise.resolve().then(function () { return smallArrowsUp; }).then(d => d.default),
  'small-book-open': () => Promise.resolve().then(function () { return smallBookOpen; }).then(d => d.default),
  'small-bookmark-double': () => Promise.resolve().then(function () { return smallBookmarkDouble; }).then(d => d.default),
  'small-bookmark': () => Promise.resolve().then(function () { return smallBookmark; }).then(d => d.default),
  'small-calendar-date': () => Promise.resolve().then(function () { return smallCalendarDate; }).then(d => d.default),
  'small-check-1': () => Promise.resolve().then(function () { return smallCheck1; }).then(d => d.default),
  'small-check-circle': () => Promise.resolve().then(function () { return smallCheckCircle; }).then(d => d.default),
  'small-check': () => Promise.resolve().then(function () { return smallCheck; }).then(d => d.default),
  'small-chevron-down': () => Promise.resolve().then(function () { return smallChevronDown; }).then(d => d.default),
  'small-chevron-right': () => Promise.resolve().then(function () { return smallChevronRight; }).then(d => d.default),
  'small-chevron-up': () => Promise.resolve().then(function () { return smallChevronUp; }).then(d => d.default),
  'small-dashboard-1': () => Promise.resolve().then(function () { return smallDashboard1; }).then(d => d.default),
  'small-delete-1': () => Promise.resolve().then(function () { return smallDelete1; }).then(d => d.default),
  'small-delete-2': () => Promise.resolve().then(function () { return smallDelete2; }).then(d => d.default),
  'small-delete-bin-1': () => Promise.resolve().then(function () { return smallDeleteBin1; }).then(d => d.default),
  'small-delete-circle': () => Promise.resolve().then(function () { return smallDeleteCircle; }).then(d => d.default),
  'small-delete': () => Promise.resolve().then(function () { return smallDelete; }).then(d => d.default),
  'small-download-button-2': () => Promise.resolve().then(function () { return smallDownloadButton2; }).then(d => d.default),
  'small-drag-handle-vertical': () => Promise.resolve().then(function () { return smallDragHandleVertical; }).then(d => d.default),
  'small-edit-copy': () => Promise.resolve().then(function () { return smallEditCopy; }).then(d => d.default),
  'small-edit-pencil': () => Promise.resolve().then(function () { return smallEditPencil; }).then(d => d.default),
  'small-edit-view-off': () => Promise.resolve().then(function () { return smallEditViewOff; }).then(d => d.default),
  'small-edit-view': () => Promise.resolve().then(function () { return smallEditView; }).then(d => d.default),
  'small-exclamation-mark': () => Promise.resolve().then(function () { return smallExclamationMark; }).then(d => d.default),
  'small-file-accept': () => Promise.resolve().then(function () { return smallFileAccept; }).then(d => d.default),
  'small-file-alert': () => Promise.resolve().then(function () { return smallFileAlert; }).then(d => d.default),
  'small-file-reject': () => Promise.resolve().then(function () { return smallFileReject; }).then(d => d.default),
  'small-file-upload': () => Promise.resolve().then(function () { return smallFileUpload; }).then(d => d.default),
  'small-file': () => Promise.resolve().then(function () { return smallFile; }).then(d => d.default),
  'small-help-question-circle': () => Promise.resolve().then(function () { return smallHelpQuestionCircle; }).then(d => d.default),
  'small-id-thumb-mark': () => Promise.resolve().then(function () { return smallIdThumbMark; }).then(d => d.default),
  'small-info-circle': () => Promise.resolve().then(function () { return smallInfoCircle; }).then(d => d.default),
  'small-location-pin': () => Promise.resolve().then(function () { return smallLocationPin; }).then(d => d.default),
  'small-lock': () => Promise.resolve().then(function () { return smallLock; }).then(d => d.default),
  'small-logout': () => Promise.resolve().then(function () { return smallLogout; }).then(d => d.default),
  'small-mail-send-envelope': () => Promise.resolve().then(function () { return smallMailSendEnvelope; }).then(d => d.default),
  'small-mail-sign-hashtag': () => Promise.resolve().then(function () { return smallMailSignHashtag; }).then(d => d.default),
  'small-message-warning': () => Promise.resolve().then(function () { return smallMessageWarning; }).then(d => d.default),
  'small-money-atm-card-1': () => Promise.resolve().then(function () { return smallMoneyAtmCard1; }).then(d => d.default),
  'small-money-bank': () => Promise.resolve().then(function () { return smallMoneyBank; }).then(d => d.default),
  'small-money-cash-bag-dollar': () => Promise.resolve().then(function () { return smallMoneyCashBagDollar; }).then(d => d.default),
  'small-money-cash-coins-stack': () => Promise.resolve().then(function () { return smallMoneyCashCoinsStack; }).then(d => d.default),
  'small-money-wallet-1': () => Promise.resolve().then(function () { return smallMoneyWallet1; }).then(d => d.default),
  'small-programming-browser-code-2': () => Promise.resolve().then(function () { return smallProgrammingBrowserCode2; }).then(d => d.default),
  'small-question-mark': () => Promise.resolve().then(function () { return smallQuestionMark; }).then(d => d.default),
  'small-remove-1': () => Promise.resolve().then(function () { return smallRemove1; }).then(d => d.default),
  'small-search': () => Promise.resolve().then(function () { return smallSearch; }).then(d => d.default),
  'small-setting-cog': () => Promise.resolve().then(function () { return smallSettingCog; }).then(d => d.default),
  'small-setting-gauge-dashboard-1': () => Promise.resolve().then(function () { return smallSettingGaugeDashboard1; }).then(d => d.default),
  'small-setting-menu-horizontal': () => Promise.resolve().then(function () { return smallSettingMenuHorizontal; }).then(d => d.default),
  'small-shopping-store-2': () => Promise.resolve().then(function () { return smallShoppingStore2; }).then(d => d.default),
  'small-solid-alert-circle': () => Promise.resolve().then(function () { return smallSolidAlertCircle; }).then(d => d.default),
  'small-solid-alert-triangle': () => Promise.resolve().then(function () { return smallSolidAlertTriangle; }).then(d => d.default),
  'small-solid-check': () => Promise.resolve().then(function () { return smallSolidCheck; }).then(d => d.default),
  'small-solid-delete': () => Promise.resolve().then(function () { return smallSolidDelete; }).then(d => d.default),
  'small-solid-folder': () => Promise.resolve().then(function () { return smallSolidFolder; }).then(d => d.default),
  'small-solid-info': () => Promise.resolve().then(function () { return smallSolidInfo; }).then(d => d.default),
  'small-solid-minus': () => Promise.resolve().then(function () { return smallSolidMinus; }).then(d => d.default),
  'small-solid-user-2': () => Promise.resolve().then(function () { return smallSolidUser2; }).then(d => d.default),
  'small-solid-user-multiple': () => Promise.resolve().then(function () { return smallSolidUserMultiple; }).then(d => d.default),
  'small-tag': () => Promise.resolve().then(function () { return smallTag; }).then(d => d.default),
  'small-time-clock-circle': () => Promise.resolve().then(function () { return smallTimeClockCircle; }).then(d => d.default),
  'small-travel-map-location-pin': () => Promise.resolve().then(function () { return smallTravelMapLocationPin; }).then(d => d.default),
  'small-travel-map': () => Promise.resolve().then(function () { return smallTravelMap; }).then(d => d.default),
  'small-unlock': () => Promise.resolve().then(function () { return smallUnlock; }).then(d => d.default),
  'small-user-add': () => Promise.resolve().then(function () { return smallUserAdd; }).then(d => d.default),
  'small-user-approve': () => Promise.resolve().then(function () { return smallUserApprove; }).then(d => d.default),
  'small-user-block': () => Promise.resolve().then(function () { return smallUserBlock; }).then(d => d.default),
  'small-user-edit': () => Promise.resolve().then(function () { return smallUserEdit; }).then(d => d.default),
  'small-user-multiple': () => Promise.resolve().then(function () { return smallUserMultiple; }).then(d => d.default),
  'small-user-reject': () => Promise.resolve().then(function () { return smallUserReject; }).then(d => d.default),
  'small-user-single': () => Promise.resolve().then(function () { return smallUserSingle; }).then(d => d.default),
  'small-user-unresolved': () => Promise.resolve().then(function () { return smallUserUnresolved; }).then(d => d.default),
  'medium-add-1': () => Promise.resolve().then(function () { return mediumAdd1; }).then(d => d.default),
  'medium-add-circle': () => Promise.resolve().then(function () { return mediumAddCircle; }).then(d => d.default),
  'medium-alert-alarm-bell': () => Promise.resolve().then(function () { return mediumAlertAlarmBell; }).then(d => d.default),
  'medium-alert-circle': () => Promise.resolve().then(function () { return mediumAlertCircle; }).then(d => d.default),
  'medium-alert-triangle': () => Promise.resolve().then(function () { return mediumAlertTriangle; }).then(d => d.default),
  'medium-arrow-left': () => Promise.resolve().then(function () { return mediumArrowLeft; }).then(d => d.default),
  'medium-arrow-right': () => Promise.resolve().then(function () { return mediumArrowRight; }).then(d => d.default),
  'medium-arrows-rotate': () => Promise.resolve().then(function () { return mediumArrowsRotate; }).then(d => d.default),
  'medium-bookmark-tag': () => Promise.resolve().then(function () { return mediumBookmarkTag; }).then(d => d.default),
  'medium-check-1': () => Promise.resolve().then(function () { return mediumCheck1; }).then(d => d.default),
  'medium-check-circle': () => Promise.resolve().then(function () { return mediumCheckCircle; }).then(d => d.default),
  'medium-check': () => Promise.resolve().then(function () { return mediumCheck; }).then(d => d.default),
  'medium-chevron-down': () => Promise.resolve().then(function () { return mediumChevronDown; }).then(d => d.default),
  'medium-chevron-left-double': () => Promise.resolve().then(function () { return mediumChevronLeftDouble; }).then(d => d.default),
  'medium-chevron-left': () => Promise.resolve().then(function () { return mediumChevronLeft; }).then(d => d.default),
  'medium-chevron-right-double': () => Promise.resolve().then(function () { return mediumChevronRightDouble; }).then(d => d.default),
  'medium-chevron-right': () => Promise.resolve().then(function () { return mediumChevronRight; }).then(d => d.default),
  'medium-clock-rewind': () => Promise.resolve().then(function () { return mediumClockRewind; }).then(d => d.default),
  'medium-delete-1': () => Promise.resolve().then(function () { return mediumDelete1; }).then(d => d.default),
  'medium-delete-bin-1': () => Promise.resolve().then(function () { return mediumDeleteBin1; }).then(d => d.default),
  'medium-delete-circle': () => Promise.resolve().then(function () { return mediumDeleteCircle; }).then(d => d.default),
  'medium-delete': () => Promise.resolve().then(function () { return mediumDelete; }).then(d => d.default),
  'medium-download': () => Promise.resolve().then(function () { return mediumDownload; }).then(d => d.default),
  'medium-edit-pencil': () => Promise.resolve().then(function () { return mediumEditPencil; }).then(d => d.default),
  'medium-file-alert': () => Promise.resolve().then(function () { return mediumFileAlert; }).then(d => d.default),
  'medium-file-check-alternate': () => Promise.resolve().then(function () { return mediumFileCheckAlternate; }).then(d => d.default),
  'medium-file-code': () => Promise.resolve().then(function () { return mediumFileCode; }).then(d => d.default),
  'medium-file-double': () => Promise.resolve().then(function () { return mediumFileDouble; }).then(d => d.default),
  'medium-file-request': () => Promise.resolve().then(function () { return mediumFileRequest; }).then(d => d.default),
  'medium-file-search': () => Promise.resolve().then(function () { return mediumFileSearch; }).then(d => d.default),
  'medium-file-settings-3': () => Promise.resolve().then(function () { return mediumFileSettings3; }).then(d => d.default),
  'medium-file-upload': () => Promise.resolve().then(function () { return mediumFileUpload; }).then(d => d.default),
  'medium-file-zip': () => Promise.resolve().then(function () { return mediumFileZip; }).then(d => d.default),
  'medium-file': () => Promise.resolve().then(function () { return mediumFile; }).then(d => d.default),
  'medium-filter-3': () => Promise.resolve().then(function () { return mediumFilter3; }).then(d => d.default),
  'medium-graph-2': () => Promise.resolve().then(function () { return mediumGraph2; }).then(d => d.default),
  'medium-hamburger': () => Promise.resolve().then(function () { return mediumHamburger; }).then(d => d.default),
  'medium-home': () => Promise.resolve().then(function () { return mediumHome; }).then(d => d.default),
  'medium-image-camera': () => Promise.resolve().then(function () { return mediumImageCamera; }).then(d => d.default),
  'medium-input-text-field': () => Promise.resolve().then(function () { return mediumInputTextField; }).then(d => d.default),
  'medium-interface-link': () => Promise.resolve().then(function () { return mediumInterfaceLink; }).then(d => d.default),
  'medium-layout-column-left-hide': () => Promise.resolve().then(function () { return mediumLayoutColumnLeftHide; }).then(d => d.default),
  'medium-layout-column-right-hide': () => Promise.resolve().then(function () { return mediumLayoutColumnRightHide; }).then(d => d.default),
  'medium-mail-envelope': () => Promise.resolve().then(function () { return mediumMailEnvelope; }).then(d => d.default),
  'medium-money-calculator': () => Promise.resolve().then(function () { return mediumMoneyCalculator; }).then(d => d.default),
  'medium-money-coins': () => Promise.resolve().then(function () { return mediumMoneyCoins; }).then(d => d.default),
  'medium-money-graph-bar-increase-square': () => Promise.resolve().then(function () { return mediumMoneyGraphBarIncreaseSquare; }).then(d => d.default),
  'medium-money-graph-bar': () => Promise.resolve().then(function () { return mediumMoneyGraphBar; }).then(d => d.default),
  'medium-more-menu-horizontal': () => Promise.resolve().then(function () { return mediumMoreMenuHorizontal; }).then(d => d.default),
  'medium-more-menu-vertical': () => Promise.resolve().then(function () { return mediumMoreMenuVertical; }).then(d => d.default),
  'medium-network-cluster': () => Promise.resolve().then(function () { return mediumNetworkCluster; }).then(d => d.default),
  'medium-remove-1': () => Promise.resolve().then(function () { return mediumRemove1; }).then(d => d.default),
  'medium-setting-cog': () => Promise.resolve().then(function () { return mediumSettingCog; }).then(d => d.default),
  'medium-setting-slider-horizontal-square': () => Promise.resolve().then(function () { return mediumSettingSliderHorizontalSquare; }).then(d => d.default),
  'medium-setting-slider': () => Promise.resolve().then(function () { return mediumSettingSlider; }).then(d => d.default),
  'medium-upload-1': () => Promise.resolve().then(function () { return mediumUpload1; }).then(d => d.default),
  'medium-user-block': () => Promise.resolve().then(function () { return mediumUserBlock; }).then(d => d.default),
  'medium-user-delete': () => Promise.resolve().then(function () { return mediumUserDelete; }).then(d => d.default),
  'medium-user-multiple': () => Promise.resolve().then(function () { return mediumUserMultiple; }).then(d => d.default),
  'medium-user-profile-focus': () => Promise.resolve().then(function () { return mediumUserProfileFocus; }).then(d => d.default),
  'medium-user-single': () => Promise.resolve().then(function () { return mediumUserSingle; }).then(d => d.default),
  'medium-warning-triangle': () => Promise.resolve().then(function () { return mediumWarningTriangle; }).then(d => d.default),
  'large-ai-spark-document': () => Promise.resolve().then(function () { return largeAiSparkDocument; }).then(d => d.default),
  'large-browser-notification': () => Promise.resolve().then(function () { return largeBrowserNotification; }).then(d => d.default),
  'large-common-file-text-check': () => Promise.resolve().then(function () { return largeCommonFileTextCheck; }).then(d => d.default),
  'large-file-search': () => Promise.resolve().then(function () { return largeFileSearch; }).then(d => d.default),
  'large-file-settings': () => Promise.resolve().then(function () { return largeFileSettings; }).then(d => d.default),
  'large-file-text-search': () => Promise.resolve().then(function () { return largeFileTextSearch; }).then(d => d.default),
  'large-file-text-warning': () => Promise.resolve().then(function () { return largeFileTextWarning; }).then(d => d.default),
  'large-file-upload': () => Promise.resolve().then(function () { return largeFileUpload; }).then(d => d.default),
  'large-folder-check': () => Promise.resolve().then(function () { return largeFolderCheck; }).then(d => d.default),
  'large-folder-open-1': () => Promise.resolve().then(function () { return largeFolderOpen1; }).then(d => d.default),
  'large-graph-2': () => Promise.resolve().then(function () { return largeGraph2; }).then(d => d.default),
  'large-graph-stats-descend': () => Promise.resolve().then(function () { return largeGraphStatsDescend; }).then(d => d.default),
  'large-link-broken': () => Promise.resolve().then(function () { return largeLinkBroken; }).then(d => d.default),
  'large-lock': () => Promise.resolve().then(function () { return largeLock; }).then(d => d.default),
  'large-password-key': () => Promise.resolve().then(function () { return largePasswordKey; }).then(d => d.default),
  'large-touch-id-user': () => Promise.resolve().then(function () { return largeTouchIdUser; }).then(d => d.default),
  'large-user-multiple': () => Promise.resolve().then(function () { return largeUserMultiple; }).then(d => d.default)
};

//
var script$x = {
  name: 'IIcon',
  props: {
    symbol: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value);
      }
    },
    colour: {
      type: String,
      default: 'black'
    },
    size: {
      type: Number,
      default: 24
    },
    strokeWidth: {
      type: Number,
      default: 1.5
    }
  },
  computed: {
    iconStyle() {
      return `color: ${this.colour}; width: ${this.size}px; height: ${this.size}px; stroke-width: ${this.strokeWidth};`;
    },
    iconComponent() {
      return icons[this.symbol];
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$34 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.iconComponent, {
    tag: "component",
    staticClass: "i-icon",
    style: _vm.iconStyle,
    attrs: {
      "role": "presentation"
    }
  });
};
var __vue_staticRenderFns__$34 = [];

/* style */
const __vue_inject_styles__$34 = function (inject) {
  if (!inject) return;
  inject("data-v-1281e022_0", {
    source: ".i-icon[data-v-1281e022]{display:block;stroke:currentColor!important}.i-icon[data-v-1281e022]  .fill-override{fill:currentColor!important;stroke:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$34 = "data-v-1281e022";
/* module identifier */
const __vue_module_identifier__$34 = undefined;
/* functional template */
const __vue_is_functional_template__$34 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$34 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$34,
  staticRenderFns: __vue_staticRenderFns__$34
}, __vue_inject_styles__$34, __vue_script__$x, __vue_scope_id__$34, __vue_is_functional_template__$34, __vue_module_identifier__$34, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$w = {
  name: 'ISpinner',
  props: {
    size: {
      type: String,
      default: 'md'
    },
    width: {
      type: Number,
      default: 2.5
    },
    type: {
      type: String,
      default: 'primary'
    },
    subtype: {
      type: String,
      default: undefined
    },
    transparentBgRing: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    spinnerSize() {
      let spinnerSize;
      switch (this.size) {
        case 'xs':
          spinnerSize = 12;
          break;
        case 'sm':
          spinnerSize = 16;
          break;
        case 'md':
          spinnerSize = 24;
          break;
        case 'lg':
          spinnerSize = 32;
          break;
        case 'xl':
          spinnerSize = 40;
          break;
        default:
          spinnerSize = 24;
      }
      return spinnerSize;
    }
  },
  methods: {
    ringClass(type) {
      const fgRing = () => {
        if (this.subtype === 'strong') {
          return 'i-text-neutral-default';
        } else {
          return `i-text-${this.type}-100`;
        }
      };
      const bgRing = () => {
        if (this.transparentBgRing) {
          return 'transparent-color';
        } else if (this.subtype === 'strong') {
          return `i-text-${this.type}-80`;
        } else if (this.subtype === 'subtle' || this.subtype === 'outline') {
          return `i-text-${this.type}-60`;
        } else {
          return 'i-text-neutral-40';
        }
      };
      return type === 'fg' ? fgRing() : bgRing();
    }
  }
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$33 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-spinner",
    class: {
      dark: _vm.dark
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('div', {
    staticClass: "spinning-animation"
  }, [_c('svg', {
    attrs: {
      "width": _vm.spinnerSize,
      "height": _vm.spinnerSize,
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "bg-ring",
    class: [_vm.ringClass('bg'), _vm.dark ? 'dark' : ''],
    attrs: {
      "d": "M23 12C23 13.4445 22.7155 14.8749 22.1627 16.2095C21.6099 17.5441 20.7996 18.7567 19.7782 19.7782C18.7567 20.7996 17.5441 21.6099 16.2095 22.1627C14.8749 22.7155 13.4445 23 12 23C10.5555 23 9.12506 22.7155 7.79048 22.1627C6.4559 21.6099 5.24327 20.7996 4.22182 19.7782C3.20038 18.7567 2.39013 17.5441 1.83732 16.2095C1.28452 14.8749 1 13.4445 1 12C1 10.5555 1.28452 9.12506 1.83733 7.79048C2.39013 6.4559 3.20038 5.24327 4.22183 4.22182C5.24327 3.20038 6.4559 2.39013 7.79048 1.83732C9.12507 1.28452 10.5555 1 12 1C13.4445 1 14.8749 1.28452 16.2095 1.83733C17.5441 2.39013 18.7567 3.20038 19.7782 4.22183C20.7996 5.24327 21.6099 6.4559 22.1627 7.79048C22.7155 9.12507 23 10.5555 23 12L23 12Z",
      "stroke-width": _vm.width,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fg-ring",
    class: [_vm.ringClass('fg'), _vm.dark ? 'dark' : ''],
    attrs: {
      "d": "M23 12C23 14.1756 22.3549 16.3023 21.1462 18.1113C19.9375 19.9202 18.2195 21.3301 16.2095 22.1627C14.1995 22.9952 11.9878 23.2131 9.85401 22.7886C7.72022 22.3642 5.7602 21.3166 4.22183 19.7782C2.68345 18.2398 1.6358 16.2798 1.21136 14.146C0.786924 12.0122 1.00476 9.80047 1.83733 7.79048C2.66989 5.78049 4.07979 4.06253 5.88873 2.85383C7.69767 1.64514 9.82441 1 12 1",
      "stroke-width": _vm.width,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Loading")])])]);
};
var __vue_staticRenderFns__$33 = [];

/* style */
const __vue_inject_styles__$33 = function (inject) {
  if (!inject) return;
  inject("data-v-23ca2a9a_0", {
    source: ".i-spinner[data-v-23ca2a9a]{padding:5px;display:flex;align-items:center;justify-content:center;transform:rotate(-45deg)}.i-spinner .spinning-animation[data-v-23ca2a9a]{display:flex;transform-origin:center;animation:spinning-data-v-23ca2a9a .8s infinite ease-in-out}.i-spinner .text[data-v-23ca2a9a]{clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px}.i-spinner.dark .bg-ring[data-v-23ca2a9a],.i-spinner.dark .fg-ring[data-v-23ca2a9a]{stroke:currentColor}.i-spinner svg[data-v-23ca2a9a]{overflow:visible}.i-spinner svg .bg-ring[data-v-23ca2a9a],.i-spinner svg .fg-ring[data-v-23ca2a9a]{stroke:currentColor}.i-spinner .transparent-color[data-v-23ca2a9a]{color:transparent}@keyframes spinning-data-v-23ca2a9a{100%{transform:rotate(360deg)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$33 = "data-v-23ca2a9a";
/* module identifier */
const __vue_module_identifier__$33 = undefined;
/* functional template */
const __vue_is_functional_template__$33 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$33 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$33,
  staticRenderFns: __vue_staticRenderFns__$33
}, __vue_inject_styles__$33, __vue_script__$w, __vue_scope_id__$33, __vue_is_functional_template__$33, __vue_module_identifier__$33, false, createInjector, undefined, undefined);

//
var script$v = {
  name: 'IButton',
  // vue component name,
  components: {
    iIcon: __vue_component__$34,
    iSpinner: __vue_component__$33
  },
  props: {
    mode: {
      type: String,
      default: 'light'
    },
    text: {
      type: String,
      default: 'Submit'
    },
    type: {
      type: String,
      default: 'primary'
    },
    subtype: {
      type: String,
      default: 'strong'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    loading: {
      type: Boolean,
      default: false
    },
    // icon related, all optional with no defaults
    icon: {
      type: Boolean,
      default: false
    },
    iconSymbol: {
      type: String,
      default: undefined
    },
    iconTrailing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizes() {
      let spinner, icon;
      switch (this.size) {
        case 'xs':
          spinner = 'xs';
          icon = 16;
          break;
        case 'sm':
          spinner = 'sm';
          icon = 16;
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          spinner = 'md';
          icon = 20;
          break;
      }
      return {
        spinner,
        icon
      };
    }
  },
  methods: {
    onClick() {
      if (!this.loading) {
        this.$emit('button-click');
      }
    }
  }
};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$32 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('button', {
    staticClass: "i-button",
    class: [_vm.type, _vm.subtype, _vm.size, _vm.mode, _vm.icon && _vm.iconTrailing ? 'trailing' : ''],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm.icon ? _c('i-icon', {
    class: {
      loading: _vm.loading
    },
    attrs: {
      "symbol": _vm.iconSymbol,
      "size": _vm.sizes.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm.loading ? _c('div', {
    staticClass: "loader-container"
  }, [_c('i-spinner', {
    attrs: {
      "size": _vm.sizes.spinner,
      "type": _vm.type,
      "subtype": _vm.subtype,
      "width": 2.5
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "button-text",
    class: {
      loading: _vm.loading
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")])], 1);
};
var __vue_staticRenderFns__$32 = [];

/* style */
const __vue_inject_styles__$32 = undefined;
/* scoped */
const __vue_scope_id__$32 = "data-v-13117474";
/* module identifier */
const __vue_module_identifier__$32 = undefined;
/* functional template */
const __vue_is_functional_template__$32 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$32 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$32,
  staticRenderFns: __vue_staticRenderFns__$32
}, __vue_inject_styles__$32, __vue_script__$v, __vue_scope_id__$32, __vue_is_functional_template__$32, __vue_module_identifier__$32, false, undefined, undefined, undefined);

//
var script$u = {
  name: 'IIconButton',
  components: {
    IIcon: __vue_component__$34
  },
  props: {
    type: {
      type: String,
      default: 'transparent'
    },
    mode: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: 'md'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      required: true
    },
    symbolStroke: {
      type: Number,
      default: 2
    },
    tooltipContainer: {
      type: String,
      default: 'body'
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
      validator: function (value) {
        return ['top', 'bottom', 'left', 'right'].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      tooltipTarget: `tooltip-${this.type}-${this.size}-${Math.floor(Math.random() * 1000) + 1}`,
      tooltipDelay: {
        show: 400,
        hide: 0
      }
    };
  },
  computed: {
    iconSize() {
      return {
        xxs: 10,
        xs: 12,
        sm: 16,
        md: 20,
        lg: 20,
        xl: 20
      }[this.size];
    }
  },
  methods: {
    onClick(evt) {
      evt.stopPropagation();
      this.$emit('button-click', evt);
      this.$root.$emit('bv::hide::tooltip');
    }
  }
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$31 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-icon-button-wrapper"
  }, [_c('button', {
    staticClass: "i-icon-button",
    class: [_vm.size, "type-" + _vm.type, _vm.mode, _vm.disabled ? 'disabled' : ''],
    attrs: {
      "id": _vm.tooltipTarget,
      "aria-label": _vm.tooltip,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": _vm.symbol,
      "size": _vm.iconSize,
      "stroke-width": _vm.symbolStroke
    }
  })], 1), _vm._v(" "), _vm.tooltip ? _c('b-tooltip', {
    attrs: {
      "target": _vm.tooltipTarget,
      "delay": _vm.tooltipDelay,
      "container": _vm.tooltipContainer,
      "placement": _vm.tooltipPlacement,
      "triggers": "hover"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.tooltip) + "\n  ")]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$31 = [];

/* style */
const __vue_inject_styles__$31 = undefined;
/* scoped */
const __vue_scope_id__$31 = undefined;
/* module identifier */
const __vue_module_identifier__$31 = undefined;
/* functional template */
const __vue_is_functional_template__$31 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$31 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$31,
  staticRenderFns: __vue_staticRenderFns__$31
}, __vue_inject_styles__$31, __vue_script__$u, __vue_scope_id__$31, __vue_is_functional_template__$31, __vue_module_identifier__$31, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//

const iButtonsGroupTypes = {
  CLEAR: 'clear',
  OUTLINE: 'outline',
  SOLID: 'solid'
};
var script$t = {
  name: 'iButtonsGroup',
  components: {},
  props: {
    type: {
      type: String,
      default: iButtonsGroupTypes.OUTLINE
    }
  },
  data() {
    return {
      iButtonsGroupTypes
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$30 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-buttons-group d-flex flex-row",
    class: {
      clear: _vm.type === _vm.iButtonsGroupTypes.CLEAR,
      outline: _vm.type === _vm.iButtonsGroupTypes.OUTLINE,
      solid: _vm.type === _vm.iButtonsGroupTypes.SOLID
    }
  }, [_vm._t("buttons")], 2);
};
var __vue_staticRenderFns__$30 = [];

/* style */
const __vue_inject_styles__$30 = undefined;
/* scoped */
const __vue_scope_id__$30 = undefined;
/* module identifier */
const __vue_module_identifier__$30 = undefined;
/* functional template */
const __vue_is_functional_template__$30 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$30 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$30,
  staticRenderFns: __vue_staticRenderFns__$30
}, __vue_inject_styles__$30, __vue_script__$t, __vue_scope_id__$30, __vue_is_functional_template__$30, __vue_module_identifier__$30, false, undefined, undefined, undefined);

//
var script$s = {
  name: 'IAlertIcon',
  // vue component name,
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    type: {
      type: String,
      default: 'success'
    },
    size: {
      type: String,
      default: 'md'
    },
    colour: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    icon() {
      const mediumIcon = this.type === 'success' ? 'medium-check' : 'medium-delete';
      let size, symbol;
      switch (this.size) {
        case 'sm':
        case 'md':
          size = 16;
          symbol = this.type === 'success' ? 'small-check' : 'small-delete';
          break;
        case 'lg':
          size = 20;
          symbol = mediumIcon;
          break;
        case 'xl':
        case 'xxl':
          size = 24;
          symbol = mediumIcon;
          break;
        default:
          size = 16;
          symbol = 'small-check';
      }
      return {
        size,
        symbol
      };
    }
  }
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$2$ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-alert-icon",
    class: [_vm.type, _vm.size, _vm.colour]
  }, [_c('i-icon', {
    attrs: {
      "symbol": _vm.icon.symbol,
      "size": _vm.icon.size
    }
  })], 1);
};
var __vue_staticRenderFns__$2$ = [];

/* style */
const __vue_inject_styles__$2$ = undefined;
/* scoped */
const __vue_scope_id__$2$ = "data-v-b9cad58c";
/* module identifier */
const __vue_module_identifier__$2$ = undefined;
/* functional template */
const __vue_is_functional_template__$2$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2$,
  staticRenderFns: __vue_staticRenderFns__$2$
}, __vue_inject_styles__$2$, __vue_script__$s, __vue_scope_id__$2$, __vue_is_functional_template__$2$, __vue_module_identifier__$2$, false, undefined, undefined, undefined);

/**
	!! AUTOGENERATED DO NOT EDIT !!
	by tools/scss-to-js-generator script 
*/
var palette = {
  'light-neutral-default': '#fff',
  'dark-neutral-default': '#000000',
  'logo-rich-black': '#101e2e',
  'light-neutral-10': '#fbfcfd',
  'light-neutral-20': '#f8f9fa',
  'light-neutral-30': '#f1f3f5',
  'light-neutral-40': '#eceef0',
  'light-neutral-50': '#e6e8eb',
  'light-neutral-60': '#dfe3e6',
  'light-neutral-70': '#d7dbdf',
  'light-neutral-80': '#c1c8cd',
  'light-neutral-90': '#889096',
  'light-neutral-100': '#7e868c',
  'light-neutral-110': '#687076',
  'light-neutral-120': '#11181c',
  'light-primary-10': '#fbfdff',
  'light-primary-20': '#f5faff',
  'light-primary-30': '#edf6ff',
  'light-primary-40': '#e1f0ff',
  'light-primary-50': '#cee7fe',
  'light-primary-60': '#b7d9f8',
  'light-primary-70': '#96c7f2',
  'light-primary-80': '#5eb0ef',
  'light-primary-90': '#0091ff',
  'light-primary-100': '#0081f1',
  'light-primary-110': '#006adc',
  'light-primary-120': '#00254d',
  'light-error-10': '#fffcfc',
  'light-error-20': '#fff8f8',
  'light-error-30': '#ffefef',
  'light-error-40': '#ffe5e5',
  'light-error-50': '#fdd8d8',
  'light-error-60': '#f9c6c6',
  'light-error-70': '#f3aeaf',
  'light-error-80': '#eb9091',
  'light-error-90': '#e5484d',
  'light-error-100': '#dc3d43',
  'light-error-110': '#cd2b31',
  'light-error-120': '#381316',
  'light-warning-10': '#fefcfb',
  'light-warning-20': '#fef8f4',
  'light-warning-30': '#fff1e7',
  'light-warning-40': '#ffe8d7',
  'light-warning-50': '#ffdcc3',
  'light-warning-60': '#ffcca7',
  'light-warning-70': '#ffb381',
  'light-warning-80': '#fa934e',
  'light-warning-90': '#f76808',
  'light-warning-100': '#ed5f00',
  'light-warning-110': '#bd4b00',
  'light-warning-120': '#451e11',
  'light-success-10': '#fbfefc',
  'light-success-20': '#f2fcf5',
  'light-success-30': '#e9f9ee',
  'light-success-40': '#ddf3e4',
  'light-success-50': '#ccebd7',
  'light-success-60': '#b4dfc4',
  'light-success-70': '#92ceac',
  'light-success-80': '#5bb98c',
  'light-success-90': '#30a46c',
  'light-success-100': '#299764',
  'light-success-110': '#18794e',
  'light-success-120': '#153226',
  'light-yellow-30': '#fffbd1',
  'light-yellow-40': '#fff8bb',
  'light-yellow-60': '#f9e68c',
  'light-yellow-80': '#ebbc00',
  'light-yellow-90': '#f5d90a',
  'light-yellow-110': '#946800',
  'light-yellow-120': '#35290f',
  'light-mint-30': '#e1fbf4',
  'light-mint-40': '#d2f7ed',
  'light-mint-60': '#a5e4d4',
  'light-mint-80': '#40c4aa',
  'light-mint-90': '#70e1c8',
  'light-mint-110': '#147d6f',
  'light-mint-120': '#09342e',
  'light-plum-30': '#fceffc',
  'light-plum-40': '#f9e5f9',
  'light-plum-60': '#ebc8ed',
  'light-plum-80': '#cf91d8',
  'light-plum-90': '#ab4aba',
  'light-plum-110': '#9c2bad',
  'light-plum-120': '#340c3b',
  'light-grass-30': '#ebf9eb',
  'light-grass-40': '#dff3df',
  'light-grass-60': '#b7dfba',
  'light-grass-80': '#65ba75',
  'light-grass-90': '#46a758',
  'light-grass-110': '#297c3b',
  'light-grass-120': '#1b311e',
  'light-brown-30': '#f8f1ea',
  'light-brown-40': '#f4e9dd',
  'light-brown-60': '#e8cdb5',
  'light-brown-80': '#d09e72',
  'light-brown-90': '#ad7f58',
  'light-brown-110': '#886349',
  'light-brown-120': '#3f2c22',
  'light-orange-30': '#fff1e7',
  'light-orange-40': '#ffe8d7',
  'light-orange-60': '#ffcca7',
  'light-orange-80': '#fa934e',
  'light-orange-90': '#f76808',
  'light-orange-110': '#bd4b00',
  'light-orange-120': '#451e11',
  'dark-neutral-10': '#151718',
  'dark-neutral-20': '#1a1d1e',
  'dark-neutral-30': '#202425',
  'dark-neutral-40': '#26292b',
  'dark-neutral-50': '#2b2f31',
  'dark-neutral-60': '#313538',
  'dark-neutral-70': '#3a3f42',
  'dark-neutral-80': '#4c5155',
  'dark-neutral-90': '#697177',
  'dark-neutral-100': '#787f85',
  'dark-neutral-110': '#9ba1a6',
  'dark-neutral-120': '#ecedee',
  'dark-primary-10': '#0f1720',
  'dark-primary-20': '#0f1b2d',
  'dark-primary-30': '#10243e',
  'dark-primary-40': '#102a4c',
  'dark-primary-50': '#0f3058',
  'dark-primary-60': '#0d3868',
  'dark-primary-70': '#0a4481',
  'dark-primary-80': '#0954a5',
  'dark-primary-90': '#0091ff',
  'dark-primary-100': '#369eff',
  'dark-primary-110': '#52a9ff',
  'dark-primary-120': '#eaf6ff',
  'dark-error-10': '#1f1315',
  'dark-error-20': '#291415',
  'dark-error-30': '#3c181a',
  'dark-error-40': '#481a1d',
  'dark-error-50': '#541b1f',
  'dark-error-60': '#671e22',
  'dark-error-70': '#822025',
  'dark-error-80': '#aa2429',
  'dark-error-90': '#e5484d',
  'dark-error-100': '#f2555a',
  'dark-error-110': '#ff6369',
  'dark-error-120': '#feecee',
  'dark-warning-10': '#1f1206',
  'dark-warning-20': '#2b1400',
  'dark-warning-30': '#391a03',
  'dark-warning-40': '#441f04',
  'dark-warning-50': '#4f2305',
  'dark-warning-60': '#5f2a06',
  'dark-warning-70': '#763205',
  'dark-warning-80': '#943e00',
  'dark-warning-90': '#f76808',
  'dark-warning-100': '#ff802b',
  'dark-warning-110': '#ff8b3e',
  'dark-warning-120': '#feeadd',
  'dark-success-10': '#0d1912',
  'dark-success-20': '#0c1f17',
  'dark-success-30': '#0f291e',
  'dark-success-40': '#113123',
  'dark-success-50': '#133929',
  'dark-success-60': '#164430',
  'dark-success-70': '#1b543a',
  'dark-success-80': '#236e4a',
  'dark-success-90': '#30a46c',
  'dark-success-100': '#3cb179',
  'dark-success-110': '#4cc38a',
  'dark-success-120': '#e5fbeb'
};

//
const iFeaturedIconSizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: '2xl',
  XXXL: '3xl'
};
const iFeaturedIconTypes = {
  PRIMARY: 'primary',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  NEUTRAL: 'neutral',
  OUTLINE: 'outline',
  WHITE: 'white'
};
var script$r = {
  name: 'iFeaturedIcon',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    symbol: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: iFeaturedIconTypes.PRIMARY
    },
    size: {
      type: String,
      default: iFeaturedIconSizes.MD
    }
  },
  computed: {
    iconSize() {
      const map = {};
      map[iFeaturedIconSizes.SM] = 16;
      map[iFeaturedIconSizes.MD] = 16;
      map[iFeaturedIconSizes.LG] = 20;
      map[iFeaturedIconSizes.XL] = 20;
      map[iFeaturedIconSizes.XXL] = 24;
      map[iFeaturedIconSizes.XXXL] = 40;
      return map[this.size];
    },
    iconColour() {
      return [iFeaturedIconTypes.OUTLINE, iFeaturedIconTypes.WHITE].includes(this.type) ? palette[`light-neutral-120`] : palette[`light-${this.type}-110`];
    },
    iconStyle() {
      let background = palette[`light-${this.type}-30`];
      let borderColor = background;
      if ([iFeaturedIconTypes.OUTLINE, iFeaturedIconTypes.WHITE].includes(this.type)) {
        background = palette[`light-neutral-default`];
        borderColor = this.type === iFeaturedIconTypes.OUTLINE ? palette[`light-neutral-60`] : palette[`light-neutral-default`];
      }
      const map = {};
      map[iFeaturedIconSizes.SM] = 36;
      map[iFeaturedIconSizes.MD] = 40;
      map[iFeaturedIconSizes.LG] = 44;
      map[iFeaturedIconSizes.XL] = 48;
      map[iFeaturedIconSizes.XXL] = 56;
      map[iFeaturedIconSizes.XXXL] = 104;
      let size = map[this.size];
      return `width: ${size}px; height: ${size}px; background: ${background}; border: 1px solid ${borderColor};`;
    }
  }
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$2_ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-featured-icon",
    style: _vm.iconStyle
  }, [_c('i-icon', {
    staticClass: "icon",
    attrs: {
      "symbol": _vm.symbol,
      "size": _vm.iconSize,
      "colour": _vm.iconColour
    }
  })], 1);
};
var __vue_staticRenderFns__$2_ = [];

/* style */
const __vue_inject_styles__$2_ = undefined;
/* scoped */
const __vue_scope_id__$2_ = undefined;
/* module identifier */
const __vue_module_identifier__$2_ = undefined;
/* functional template */
const __vue_is_functional_template__$2_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2_,
  staticRenderFns: __vue_staticRenderFns__$2_
}, __vue_inject_styles__$2_, __vue_script__$r, __vue_scope_id__$2_, __vue_is_functional_template__$2_, __vue_module_identifier__$2_, false, undefined, undefined, undefined);

//
var script$q = {
  name: 'ICopyInput',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    elementId: {
      type: String,
      required: true,
      default: 'copy-text-input'
    },
    value: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    container: {
      type: String,
      default: 'body'
    }
  },
  data() {
    return {
      visible: this.type !== 'password'
    };
  },
  methods: {
    toggleVisibility() {
      this.visible = !this.visible;
    },
    toolTipHideDelay() {
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', 'copy-text-button');
      }, 1000);
    },
    copyInputValue(value) {
      navigator.clipboard.writeText(value).then(() => {
        /* clipboard successfully set */
        this.toolTipHideDelay();
      }, () => {
        /* clipboard write failed */
        this.toolTipHideDelay();
      });
    },
    highlightText() {
      this.$refs[this.elementId].select();
    }
  }
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$2Z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-form-input-group"
  }, [_vm.type === 'password' ? _c('button', {
    staticClass: "input-action float-left secret-toggle",
    attrs: {
      "id": "display-text-button",
      "data-testid": "toggle-password-visibility"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleVisibility();
      }
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": _vm.visible ? 'small-edit-view' : 'small-edit-view-off',
      "size": 16
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    ref: _vm.elementId,
    staticClass: "i-form-input has-end-icon",
    class: {
      'has-start-icon': _vm.type === 'password',
      'password-hidden': _vm.type === 'password' && !_vm.visible
    },
    attrs: {
      "id": _vm.elementId,
      "data-testid": _vm.elementId,
      "value": _vm.value,
      "type": _vm.visible ? 'text' : 'password',
      "plaintext": ""
    },
    on: {
      "click": _vm.highlightText
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip:[container].click",
      value: 'Copied!',
      expression: "'Copied!'",
      arg: _vm.container,
      modifiers: {
        "click": true
      }
    }],
    staticClass: "input-action copy-text-button",
    attrs: {
      "id": "copy-text-button",
      "data-testid": "copy-button"
    },
    on: {
      "click": function ($event) {
        return _vm.copyInputValue(_vm.value);
      }
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": "small-edit-copy",
      "size": 16
    }
  })], 1)], 1);
};
var __vue_staticRenderFns__$2Z = [];

/* style */
const __vue_inject_styles__$2Z = function (inject) {
  if (!inject) return;
  inject("data-v-f32fbd8c_0", {
    source: ".i-form-input-group:hover .copy-text-button[data-v-f32fbd8c]{opacity:1}.i-form-input-group .copy-text-button[data-v-f32fbd8c]{opacity:0}.i-form-input-group .password-hidden[data-v-f32fbd8c]{pointer-events:none;text-overflow:clip;overflow:hidden}.i-form-input-group .input-action[data-v-f32fbd8c]{cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2Z = "data-v-f32fbd8c";
/* module identifier */
const __vue_module_identifier__$2Z = undefined;
/* functional template */
const __vue_is_functional_template__$2Z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Z,
  staticRenderFns: __vue_staticRenderFns__$2Z
}, __vue_inject_styles__$2Z, __vue_script__$q, __vue_scope_id__$2Z, __vue_is_functional_template__$2Z, __vue_module_identifier__$2Z, false, createInjector, undefined, undefined);

//
var script$p = {
  name: 'IInlineInput',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      text: null,
      timeout: null,
      focused: false
    };
  },
  computed: {
    inputWidth() {
      const inputElement = this.$refs.inputText;
      let width = this.getTextWidth(this.text, `normal 12px`);
      if (inputElement) {
        const compStyles = window.getComputedStyle(inputElement);
        width = this.getTextWidth(this.text, `${compStyles.fontStyle} ${compStyles.fontSize} ${compStyles.fontFamily}`);
      }
      return width + 8;
    }
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    }
  },
  mounted() {
    this.text = this.value;
  },
  methods: {
    highlight() {
      this.$refs.inputText.select();
    },
    blur() {
      this.focused = false;
      this.$refs.inputText.blur();
    },
    onInput(event) {
      var _event$target;
      this.text = (event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || '';
      this.$emit('input', event);
      this.debounce();
    },
    debounce() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.$emit('debounced-input');
      }, 400);
    },
    getTextWidth(text, font) {
      const canvas = this.getTextWidth.canvas || (this.getTextWidth.canvas = document.createElement('canvas'));
      const context = canvas.getContext('2d');
      let width = 100;
      if (context) {
        context.font = font;
        const metrics = context.measureText(text);
        width = metrics.width;
      }
      return width;
    }
  }
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$2Y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['i-inline-input', {
      disabled: _vm.disabled
    }],
    on: {
      "click": function ($event) {
        return _vm.highlight();
      }
    }
  }, [_c('input', {
    ref: "inputText",
    style: {
      width: _vm.inputWidth + "px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.text
    },
    on: {
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        return _vm.blur();
      },
      "input": _vm.onInput,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.blur();
      }
    }
  }), _vm._v(" "), _c('i-icon', {
    staticClass: "pencil-icon i-text-neutral-90",
    class: _vm.focused || !_vm.text ? 'focused' : '',
    attrs: {
      "symbol": "small-edit-pencil",
      "size": 12
    }
  }), _vm._v(" "), _c('span', {
    ref: "hiddenInputText",
    staticClass: "hidden-input-text"
  }, [_vm._v(_vm._s(_vm.text))])], 1);
};
var __vue_staticRenderFns__$2Y = [];

/* style */
const __vue_inject_styles__$2Y = undefined;
/* scoped */
const __vue_scope_id__$2Y = undefined;
/* module identifier */
const __vue_module_identifier__$2Y = undefined;
/* functional template */
const __vue_is_functional_template__$2Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Y,
  staticRenderFns: __vue_staticRenderFns__$2Y
}, __vue_inject_styles__$2Y, __vue_script__$p, __vue_scope_id__$2Y, __vue_is_functional_template__$2Y, __vue_module_identifier__$2Y, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$o = {
  name: 'IRadio',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    defaultValue: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  data() {
    return {
      displayOptions: []
    };
  },
  watch: {
    options() {
      this.setupOptions();
    },
    defaultValue() {
      this.setupOptions();
    }
  },
  mounted() {
    this.setupOptions();
  },
  methods: {
    setupOptions() {
      this.displayOptions = this.options.map(radio => {
        return {
          value: radio.value,
          title: radio.title,
          subtitle: radio.subtitle,
          selected: radio.value === this.defaultValue,
          disabled: this.disabled || radio.disabled
        };
      });
    },
    selectOption(event, option) {
      if (!option.disabled) {
        this.displayOptions.forEach(o => {
          o.selected = o.value === option.value;
        });
        this.$emit('option-selected', option.value);
      }
    }
  }
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$2X = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-radio-checkbox"
  }, _vm._l(_vm.displayOptions, function (option) {
    return _c('label', {
      key: option.value,
      staticClass: "option",
      class: {
        checked: option.selected,
        disabled: option.disabled
      },
      attrs: {
        "for": option.value
      },
      on: {
        "click": function ($event) {
          return _vm.selectOption($event, option);
        }
      }
    }, [_c('input', {
      staticClass: "radio-style",
      attrs: {
        "id": option.value,
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": option.selected
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_c('span', {
      staticClass: "i-text-neutral-120",
      class: {
        'i-text-subheading-2': _vm.size === 'md',
        'i-text-subheading-3': _vm.size === 'sm'
      }
    }, [_vm._v(_vm._s(option.title))]), _vm._v(" "), option.subtitle ? _c('span', {
      staticClass: "i-text-neutral-110",
      class: {
        'i-text-body-2': _vm.size === 'md',
        'i-text-body-3': _vm.size === 'sm'
      }
    }, [_vm._v(_vm._s(option.subtitle))]) : _vm._e()])]);
  }), 0);
};
var __vue_staticRenderFns__$2X = [];

/* style */
const __vue_inject_styles__$2X = undefined;
/* scoped */
const __vue_scope_id__$2X = "data-v-d8f46e58";
/* module identifier */
const __vue_module_identifier__$2X = undefined;
/* functional template */
const __vue_is_functional_template__$2X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2X,
  staticRenderFns: __vue_staticRenderFns__$2X
}, __vue_inject_styles__$2X, __vue_script__$o, __vue_scope_id__$2X, __vue_is_functional_template__$2X, __vue_module_identifier__$2X, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$n = {
  name: 'ICheckbox',
  props: {
    label: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: [String, Number, Boolean],
      default: undefined
    },
    value: {
      type: [String, Array, Number, Boolean],
      default: undefined
    },
    size: {
      type: String,
      default: 'md'
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$2W = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-checkbox d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "checkbox-style",
    attrs: {
      "id": "checkbox-" + _vm._uid,
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.inputValue,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.inputValue) > -1 : _vm.model
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.inputValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }), _vm._v(" "), _vm.label ? _c('div', {
    staticClass: "label",
    class: [_vm.size]
  }, [_c('label', {
    class: {
      'i-text-neutral-120': !_vm.disabled,
      'i-text-neutral-90': _vm.disabled,
      'i-text-subheading-2': _vm.size === 'md',
      'i-text-subheading-3': _vm.size === 'sm'
    },
    attrs: {
      "for": "checkbox-" + _vm._uid
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label))]), _vm._v(" "), _vm.description ? _c('span', {
    staticClass: "i-text-neutral-110",
    class: {
      'i-text-body-2': _vm.size === 'md',
      'i-text-body-3': _vm.size === 'sm'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]) : _vm._e()]) : _vm._e()]);
};
var __vue_staticRenderFns__$2W = [];

/* style */
const __vue_inject_styles__$2W = undefined;
/* scoped */
const __vue_scope_id__$2W = "data-v-33cb378c";
/* module identifier */
const __vue_module_identifier__$2W = undefined;
/* functional template */
const __vue_is_functional_template__$2W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2W,
  staticRenderFns: __vue_staticRenderFns__$2W
}, __vue_inject_styles__$2W, __vue_script__$n, __vue_scope_id__$2W, __vue_is_functional_template__$2W, __vue_module_identifier__$2W, false, undefined, undefined, undefined);

//
var script$m = {
  name: 'ICheckboxGroup',
  components: {
    iCheckbox: __vue_component__$2W,
    iIcon: __vue_component__$34
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Array, Number, Boolean],
      default: undefined
    },
    sortable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      optionOrder: [],
      // Store the initial order of the options
      localOptions: [] // Store the options with the selected state
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        const sortedValue = value.slice().sort((a, b) => {
          return this.optionOrder.indexOf(a) - this.optionOrder.indexOf(b);
        });
        this.$emit('input', sortedValue);
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(newVal) {
        // Update the value of selected in localOptions
        this.localOptions = this.localOptions.map(option => {
          return {
            ...option,
            selected: newVal.includes(option.value)
          };
        });
      }
    }
  },
  created() {
    // Initialize optionOrder with the order of the options
    this.optionOrder = this.options.map(option => option.value);
    // Initialize localOptions with the order of the options and the selected state
    this.localOptions = this.options.map(option => {
      return {
        ...option,
        selected: this.model.includes(option.value)
      };
    });
  },
  methods: {
    onDragStart(option) {
      // Set the data transfer payload to the selected option
      event.dataTransfer.setData('text/plain', JSON.stringify(option));
    },
    onDragOver(event) {
      // Prevent default behavior to allow dropping
      event.preventDefault();
    },
    onDrop(event, droppedOption) {
      // Retrieve the dragged option from the data transfer payload
      const draggedOption = JSON.parse(event.dataTransfer.getData('text/plain'));

      // Find the index of the dragged option in localOptions
      const draggedIndex = this.localOptions.findIndex(option => option.value === draggedOption.value);

      // Find the index of the dropped option in localOptions
      const droppedIndex = this.localOptions.findIndex(option => option.value === droppedOption.value);

      // Check if the dragged option is dropped before or after its original position
      if (draggedIndex < droppedIndex) {
        // If dropped after its original position, adjust the dropped index
        this.localOptions.splice(droppedIndex + 1, 0, draggedOption);
        this.localOptions.splice(draggedIndex, 1);
      } else if (draggedIndex > droppedIndex) {
        // If dropped before its original position, adjust the dropped index
        this.localOptions.splice(droppedIndex, 0, draggedOption);
        this.localOptions.splice(draggedIndex + 1, 1);
      }

      // Update the optionOrder array accordingly
      this.optionOrder = this.localOptions.map(option => option.value);

      // Update the model to reflect the sorted order
      this.model = this.localOptions.filter(option => this.model.includes(option.value)).map(option => option.value);
    }
  }
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$2V = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-radio-checkbox"
  }, _vm._l(_vm.localOptions, function (option) {
    return _c('div', {
      key: option.value,
      class: [{
        sortable: _vm.sortable
      }],
      attrs: {
        "draggable": _vm.sortable
      },
      on: {
        "dragstart": function ($event) {
          return _vm.onDragStart(option);
        },
        "dragover": function ($event) {
          return _vm.onDragOver($event);
        },
        "drop": function ($event) {
          return _vm.onDrop($event, option);
        }
      }
    }, [_vm.sortable ? _c('div', {
      staticClass: "drag-handle"
    }, [_c('i-icon', {
      staticClass: "i-mr-2",
      attrs: {
        "symbol": "small-drag-handle-vertical",
        "size": 16
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('i-checkbox', {
      staticClass: "option i-mb-4",
      class: {
        checked: option.selected,
        disabled: option.disabled
      },
      attrs: {
        "label": option.label,
        "description": option.description,
        "disabled": option.disabled,
        "input-value": option.value
      },
      model: {
        value: _vm.model,
        callback: function ($$v) {
          _vm.model = $$v;
        },
        expression: "model"
      }
    })], 1);
  }), 0);
};
var __vue_staticRenderFns__$2V = [];

/* style */
const __vue_inject_styles__$2V = undefined;
/* scoped */
const __vue_scope_id__$2V = undefined;
/* module identifier */
const __vue_module_identifier__$2V = undefined;
/* functional template */
const __vue_is_functional_template__$2V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2V,
  staticRenderFns: __vue_staticRenderFns__$2V
}, __vue_inject_styles__$2V, __vue_script__$m, __vue_scope_id__$2V, __vue_is_functional_template__$2V, __vue_module_identifier__$2V, false, undefined, undefined, undefined);

//
var script$l = {
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    inputId: {
      type: String,
      default: 'searchInput'
    },
    inputPlaceholder: {
      type: String,
      default: 'Search'
    },
    keyboardShortcut: {
      type: Boolean,
      default: false
    },
    debounceTime: {
      type: Number,
      default: 200
    },
    filledValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      palette,
      iconHovered: false,
      focused: false,
      textValue: '',
      debounceTimeout: null
    };
  },
  computed: {
    hasTypedText() {
      return this.textValue !== '';
    },
    shortcutText() {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      return isMac ? '⌘' : 'Ctrl+';
    }
  },
  mounted() {
    this.textValue = this.filledValue;
    if (this.keyboardShortcut) {
      document.addEventListener('keydown', event => this.handleSearchShortcut(event, this.inputId));
    }
  },
  beforeDestroy() {
    if (this.keyboardShortcut) {
      document.removeEventListener('keydown', event => this.handleSearchShortcut(event, this.inputId));
    }
  },
  methods: {
    resetText() {
      this.setValue('');
      this.focused = true;
    },
    setValue(value) {
      this.textValue = value;
      this.debounceTimeout && clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.$emit('input', this.textValue);
      }, this.debounceTime);
    },
    onInput(evt) {
      this.setValue(evt.target.value);
    },
    handleSearchShortcut(event, inputId) {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        const inputElement = document.querySelector(`#${inputId}`);
        if (inputElement) {
          inputElement.focus();
          inputElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$2U = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-search-input d-flex flex-row align-items-center i-radius-md i-p-6",
    class: {
      focused: _vm.focused
    }
  }, [_c('i-icon', {
    staticClass: "search-icon i-mr-6",
    attrs: {
      "symbol": "small-search",
      "size": 16,
      "colour": _vm.palette['light-neutral-80']
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textValue,
      expression: "textValue"
    }],
    staticClass: "i-text-subheading-3 i-text-neutral-120",
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": _vm.textValue
    },
    on: {
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        _vm.focused = false;
      },
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.textValue = $event.target.value;
      }, _vm.onInput]
    }
  }), _vm._v(" "), _vm.hasTypedText ? _c('div', {
    staticClass: "clear-icon",
    on: {
      "mouseover": function ($event) {
        _vm.iconHovered = true;
      },
      "mouseleave": function ($event) {
        _vm.iconHovered = false;
      },
      "click": function ($event) {
        return _vm.resetText();
      }
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": "small-delete-1",
      "size": 12,
      "colour": _vm.iconHovered ? _vm.palette['light-neutral-110'] : _vm.palette['light-neutral-90']
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.keyboardShortcut && !_vm.hasTypedText ? _c('div', {
    staticClass: "i-text-body-2 i-text-neutral-80"
  }, [_vm._v("\n    " + _vm._s(_vm.shortcutText) + "K\n  ")]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$2U = [];

/* style */
const __vue_inject_styles__$2U = undefined;
/* scoped */
const __vue_scope_id__$2U = undefined;
/* module identifier */
const __vue_module_identifier__$2U = undefined;
/* functional template */
const __vue_is_functional_template__$2U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2U,
  staticRenderFns: __vue_staticRenderFns__$2U
}, __vue_inject_styles__$2U, __vue_script__$l, __vue_scope_id__$2U, __vue_is_functional_template__$2U, __vue_module_identifier__$2U, false, undefined, undefined, undefined);

//
var script$k = {
  name: 'ISelect',
  components: {
    IIcon: __vue_component__$34
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select'
    },
    defaultValue: {
      type: String,
      required: false,
      default: null
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      selected: null,
      open: false,
      retries: 0,
      displayOptions: this.setupOptions()
    };
  },
  watch: {
    options() {
      this.displayOptions = this.setupOptions();
    },
    defaultValue(newVal) {
      this.selected = this.displayOptions.find(o => o.value === newVal);
    }
  },
  mounted() {
    this.selected = this.displayOptions.find(o => o.value === this.defaultValue);
  },
  methods: {
    setupOptions() {
      return this.options.map(option => {
        return {
          value: option.value,
          text: option.text,
          focused: false,
          disabled: option.disabled,
          divider: option.divider
        };
      });
    },
    focusByDirection($event, direction) {
      this.open = true;
      $event.preventDefault();
      const defaultPosition = direction === 'down' ? 0 : this.displayOptions.length - 1;
      const positionMover = direction === 'down' ? 1 : -1;
      const positionRestart = direction === 'down' ? v => v === this.displayOptions.length : v => v < 0;
      const tryAgain = () => {
        this.focusByDirection($event, direction);
      };
      const currFocus = this.displayOptions.find(o => o.focused);
      if (currFocus) {
        const newIndex = this.displayOptions.indexOf(currFocus) + positionMover;
        positionRestart(newIndex) ? this.focusByIndex(defaultPosition, tryAgain) : this.focusByIndex(newIndex, tryAgain);
      } else {
        this.focusByIndex(defaultPosition, tryAgain);
      }
    },
    focusByIndex(index, tryAgain = () => {}) {
      const optionToFocus = this.displayOptions[index];
      this.displayOptions.forEach(o => o.focused = o.value === optionToFocus.value);
      if (optionToFocus.disabled && this.retries < this.displayOptions.length) {
        this.retries += 1;
        tryAgain();
      } else {
        this.retries = 0;
      }
    },
    selectFocusedOption() {
      const focusedOption = this.displayOptions.find(o => o.focused);
      if (focusedOption) {
        this.selectOption(focusedOption);
      }
    },
    selectOption(option) {
      if (!option.disabled) {
        this.selected = option;
        this.open = false;
        this.$emit('option-selected', option.value);
      }
    }
  }
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$2T = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-select",
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.selectFocusedOption();
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
          return null;
        }
        return _vm.focusByDirection($event, 'down');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
          return null;
        }
        return _vm.focusByDirection($event, 'up');
      }]
    }
  }, [_c('div', {
    staticClass: "selected-input",
    class: {
      open: _vm.open,
      disabled: _vm.disabled
    },
    attrs: {
      "tabindex": _vm.tabindex
    },
    on: {
      "blur": function ($event) {
        _vm.open = false;
      },
      "click": function ($event) {
        _vm.open = !_vm.open;
      }
    }
  }, [_vm.selected ? _c('span', [_vm._v(" " + _vm._s(_vm.selected.text) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]), _vm._v(" "), _c('i-icon', {
    staticClass: "i-ml-sm",
    class: [_vm.open ? 'rotate-up' : 'rotate-down', _vm.disabled ? 'i-text-neutral-90' : ''],
    attrs: {
      "symbol": "small-chevron-right",
      "size": 16
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "items",
    class: {
      closed: !_vm.open
    }
  }, _vm._l(_vm.displayOptions, function (option, i) {
    return _c('div', {
      key: i,
      staticClass: "item",
      class: {
        focused: option.focused,
        disabled: option.disabled || option.divider,
        divider: option.divider
      },
      on: {
        "mouseenter": function ($event) {
          return _vm.focusByIndex(i);
        },
        "mousedown": function ($event) {
          return _vm.selectOption(option);
        }
      }
    }, [!option.divider ? _c('span', [_vm._v(_vm._s(option.text))]) : _vm._e()]);
  }), 0)]);
};
var __vue_staticRenderFns__$2T = [];

/* style */
const __vue_inject_styles__$2T = undefined;
/* scoped */
const __vue_scope_id__$2T = "data-v-2431fd46";
/* module identifier */
const __vue_module_identifier__$2T = undefined;
/* functional template */
const __vue_is_functional_template__$2T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2T,
  staticRenderFns: __vue_staticRenderFns__$2T
}, __vue_inject_styles__$2T, __vue_script__$k, __vue_scope_id__$2T, __vue_is_functional_template__$2T, __vue_module_identifier__$2T, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$j = {
  name: 'ISwitch',
  props: {
    label: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    },
    type: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    textSize() {
      switch (this.size) {
        case 'xs':
          return '3';
        case 'sm':
          return '2';
        case 'md':
        default:
          return '1';
      }
    }
  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$2S = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "i-switch",
    on: {
      "click": function (evt) {
        return evt.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "switch",
    class: [_vm.size, _vm.type]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.model,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm.model
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider"
  })]), _vm._v(" "), _vm.label ? _c('div', {
    staticClass: "label",
    class: [_vm.size]
  }, [_c('span', {
    staticClass: "i-text-neutral-120",
    class: "i-text-subheading-" + _vm.textSize
  }, [_vm._v("\n      " + _vm._s(_vm.label))]), _vm._v(" "), _vm.description ? _c('span', {
    staticClass: "i-text-neutral-110",
    class: "i-text-body-" + _vm.textSize
  }, [_vm._v("\n      " + _vm._s(_vm.description))]) : _vm._e()]) : _vm._e()]);
};
var __vue_staticRenderFns__$2S = [];

/* style */
const __vue_inject_styles__$2S = undefined;
/* scoped */
const __vue_scope_id__$2S = undefined;
/* module identifier */
const __vue_module_identifier__$2S = undefined;
/* functional template */
const __vue_is_functional_template__$2S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2S,
  staticRenderFns: __vue_staticRenderFns__$2S
}, __vue_inject_styles__$2S, __vue_script__$j, __vue_scope_id__$2S, __vue_is_functional_template__$2S, __vue_module_identifier__$2S, false, undefined, undefined, undefined);

const iTextInputSizes = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
const iTextInputModes = {
  SIMPLE: 'simple',
  TEXTAREA: 'textarea'
};
var script$i = {
  name: 'ITextInput',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: iTextInputSizes.MEDIUM
    },
    placeholder: {
      type: String,
      default: ''
    },
    debounceTime: {
      type: Number,
      default: 100
    },
    showHintText: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: null
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    mode: {
      type: String,
      default: iTextInputModes.SIMPLE
    }
  },
  data() {
    return {
      palette,
      textValue: '',
      debounceTimeout: null,
      focused: false,
      inputId: `i-text-input-${crypto.randomUUID()}`,
      iTextInputModes,
      iTextInputSizes
    };
  },
  computed: {
    showRightIcon() {
      return this.rightIcon && this.mode !== iTextInputModes.TEXTAREA;
    },
    cssVars() {
      return {
        '--background-colour': this.backgroundColour,
        '--border-colour': this.borderColour,
        '--input-colour': this.inputColour,
        '--icon-colour': this.iconColour,
        '--inner-border-colour': this.innerBorderColour,
        '--hint-text-colour': this.hintTextColour
      };
    },
    backgroundColour() {
      if (this.disabled) {
        return palette['light-neutral-20'];
      } else {
        return 'transparent';
      }
    },
    inputColour() {
      if (this.hasError) {
        return palette['light-error-120'];
      } else {
        return palette['light-neutral-120'];
      }
    },
    innerBorderColour() {
      if (this.disabled) {
        return 'transparent';
      } else if (this.hasError) {
        return palette['light-error-90'];
      } else if (this.focused) {
        return palette['light-primary-90'];
      } else {
        return 'transparent';
      }
    },
    borderColour() {
      if (this.disabled) {
        return palette['light-neutral-70'];
      } else if (this.hasError) {
        return palette['light-error-90'];
      } else if (this.focused) {
        return palette['light-primary-90'];
      } else {
        return palette['light-neutral-70'];
      }
    },
    iconColour() {
      if (this.hasError) {
        return palette['light-error-110'];
      } else {
        return palette['light-neutral-90'];
      }
    },
    hintTextColour() {
      if (this.hasError) {
        return palette['light-error-110'];
      } else {
        return palette['light-neutral-110'];
      }
    }
  },
  mounted() {
    this.textValue = this.value;
  },
  methods: {
    onClick() {
      this.setFocused();
    },
    onInput(evt) {
      this.setValue(evt.target.value);
    },
    setFocused(value = true) {
      const inputElement = this.$refs.inputElement;
      value ? inputElement.focus() : inputElement.blur();
      this.focused = value;
    },
    setValue(value) {
      this.textValue = value;
      this.debounceTimeout && clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.$emit('input', this.textValue);
      }, this.debounceTime);
    }
  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$2R = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-text-input d-flex flex-column",
    class: {
      small: _vm.size === _vm.iTextInputSizes.SMALL,
      medium: _vm.size === _vm.iTextInputSizes.MEDIUM,
      'i-gap-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-gap-4': _vm.size === _vm.iTextInputSizes.MEDIUM,
      focused: _vm.focused,
      disabled: _vm.disabled,
      textarea: _vm.mode === _vm.iTextInputModes.TEXTAREA,
      'with-icon': _vm.showRightIcon
    },
    style: _vm.cssVars,
    on: {
      "click": _vm.onClick
    }
  }, [_vm.label ? _c('label', {
    staticClass: "i-text-neutral-120",
    class: {
      'i-text-subheading-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-text-subheading-2': _vm.size === _vm.iTextInputSizes.MEDIUM
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper d-flex flex-row align-items-center i-radius-sm i-px-8 i-py-5"
  }, [_vm.type === 'checkbox' && _vm.mode === _vm.iTextInputModes.SIMPLE ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textValue,
      expression: "textValue"
    }],
    ref: "inputElement",
    staticClass: "d-flex i-radius-sm",
    class: {
      'i-text-body-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-text-body-2': _vm.size === _vm.iTextInputSizes.MEDIUM
    },
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.textValue) ? _vm._i(_vm.textValue, null) > -1 : _vm.textValue
    },
    on: {
      "focus": function ($event) {
        return _vm.setFocused(true);
      },
      "blur": function ($event) {
        return _vm.setFocused(false);
      },
      "input": _vm.onInput,
      "change": function ($event) {
        var $$a = _vm.textValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.textValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.textValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.textValue = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' && _vm.mode === _vm.iTextInputModes.SIMPLE ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textValue,
      expression: "textValue"
    }],
    ref: "inputElement",
    staticClass: "d-flex i-radius-sm",
    class: {
      'i-text-body-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-text-body-2': _vm.size === _vm.iTextInputSizes.MEDIUM
    },
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.textValue, null)
    },
    on: {
      "focus": function ($event) {
        return _vm.setFocused(true);
      },
      "blur": function ($event) {
        return _vm.setFocused(false);
      },
      "input": _vm.onInput,
      "change": function ($event) {
        _vm.textValue = null;
      }
    }
  }) : _vm.mode === _vm.iTextInputModes.SIMPLE ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textValue,
      expression: "textValue"
    }],
    ref: "inputElement",
    staticClass: "d-flex i-radius-sm",
    class: {
      'i-text-body-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-text-body-2': _vm.size === _vm.iTextInputSizes.MEDIUM
    },
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.textValue
    },
    on: {
      "focus": function ($event) {
        return _vm.setFocused(true);
      },
      "blur": function ($event) {
        return _vm.setFocused(false);
      },
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.textValue = $event.target.value;
      }, _vm.onInput]
    }
  }) : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.textValue,
      expression: "textValue"
    }],
    ref: "inputElement",
    staticClass: "d-flex i-radius-sm",
    class: {
      'i-text-body-3': _vm.size === _vm.iTextInputSizes.SMALL,
      'i-text-body-2': _vm.size === _vm.iTextInputSizes.MEDIUM
    },
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.textValue
    },
    on: {
      "focus": function ($event) {
        return _vm.setFocused(true);
      },
      "blur": function ($event) {
        return _vm.setFocused(false);
      },
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.textValue = $event.target.value;
      }, _vm.onInput]
    }
  }), _vm._v(" "), _vm.showRightIcon ? _c('i-icon', {
    attrs: {
      "symbol": _vm.rightIcon,
      "size": _vm.size === _vm.iTextInputSizes.SMALL ? 12 : 16,
      "colour": _vm.iconColour
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.showHintText ? _c('div', {
    staticClass: "hint"
  }, [_c('div', {
    staticClass: "text i-text-body-3"
  }, [_vm._v(_vm._s(_vm.hintText))])]) : _vm._e()]);
};
var __vue_staticRenderFns__$2R = [];

/* style */
const __vue_inject_styles__$2R = undefined;
/* scoped */
const __vue_scope_id__$2R = undefined;
/* module identifier */
const __vue_module_identifier__$2R = undefined;
/* functional template */
const __vue_is_functional_template__$2R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2R,
  staticRenderFns: __vue_staticRenderFns__$2R
}, __vue_inject_styles__$2R, __vue_script__$i, __vue_scope_id__$2R, __vue_is_functional_template__$2R, __vue_module_identifier__$2R, false, undefined, undefined, undefined);

const iMenuTriggerAlignOptions = {
  LEFT: 'left',
  RIGHT: 'right'
};

/**
 * position the menu below the trigger if there is enough space, otherwise below
 */
const positionMenu = (triggerBtn, menuContainer, triggerAlign) => {
  // do on next cycle to make sure I get right sizes of open menu
  setTimeout(() => {
    const triggerRect = triggerBtn.getBoundingClientRect();
    const menuContainerRect = menuContainer.getBoundingClientRect();
    const MARGIN = 6;

    // top pp
    const topIfBelow = triggerRect.bottom + MARGIN;
    const topIfAbove = triggerRect.top - MARGIN - menuContainerRect.height;
    const enoughSpaceBelow = topIfBelow + menuContainerRect.height < window.innerHeight;
    const itemsPosTop = enoughSpaceBelow ? topIfBelow : topIfAbove;
    menuContainer.style.top = `${itemsPosTop}px`;

    // left position
    const leftIfRight = triggerRect.right - menuContainerRect.width + 2;
    const leftIfLeft = triggerRect.left;
    const enoughSpaceRight = triggerAlign === iMenuTriggerAlignOptions.RIGHT || leftIfLeft + menuContainerRect.width < window.innerWidth;
    const enoughSpaceLeft = triggerAlign === iMenuTriggerAlignOptions.LEFT || leftIfRight > 0;
    let itemsPosLeft;
    if (triggerAlign === iMenuTriggerAlignOptions.LEFT) {
      itemsPosLeft = enoughSpaceRight ? leftIfLeft : leftIfRight;
    } else {
      itemsPosLeft = enoughSpaceLeft ? leftIfRight : leftIfLeft;
    }
    menuContainer.style.left = `${itemsPosLeft}px`;
  });
};

//
var script$h = {
  name: 'IFilter',
  components: {
    iButton: __vue_component__$32,
    iCheckbox: __vue_component__$2W,
    iIcon: __vue_component__$34,
    iRadio: __vue_component__$2X,
    iSearchInput: __vue_component__$2U
  },
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Filter by ${label}'
    },
    label: {
      type: String,
      default: ''
    },
    searchInputPlaceholder: {
      type: String,
      default: 'Search'
    },
    maxSelectedExtendedList: {
      type: Number,
      default: 3
    },
    showSelectedList: {
      type: Boolean,
      default: true
    },
    maxSelectable: {
      type: Number,
      default: Infinity
    },
    options: {
      type: Array,
      default: () => []
    },
    searchable: {
      type: Boolean,
      default: true
    },
    triggerAlign: {
      type: String,
      default: iMenuTriggerAlignOptions.LEFT
    },
    value: {
      type: Array,
      default: () => []
    },
    customRange: {
      type: Boolean,
      default: false
    },
    customRangeLabel: {
      type: String,
      default: undefined
    },
    showEmptyCreateButton: {
      type: Boolean,
      default: false
    },
    emptyCreateButtonLabel: {
      type: String,
      default: 'Create `${value}`'
    },
    width: {
      type: Number,
      default: 260
    },
    customTrigger: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOpen: false,
      showCustomRange: false,
      allOptions: [],
      iconHovered: false,
      palette,
      scrollRepositionTimeout: null,
      searchString: ''
    };
  },
  computed: {
    filtersApplied() {
      return !!this.allOptions.find(o => o.selected);
    },
    shouldUseCheckboxes() {
      return this.maxSelectable > 1;
    },
    iconColour() {
      if (!this.enabled) {
        return palette['light-neutral-60'];
      } else {
        return this.filtersApplied ? palette['light-neutral-90'] : palette['light-neutral-80'];
      }
    },
    selectedOptions() {
      return this.allOptions.filter(o => o.tempSelected);
    },
    selectedLimitReached() {
      return this.selectedOptions.length >= this.maxSelectable;
    },
    selectedOptionsList() {
      const selectedOptions = this.allOptions.filter(o => o.selected);
      let selectedString = selectedOptions.slice(0, this.maxSelectedExtendedList).map(o => o.range ? this.customRangeLabel : o.label).join(', ');
      return selectedOptions.length > this.maxSelectedExtendedList ? `${selectedOptions[0].label} and ${selectedOptions.length - 1} more` : selectedString;
    },
    visibleOptions() {
      return this.allOptions.filter(o => o.label.toLowerCase().includes(this.searchString.toLowerCase()) || o.selected);
    },
    radioOptions() {
      return this.allOptions.filter(o => o.label.toLowerCase().includes(this.searchString.toLowerCase())).map(o => {
        return {
          title: o.label,
          value: o.label
        };
      });
    },
    radioDefaultOption() {
      return this.selectedOptions.length ? this.selectedOptions[0].label : '';
    }
  },
  watch: {
    value: function () {
      this.reloadState();
    },
    options: function () {
      this.reloadState();
    }
  },
  mounted() {
    if (this.$refs) {
      this.menuContainer = this.$refs.optionsMenu;
      if (this.customTrigger) {
        this.triggerBtn = document.querySelector(this.customTrigger);
        this.triggerBtn && this.triggerBtn.addEventListener('click', this.toggleMenu);
      } else {
        this.triggerBtn = this.$refs.triggerButton;
      }
    }

    // initial state
    this.reloadState();
  },
  methods: {
    reloadState() {
      this.allOptions = [...this.options.map(o => {
        const selected = this.value.includes(o.label);
        this.isCustomRangeSelected(selected, o.range);
        return {
          ...o,
          selected: selected,
          tempSelected: selected
        };
      })];
    },
    resetSelection(evt) {
      if (this.enabled) {
        evt.stopPropagation();
        this.clearSelection();
        this.applySelection();
      }
    },
    clearSelection() {
      this.showCustomRange = false;
      this.allOptions.forEach(o => {
        o.tempSelected = false;
      });
    },
    onSearchInput(text) {
      this.searchString = text;
    },
    onRadioSelect(selectedValue) {
      this.allOptions.forEach(o => {
        const selected = o.label === selectedValue;
        this.isCustomRangeSelected(selected, o.range);
        o.tempSelected = selected;
      });
    },
    applySelection() {
      this.allOptions.forEach(o => {
        o.selected = o.tempSelected;
      });
      const selected = [...this.allOptions].filter(o => o.tempSelected).map(o => {
        return {
          ...o,
          selected: true
        };
      });
      this.$emit('selection-changed', {
        label: this.label,
        selection: selected
      });
      this.setMenuOpen(false);
    },
    toggleOptionSelection(evt, option) {
      if (evt.target.nodeName !== 'LABEL' && (option.tempSelected || this.selectedOptions.length < this.maxSelectable)) {
        option.tempSelected = !option.tempSelected;
      }
    },
    toggleMenu() {
      this.setMenuOpen(!this.isOpen);
    },
    setMenuOpen(value) {
      this.isOpen = value;
      if (this.isOpen && this.menuContainer) {
        positionMenu(this.triggerBtn, this.menuContainer, this.triggerAlign);
      }
      this.$emit('i-filter-open-changed', this.isOpen);
      document.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    },
    onOverlayClick(evt) {
      this.setMenuOpen(false);
      evt.stopPropagation();
    },
    isCustomRangeSelected(selectedState, isRangeOption) {
      return this.customRange && selectedState && isRangeOption ? this.showCustomRange = true : this.showCustomRange = false;
    },
    onCreateButtonClick() {
      this.$emit('create-button-clicked', this.searchString);
    }
  }
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$2Q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-filter",
    class: {
      'is-open': _vm.isOpen
    }
  }, [!_vm.customTrigger ? _c('button', {
    ref: "triggerButton",
    staticClass: "trigger-button d-flex flex-row align-items-center justify-content-center i-text-subheading-3 i-py-4 i-pl-4 i-pr-6",
    class: {
      'filters-applied': _vm.filtersApplied,
      'is-open': _vm.isOpen,
      disabled: !_vm.enabled
    },
    on: {
      "click": function ($event) {
        return _vm.toggleMenu();
      }
    }
  }, [_c('div', {
    staticClass: "left-icon-wrapper i-mr-3",
    attrs: {
      "data-testid": "reset-selection-icon"
    },
    on: {
      "mouseover": function ($event) {
        _vm.iconHovered = true;
      },
      "mouseleave": function ($event) {
        _vm.iconHovered = false;
      },
      "click": function ($event) {
        _vm.filtersApplied ? _vm.resetSelection($event) : undefined;
      }
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": _vm.filtersApplied ? 'small-delete-circle' : 'small-add-circle',
      "size": 16,
      "colour": _vm.enabled && _vm.iconHovered && _vm.filtersApplied ? _vm.palette['light-neutral-110'] : _vm.iconColour
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "label",
    class: {
      'i-text-neutral-110': _vm.enabled,
      'i-text-neutral-80': !_vm.enabled
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _vm.showSelectedList ? _c('div', {
    staticClass: "selected-options-list i-ml-2",
    class: {
      'i-text-neutral-120': _vm.enabled,
      'i-text-neutral-90': !_vm.enabled
    },
    style: {
      'max-width': _vm.width - 100 + 'px'
    },
    attrs: {
      "data-testid": "selected-options-list"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedOptionsList) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.filtersApplied ? _c('i-icon', {
    staticClass: "i-ml-3",
    attrs: {
      "symbol": "small-chevron-down",
      "size": 16,
      "colour": _vm.iconColour
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.enabled ? _c('div', {
    ref: "optionsMenu",
    staticClass: "options-menu d-flex flex-column",
    style: {
      width: _vm.width + 'px'
    }
  }, [_c('div', {
    staticClass: "title i-text-neutral-120 i-text-subheading-2 i-px-8 i-py-8"
  }, [_vm._v("\n      " + _vm._s(_vm.title.replace('${label}', _vm.label)) + "\n    ")]), _vm._v(" "), _vm.searchable ? _c('div', {
    staticClass: "search-wrapper i-px-8 i-pb-4"
  }, [_c('i-search-input', {
    attrs: {
      "data-testid": "search-input",
      "input-id": "search-input-" + _vm._uid,
      "input-placeholder": _vm.searchInputPlaceholder
    },
    on: {
      "input": _vm.onSearchInput
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.shouldUseCheckboxes ? _c('div', {
    staticClass: "options-list d-flex flex-column i-gap-1 i-px-4"
  }, _vm._l(_vm.visibleOptions, function (option) {
    return _c('div', {
      key: option.label,
      staticClass: "option-wrapper d-flex flex-row align-items-center justify-content-start i-p-4 i-radius-md",
      class: {
        disabled: !option.tempSelected && _vm.selectedLimitReached
      },
      attrs: {
        "data-testid": "option-wrapper"
      },
      on: {
        "click": function (evt) {
          return _vm.toggleOptionSelection(evt, option);
        }
      }
    }, [_c('i-checkbox', {
      staticClass: "option i-mt-8",
      attrs: {
        "value": option.tempSelected,
        "label": option.label,
        "input-value": option.label,
        "disabled": !option.tempSelected && _vm.selectedLimitReached,
        "size": "sm"
      }
    })], 1);
  }), 0) : _c('div', [_c('i-radio', {
    staticClass: "radio-container",
    attrs: {
      "size": "sm",
      "options": _vm.radioOptions,
      "default-value": _vm.radioDefaultOption
    },
    on: {
      "option-selected": _vm.onRadioSelect
    }
  })], 1), _vm._v(" "), _vm.showEmptyCreateButton && _vm.searchString !== '' ? _c('button', {
    staticClass: "create-button d-flex flex-row align-items-center i-text-subheading-3 i-text-neutral-120 i-gap-6 i-p-4 i-mx-4 i-radius-md",
    on: {
      "click": _vm.onCreateButtonClick
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": "medium-add-circle",
      "size": 16,
      "colour": _vm.palette['light-neutral-90']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.emptyCreateButtonLabel.replace('${value}', _vm.searchString)) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _vm.showCustomRange ? _c('div', {
    staticClass: "custom-range i-px-xl i-mt-3 i-mb-10"
  }, [_vm._t("custom-range")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons-container d-flex flex-row i-gap-4 i-px-8 i-py-8"
  }, [_c('i-button', {
    attrs: {
      "text": "Clear",
      "data-testid": "clear-selection-btn",
      "size": "md",
      "type": "neutral",
      "subtype": "outline"
    },
    on: {
      "button-click": function ($event) {
        return _vm.clearSelection();
      }
    }
  }), _vm._v(" "), _c('i-button', {
    attrs: {
      "text": "Apply",
      "data-testid": "apply-selection-btn",
      "size": "md",
      "type": "primary",
      "subtype": "strong"
    },
    on: {
      "button-click": function ($event) {
        return _vm.applySelection();
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-overlay",
    on: {
      "click": _vm.onOverlayClick
    }
  })]);
};
var __vue_staticRenderFns__$2Q = [];

/* style */
const __vue_inject_styles__$2Q = undefined;
/* scoped */
const __vue_scope_id__$2Q = undefined;
/* module identifier */
const __vue_module_identifier__$2Q = undefined;
/* functional template */
const __vue_is_functional_template__$2Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2Q,
  staticRenderFns: __vue_staticRenderFns__$2Q
}, __vue_inject_styles__$2Q, __vue_script__$h, __vue_scope_id__$2Q, __vue_is_functional_template__$2Q, __vue_module_identifier__$2Q, false, undefined, undefined, undefined);

//
var script$g = {
  name: 'IAmountRangeFilter',
  components: {
    iButton: __vue_component__$32,
    iIcon: __vue_component__$34
  },
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Amount'
    },
    triggerAlign: {
      type: String,
      default: iMenuTriggerAlignOptions.LEFT
    },
    amounts: {
      type: Object,
      default: () => ({
        min: null,
        max: null
      })
    },
    currency: {
      type: String,
      default: 'USD'
    },
    locale: {
      type: String,
      default: 'en-US'
    }
  },
  data() {
    return {
      isOpen: false,
      iconHovered: false,
      applied: false,
      palette,
      minAmountValue: null,
      maxAmountValue: null,
      appliedRangeLabel: ''
    };
  },
  computed: {
    iconColour() {
      if (!this.enabled) {
        return palette['light-neutral-60'];
      } else {
        return this.applied ? palette['light-neutral-90'] : palette['light-neutral-80'];
      }
    },
    isValidAmountRange() {
      if (this.minAmountValue === null || this.minAmountValue === '' || this.maxAmountValue === null || this.maxAmountValue === '') {
        return false;
      }
      return Number(this.minAmountValue) < Number(this.maxAmountValue);
    },
    setAppliedRangeLabel() {
      if (this.minAmountValue === null || this.maxAmountValue === null) {
        return '';
      }
      return `${this.toCurrency(this.minAmountValue)} - ${this.toCurrency(this.maxAmountValue)}`;
    }
  },
  watch: {
    amounts: {
      handler() {
        this.refreshState();
      },
      deep: true
    }
  },
  mounted() {
    this.refreshState();
    if (this.$refs) {
      this.triggerBtn = this.$refs.triggerButton;
      this.menuContainer = this.$refs.optionsMenu;
    }
  },
  methods: {
    refreshState() {
      this.minAmountValue = this.amounts.min;
      this.maxAmountValue = this.amounts.max;
      if (this.isValidAmountRange) {
        this.applied = true;
        this.appliedRangeLabel = this.setAppliedRangeLabel;
      } else {
        this.applied = false;
        this.appliedRangeLabel = '';
      }
    },
    resetValues(evt) {
      if (this.enabled) {
        evt.stopPropagation();
        this.clearValues();
      }
    },
    clearValues() {
      this.applied = false;
      this.minAmountValue = null;
      this.maxAmountValue = null;
      this.appliedRangeLabel = this.setAppliedRangeLabel;
      this.applyChanges();
    },
    applyChanges() {
      if (this.isValidAmountRange) {
        this.applied = true;
      }
      this.$emit('amount-changed', {
        minAmount: this.minAmountValue,
        maxAmount: this.maxAmountValue
      });
      this.appliedRangeLabel = this.setAppliedRangeLabel;
      this.setMenuOpen(false);
    },
    toggleMenu() {
      this.setMenuOpen(!this.isOpen);
    },
    setMenuOpen(value) {
      this.isOpen = value;
      if (this.isOpen && this.menuContainer) {
        positionMenu(this.triggerBtn, this.menuContainer, this.triggerAlign);
      }
      this.$emit('i-filter-open-changed', this.isOpen);
      document.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    },
    onOverlayClick(evt) {
      this.setMenuOpen(false);
      evt.stopPropagation();
    },
    toCurrency(value, fractionDigits = 0) {
      if (value === undefined) {
        return '';
      }
      if (isNaN(value)) {
        return value;
      }
      const formatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      });
      return formatter.format(value);
    }
  }
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$2P = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-filter i-amount-range-filter",
    class: {
      'is-open': _vm.isOpen
    }
  }, [_c('button', {
    ref: "triggerButton",
    staticClass: "trigger-button d-flex flex-row align-items-center justify-content-center i-text-subheading-3 i-py-4 i-pl-4 i-pr-6",
    class: {
      'filters-applied': _vm.applied,
      'is-open': _vm.isOpen,
      disabled: !_vm.enabled
    },
    on: {
      "click": function ($event) {
        return _vm.toggleMenu();
      }
    }
  }, [_c('div', {
    staticClass: "left-icon-wrapper i-mr-3",
    attrs: {
      "data-testid": "reset-filter-icon"
    },
    on: {
      "mouseover": function ($event) {
        _vm.iconHovered = true;
      },
      "mouseleave": function ($event) {
        _vm.iconHovered = false;
      },
      "click": function ($event) {
        _vm.applied ? _vm.resetValues($event) : undefined;
      }
    }
  }, [_c('i-icon', {
    attrs: {
      "symbol": _vm.applied ? 'small-delete-circle' : 'small-add-circle',
      "size": 16,
      "colour": _vm.enabled && _vm.iconHovered && _vm.applied ? _vm.palette['light-neutral-110'] : _vm.iconColour
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "label",
    class: {
      'i-text-neutral-110': _vm.enabled,
      'i-text-neutral-80': !_vm.enabled
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "i-ml-2",
    class: {
      'i-text-neutral-120': _vm.enabled,
      'i-text-neutral-90': !_vm.enabled
    }
  }, [_vm.appliedRangeLabel ? _c('span', [_vm._v("\n        " + _vm._s(_vm.appliedRangeLabel) + "\n      ")]) : _vm._e()]), _vm._v(" "), _vm.applied ? _c('i-icon', {
    staticClass: "i-ml-3",
    attrs: {
      "symbol": "small-chevron-down",
      "size": 16,
      "colour": _vm.iconColour
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.enabled ? _c('div', {
    ref: "optionsMenu",
    staticClass: "options-menu d-flex flex-column"
  }, [_c('div', {
    staticClass: "title i-text-neutral-120 i-text-subheading-2 i-px-8 i-py-8"
  }, [_vm._v("\n      Filter by " + _vm._s(_vm.label) + " (" + _vm._s(_vm.currency) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "i-amount-range-filter__min-max d-flex i-gap-4 i-px-8 align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.minAmountValue,
      expression: "minAmountValue"
    }],
    staticClass: "i-form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.minAmountValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.minAmountValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "i-text-neutral-120 i-text-body-2"
  }, [_vm._v("&")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.maxAmountValue,
      expression: "maxAmountValue"
    }],
    staticClass: "i-form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.maxAmountValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.maxAmountValue = $event.target.value;
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "buttons-container d-flex flex-row i-gap-4 i-px-8 i-py-8"
  }, [_c('i-button', {
    attrs: {
      "text": "Clear",
      "data-testid": "clear-values-button",
      "size": "md",
      "type": "neutral",
      "subtype": "outline"
    },
    on: {
      "button-click": function ($event) {
        return _vm.clearValues();
      }
    }
  }), _vm._v(" "), _c('i-button', {
    attrs: {
      "text": "Apply",
      "data-testid": "apply-values-button",
      "size": "md",
      "type": "primary",
      "subtype": "strong",
      "disabled": !_vm.isValidAmountRange
    },
    on: {
      "button-click": function ($event) {
        return _vm.applyChanges();
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-overlay",
    on: {
      "click": _vm.onOverlayClick
    }
  })]);
};
var __vue_staticRenderFns__$2P = [];

/* style */
const __vue_inject_styles__$2P = function (inject) {
  if (!inject) return;
  inject("data-v-87effc38_0", {
    source: ".i-amount-range-filter__min-max input[data-v-87effc38]{flex:1;min-width:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2P = "data-v-87effc38";
/* module identifier */
const __vue_module_identifier__$2P = undefined;
/* functional template */
const __vue_is_functional_template__$2P = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2P,
  staticRenderFns: __vue_staticRenderFns__$2P
}, __vue_inject_styles__$2P, __vue_script__$g, __vue_scope_id__$2P, __vue_is_functional_template__$2P, __vue_module_identifier__$2P, false, createInjector, undefined, undefined);

//
const iBadgeColours = {
  NEUTRAL: 'neutral',
  PRIMARY: 'primary',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success'
};
const iBadgeDotSizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};
var script$f = {
  name: 'IBadge',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    colour: {
      type: String,
      default: iBadgeColours.NEUTRAL
    },
    altTextColour: {
      type: Boolean,
      default: false
    },
    altIconColour: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    hasDot: {
      type: Boolean,
      default: false
    },
    dotSize: {
      type: String,
      default: iBadgeDotSizes.SM
    },
    hasLeadingIcon: {
      type: Boolean,
      default: false
    },
    hasTrailingIcon: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    trailingIconSize: {
      type: Number,
      default: 12
    },
    interactable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hovering: false
    };
  },
  computed: {
    _bgColour() {
      return palette[`light-${this.colour}-30`];
    },
    _bgColourHover() {
      return palette[`light-${this.colour}-40`];
    },
    bgColour() {
      return this.outline ? palette[`light-neutral-default`] : this.hovering && this.interactable ? this._bgColourHover : this._bgColour;
    },
    borderColour() {
      return this.outline ? this.hovering && this.interactable ? palette[`light-${this.colour}-80`] : palette[`light-${this.colour}-60`] : this._bgColour;
    },
    textColour() {
      return this.altTextColour ? palette[`light-${this.colour}-110`] : palette[`light-${this.colour}-120`];
    },
    _iconColour() {
      return palette[`light-${this.colour}-90`];
    },
    iconColour() {
      if (this.hovering && this.interactable) {
        return palette[`light-${this.colour}-110`];
      } else if (this.altIconColour) {
        return palette[`light-${this.colour}-120`];
      } else {
        return palette[`light-${this.colour}-90`];
      }
    },
    cssVars() {
      return {
        '--bg-colour': this.bgColour,
        '--border-colour': this.borderColour,
        '--text-colour': this.textColour,
        '--icon-colour': this.iconColour
      };
    }
  },
  methods: {
    onRightIconClick: function () {
      if (this.interactable) {
        this.$emit('right-icon-click');
      }
    }
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$2O = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-badge d-flex flex-row align-items-center",
    class: {
      'has-leading-icon': _vm.hasDot || _vm.hasLeadingIcon && _vm.icon,
      'has-trailing-icon': _vm.hasTrailingIcon && _vm.icon,
      interactable: _vm.interactable
    },
    style: _vm.cssVars,
    attrs: {
      "role": "presentation"
    },
    on: {
      "mouseenter": function ($event) {
        _vm.hovering = true;
      },
      "mouseleave": function ($event) {
        _vm.hovering = false;
      }
    }
  }, [_c('div', {
    staticClass: "left-side"
  }, [_vm.hasDot ? _c('div', {
    staticClass: "dot",
    class: _vm.dotSize
  }) : _vm.hasLeadingIcon && _vm.icon ? _c('i-icon', {
    attrs: {
      "symbol": _vm.icon,
      "size": 12,
      "colour": _vm._iconColour
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "label i-text-subheading-3"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "right-side",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onRightIconClick.apply(null, arguments);
      }
    }
  }, [_vm.hasTrailingIcon && _vm.icon ? _c('i-icon', {
    attrs: {
      "symbol": _vm.icon,
      "size": _vm.trailingIconSize,
      "colour": _vm.iconColour
    }
  }) : _vm._e()], 1)]);
};
var __vue_staticRenderFns__$2O = [];

/* style */
const __vue_inject_styles__$2O = undefined;
/* scoped */
const __vue_scope_id__$2O = undefined;
/* module identifier */
const __vue_module_identifier__$2O = undefined;
/* functional template */
const __vue_is_functional_template__$2O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2O,
  staticRenderFns: __vue_staticRenderFns__$2O
}, __vue_inject_styles__$2O, __vue_script__$f, __vue_scope_id__$2O, __vue_is_functional_template__$2O, __vue_module_identifier__$2O, false, undefined, undefined, undefined);

var script$e = {
  name: 'ISort',
  components: {
    iBadge: __vue_component__$2O
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    triggerAlign: {
      type: String,
      default: iMenuTriggerAlignOptions.LEFT
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  mounted() {
    if (this.$refs) {
      this.triggerButton = this.$refs.triggerButton;
      this.optionsMenu = this.$refs.optionsMenu;
    }
  },
  methods: {
    onSelect(value) {
      this.$emit('selection-changed', {
        selection: value
      });
      this.setMenuOpen(false);
    },
    toggleMenu() {
      this.setMenuOpen(!this.isOpen);
    },
    setMenuOpen(value) {
      this.isOpen = value;
      if (this.isOpen && this.optionsMenu) {
        positionMenu(this.triggerButton, this.optionsMenu, this.triggerAlign);
      }
      this.$emit('i-sort-open-changed', this.isOpen);
      document.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    },
    onOverlayClick(evt) {
      this.setMenuOpen(false);
      evt.stopPropagation();
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$2N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-sort",
    class: {
      'i-sort--is-open': _vm.isOpen
    }
  }, [_c('button', {
    ref: "triggerButton",
    staticClass: "i-sort__trigger-button",
    attrs: {
      "data-testid": "i-sort-trigger-button"
    },
    on: {
      "click": function ($event) {
        return _vm.toggleMenu();
      }
    }
  }, [_c('i-badge', {
    attrs: {
      "colour": "neutral",
      "label": _vm.value || 'Sort by',
      "has-trailing-icon": "",
      "icon": _vm.isOpen ? 'small-delete-2' : 'small-chevron-down',
      "interactable": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "optionsMenu",
    staticClass: "i-sort__options-menu"
  }, [_c('div', {
    staticClass: "i-text-neutral-120 i-text-subheading-2 i-px-8 i-py-8"
  }, [_vm._v("\n      Sort by\n    ")]), _vm._v(" "), _c('ul', _vm._l(_vm.options, function (option) {
    return _c('li', {
      key: option.value,
      staticClass: "i-text-body-2"
    }, [_c('button', {
      attrs: {
        "data-testid": "i-sort-menu-option"
      },
      on: {
        "click": function ($event) {
          return _vm.onSelect(option);
        }
      }
    }, [_vm._v("\n          " + _vm._s(option) + "\n        ")])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "i-sort__menu-overlay",
    attrs: {
      "data-testid": "i-sort-menu-overlay"
    },
    on: {
      "click": _vm.onOverlayClick
    }
  })]);
};
var __vue_staticRenderFns__$2N = [];

/* style */
const __vue_inject_styles__$2N = undefined;
/* scoped */
const __vue_scope_id__$2N = undefined;
/* module identifier */
const __vue_module_identifier__$2N = undefined;
/* functional template */
const __vue_is_functional_template__$2N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2N,
  staticRenderFns: __vue_staticRenderFns__$2N
}, __vue_inject_styles__$2N, __vue_script__$e, __vue_scope_id__$2N, __vue_is_functional_template__$2N, __vue_module_identifier__$2N, false, undefined, undefined, undefined);

//
var script$d = {
  name: 'IMenu',
  props: {
    closeOnItemClick: {
      type: Boolean,
      default: true
    },
    triggerAlign: {
      type: String,
      default: iMenuTriggerAlignOptions.LEFT
    },
    width: {
      type: Number,
      default: 300
    },
    triggerSelector: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      menuContainer: null,
      isOpen: false,
      itemsContainer: null,
      triggerBtn: null,
      scrollRepositionTimeout: null
    };
  },
  mounted() {
    this.menuContainer = this.$refs.container;
    this.triggerBtn = this.menuContainer.querySelector(this.triggerSelector || '.trigger-container button');
    this.itemsContainer = this.menuContainer.querySelector('.i-menu-items-container');
    if (this.triggerBtn) {
      this.triggerBtn.addEventListener('click', evt => {
        const newOpenValue = !this.isOpen;
        // close all menus
        Array.from(document.querySelectorAll('.i-menu')).forEach(m => {
          var _m$__vue__, _m$__vue__2;
          ((_m$__vue__ = m.__vue__) === null || _m$__vue__ === void 0 ? void 0 : _m$__vue__.setMenuOpen) && ((_m$__vue__2 = m.__vue__) === null || _m$__vue__2 === void 0 ? void 0 : _m$__vue__2.setMenuOpen(false));
        });
        this.setMenuOpen(newOpenValue);
        evt.stopPropagation();
      });
    }

    // add listener to all menu items to close
    if (this.closeOnItemClick) {
      this.itemsContainer.addEventListener('click', evt => {
        if (!evt.target.classList.contains('i-menu-items-container')) {
          this.setMenuOpen(false);
        }
      }, true);
    }
  },
  methods: {
    setMenuOpen(value) {
      this.isOpen = value;
      if (this.isOpen) {
        document.body.appendChild(this.itemsContainer);
        positionMenu(this.triggerBtn, this.itemsContainer, this.triggerAlign);
      } else {
        this.$el.appendChild(this.itemsContainer);
      }
      this.$emit('i-menu-open-changed', this.isOpen);
      document.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    },
    onOverlayClick(evt) {
      this.setMenuOpen(false);
      evt.stopPropagation();
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$2M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "container",
    staticClass: "i-menu",
    class: {
      'is-open': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "trigger-container"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('div', {
    staticClass: "i-menu-items-container i-pt-6 i-pl-6 i-pb-6 i-pr-6",
    class: {
      'is-open': _vm.isOpen
    },
    style: {
      width: _vm.width + 'px'
    }
  }, [_vm._t("items")], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-overlay",
    on: {
      "click": _vm.onOverlayClick
    }
  })]);
};
var __vue_staticRenderFns__$2M = [];

/* style */
const __vue_inject_styles__$2M = undefined;
/* scoped */
const __vue_scope_id__$2M = undefined;
/* module identifier */
const __vue_module_identifier__$2M = undefined;
/* functional template */
const __vue_is_functional_template__$2M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2M,
  staticRenderFns: __vue_staticRenderFns__$2M
}, __vue_inject_styles__$2M, __vue_script__$d, __vue_scope_id__$2M, __vue_is_functional_template__$2M, __vue_module_identifier__$2M, false, undefined, undefined, undefined);

//
var script$c = {
  name: 'IMenuItem',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    checkedColor: {
      type: String,
      default: palette['light-neutral-110']
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: palette['light-neutral-110']
    },
    rightIcon: {
      type: String,
      default: null
    },
    rightIconColor: {
      type: String,
      default: palette['light-neutral-110']
    },
    label: {
      type: String,
      default: ''
    },
    linkExternalUrl: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: palette['light-neutral-120']
    }
  },
  data() {
    return {
      palette
    };
  },
  computed: {
    computedIconColor() {
      return this.disabled ? palette['light-neutral-90'] : this.iconColor;
    },
    checkedIconColor() {
      return this.disabled ? palette['light-neutral-80'] : this.checkedColor;
    }
  },
  watch: {
    textColor: function () {
      this.updateColors();
    },
    disabled: function () {
      this.updateColors();
    }
  },
  mounted() {
    this.updateColors();
  },
  methods: {
    onItemClick: function (evt) {
      if (this.linkExternalUrl) {
        window.open(this.linkExternalUrl, '_blank', 'noopener');
      }
      if (!this.disabled) {
        this.$emit('item-click');
      }
      evt.stopPropagation();
    },
    updateColors: function () {
      const labelEl = this.$refs.label;
      labelEl.style.color = this.disabled ? palette[`light-neutral-90`] : this.textColor;
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$2L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('button', {
    staticClass: "i-menu-item align-items-center justify-content-start d-flex flex-row i-pl-6 i-pr-6 i-pt-4 i-pb-4",
    class: {
      disabled: _vm.disabled
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onItemClick.apply(null, arguments);
      }
    }
  }, [_vm.icon ? _c('i-icon', {
    staticClass: "i-mr-6",
    attrs: {
      "symbol": _vm.icon,
      "size": 16,
      "colour": _vm.computedIconColor
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "label",
    staticClass: "label i-mr-2 i-text-subheading-3",
    attrs: {
      "title": _vm.label
    }
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _vm.rightIcon ? _c('i-icon', {
    ref: "rightIcon",
    staticClass: "right-icon i-ml-2",
    attrs: {
      "symbol": _vm.rightIcon,
      "size": 12,
      "colour": _vm.rightIconColor
    }
  }) : _vm._e(), _vm._v(" "), _vm.checked ? _c('div', {
    staticClass: "checked-box i-ml-2"
  }, [_c('i-icon', {
    ref: "checkedIcon",
    staticClass: "check-icon",
    attrs: {
      "symbol": "small-check-1",
      "size": 12,
      "colour": _vm.checkedIconColor
    }
  })], 1) : _vm._e()], 1);
};
var __vue_staticRenderFns__$2L = [];

/* style */
const __vue_inject_styles__$2L = undefined;
/* scoped */
const __vue_scope_id__$2L = undefined;
/* module identifier */
const __vue_module_identifier__$2L = undefined;
/* functional template */
const __vue_is_functional_template__$2L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2L,
  staticRenderFns: __vue_staticRenderFns__$2L
}, __vue_inject_styles__$2L, __vue_script__$c, __vue_scope_id__$2L, __vue_is_functional_template__$2L, __vue_module_identifier__$2L, false, undefined, undefined, undefined);

//
const IToggleSizes = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg'
};
var script$b = {
  name: 'IToggle',
  // vue component name,
  components: {
    iButton: __vue_component__$32
  },
  props: {
    toggleValue: {
      type: Boolean,
      default: false
    },
    leftLabel: {
      type: String,
      default: 'Enabled'
    },
    leftIcon: {
      type: String,
      default: undefined
    },
    rightLabel: {
      type: String,
      default: 'Disabled'
    },
    rightIcon: {
      type: String,
      default: undefined
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: IToggleSizes.MEDIUM
    }
  },
  data() {
    return {
      currentlyEnabled: this.toggleValue === true
    };
  },
  computed: {
    hasLeftIcon() {
      return !!this.leftIcon;
    },
    hasRightIcon() {
      return !!this.rightIcon;
    }
  },
  watch: {
    toggleValue(newVal) {
      this.currentlyEnabled = newVal;
    }
  },
  methods: {
    setEnabled(value) {
      this.currentlyEnabled = value;
      this.$emit('value-update', this.currentlyEnabled);
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$2K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-toggle layout-row",
    class: {
      'full-width': _vm.fullWidth
    }
  }, [_c('i-button', {
    ref: "leftBtn",
    staticClass: "toggle-option",
    class: {
      disabled: !_vm.currentlyEnabled,
      enabled: _vm.currentlyEnabled
    },
    attrs: {
      "text": _vm.leftLabel,
      "type": "neutral",
      "subtype": "subtle",
      "icon": _vm.hasLeftIcon,
      "icon-symbol": _vm.leftIcon,
      "size": _vm.size
    },
    on: {
      "button-click": function ($event) {
        return _vm.setEnabled(true);
      }
    }
  }), _vm._v(" "), _c('i-button', {
    ref: "rightBtn",
    staticClass: "toggle-option",
    class: {
      disabled: _vm.currentlyEnabled,
      enabled: !_vm.currentlyEnabled
    },
    attrs: {
      "text": _vm.rightLabel,
      "type": "neutral",
      "subtype": "subtle",
      "icon": _vm.hasRightIcon,
      "icon-symbol": _vm.rightIcon,
      "size": _vm.size
    },
    on: {
      "button-click": function ($event) {
        return _vm.setEnabled(false);
      }
    }
  })], 1);
};
var __vue_staticRenderFns__$2K = [];

/* style */
const __vue_inject_styles__$2K = undefined;
/* scoped */
const __vue_scope_id__$2K = "data-v-2e6ba775";
/* module identifier */
const __vue_module_identifier__$2K = undefined;
/* functional template */
const __vue_is_functional_template__$2K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2K,
  staticRenderFns: __vue_staticRenderFns__$2K
}, __vue_inject_styles__$2K, __vue_script__$b, __vue_scope_id__$2K, __vue_is_functional_template__$2K, __vue_module_identifier__$2K, false, undefined, undefined, undefined);

//
var script$a = {
  name: 'IIconToggle',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    testId: {
      type: String,
      default: 'i-icon-toggle'
    },
    options: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      selectedValue: null
    };
  },
  created() {
    this.setSelectedValue();
  },
  methods: {
    setSelectedValue() {
      const activeOption = this.options.find(option => option.active);
      if (activeOption) {
        this.selectedValue = activeOption.value;
      }
    },
    select(value) {
      this.selectedValue = value;
      this.$emit('toggle-selected', value);
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$2J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-icon-toggle",
    attrs: {
      "data-testid": _vm.testId
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('button', {
      key: index,
      class: {
        active: option.active
      },
      on: {
        "click": function ($event) {
          return _vm.select(option.value);
        }
      }
    }, [_c('i-icon', {
      attrs: {
        "symbol": option.icon,
        "size": 20
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "i-text-button-2"
    }, [_vm._v(_vm._s(option.text))])], 1);
  }), 0);
};
var __vue_staticRenderFns__$2J = [];

/* style */
const __vue_inject_styles__$2J = undefined;
/* scoped */
const __vue_scope_id__$2J = "data-v-63d982b7";
/* module identifier */
const __vue_module_identifier__$2J = undefined;
/* functional template */
const __vue_is_functional_template__$2J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2J,
  staticRenderFns: __vue_staticRenderFns__$2J
}, __vue_inject_styles__$2J, __vue_script__$a, __vue_scope_id__$2J, __vue_is_functional_template__$2J, __vue_module_identifier__$2J, false, undefined, undefined, undefined);

//
//
//
//
//
//

var script$9 = {
  name: 'IAccordion',
  props: {
    allowMultiOpen: {
      type: Boolean,
      required: false
    }
  },
  mounted() {
    this.$on('toggle-item', this.toggleOthers);
  },
  methods: {
    toggleOthers(uid) {
      if (!this.allowMultiOpen) {
        this.$children.forEach(child => {
          if (child._uid !== uid) {
            child.isOpen = false;
          }
        });
      }
      this.$emit('accordion-toggled', document.getElementById(`i-accordion-item-${uid}`));
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$2I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-accordion"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$2I = [];

/* style */
const __vue_inject_styles__$2I = undefined;
/* scoped */
const __vue_scope_id__$2I = undefined;
/* module identifier */
const __vue_module_identifier__$2I = undefined;
/* functional template */
const __vue_is_functional_template__$2I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2I,
  staticRenderFns: __vue_staticRenderFns__$2I
}, __vue_inject_styles__$2I, __vue_script__$9, __vue_scope_id__$2I, __vue_is_functional_template__$2I, __vue_module_identifier__$2I, false, undefined, undefined, undefined);

//
const iAccordionItemSizes = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var script$8 = {
  name: 'IAccordionItem',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: iAccordionItemSizes.MEDIUM
    },
    noBackground: {
      type: Boolean,
      required: false
    },
    mountOpen: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isOpen: this.mountOpen,
      hovered: false,
      iAccordionItemSizes,
      palette,
      isOpenItemHeight: null,
      isClosedItemHeight: null,
      contentResizeObserver: null
    };
  },
  computed: {
    itemMaxHeight() {
      return this.isOpen ? `${this.isOpenItemHeight}px` : `${this.isClosedItemHeight}px`;
    }
  },
  mounted() {
    this.observeOpenHeight();
    this.calculateCloseHeight();
  },
  beforeDestroy() {
    if (this.contentResizeObserver) {
      const article = this.$refs.item.querySelector('article');
      this.contentResizeObserver.unobserve(article);
    }
  },
  methods: {
    toggle() {
      this.$parent.$emit('toggle-item', this._uid);
      this.isOpen = !this.isOpen;
    },
    calculateCloseHeight() {
      switch (this.size) {
        case iAccordionItemSizes.SMALL:
          this.isClosedItemHeight = 32;
          break;
        case iAccordionItemSizes.MEDIUM:
          this.isClosedItemHeight = 48;
          break;
        case iAccordionItemSizes.LARGE:
          this.isClosedItemHeight = 64;
          break;
      }
    },
    observeOpenHeight() {
      const article = this.$refs.item.querySelector('article');
      this.contentResizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.contentRect) {
            this.isOpenItemHeight = this.isClosedItemHeight + entry.contentRect.height + 16;
          }
        }
      });
      this.contentResizeObserver.observe(article);
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$2H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "item",
    staticClass: "i-accordion-item i-radius-md",
    class: [{
      'no-background': _vm.noBackground,
      'is-open': _vm.isOpen
    }, _vm.size],
    style: {
      maxHeight: _vm.itemMaxHeight
    },
    attrs: {
      "id": "i-accordion-item-" + _vm._uid
    },
    on: {
      "mouseover": function ($event) {
        _vm.hovered = true;
      },
      "mouseleave": function ($event) {
        _vm.hovered = false;
      }
    }
  }, [_c('div', {
    staticClass: "i-accordion-item__title",
    attrs: {
      "role": "button",
      "aria-expanded": _vm.isOpen,
      "data-testid": "accordion-item-" + _vm._uid
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "title-container i-text-neutral-120 i-text-subheading-3 i-ml-10 d-flex flex-row align-items-center justify-content-start",
    class: {
      'i-my-7': _vm.size === _vm.iAccordionItemSizes.SMALL,
      'i-my-8': _vm.size === _vm.iAccordionItemSizes.MEDIUM,
      'i-my-9': _vm.size === _vm.iAccordionItemSizes.LARGE
    }
  }, [_vm.title ? _c('span', {
    staticClass: "i-mr-4"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("extra-title-content")], 2), _vm._v(" "), _c('i-icon', {
    staticClass: "i-accordion-item__chevron i-mx-10 flex-shrink-0",
    class: {
      'i-accordion-item__chevron--collapsed': _vm.isOpen
    },
    attrs: {
      "symbol": "medium-chevron-down",
      "size": 20,
      "colour": _vm.hovered ? _vm.palette['light-neutral-90'] : _vm.palette['light-neutral-80']
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "i-accordion-item__article i-mx-10 i-mb-8",
    class: {
      hidden: !_vm.isOpen
    }
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__$2H = [];

/* style */
const __vue_inject_styles__$2H = undefined;
/* scoped */
const __vue_scope_id__$2H = undefined;
/* module identifier */
const __vue_module_identifier__$2H = undefined;
/* functional template */
const __vue_is_functional_template__$2H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2H,
  staticRenderFns: __vue_staticRenderFns__$2H
}, __vue_inject_styles__$2H, __vue_script__$8, __vue_scope_id__$2H, __vue_is_functional_template__$2H, __vue_module_identifier__$2H, false, undefined, undefined, undefined);

var script$7 = {
  name: 'ITitleBanner',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      palette,
      containerClass: `i-title-banner ${this.className}`
    };
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$2G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "i-title-banner__title-and-subtitle"
  }, [_c('div', {
    staticClass: "i-text-heading-3"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "i-text-subheading-4 i-title-banner__subtitle"
  }, [_vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    ")])]), _vm._v(" "), _c('iIcon', {
    attrs: {
      "symbol": _vm.iconName,
      "colour": _vm.palette['light-neutral-80'],
      "size": 72
    }
  })], 1);
};
var __vue_staticRenderFns__$2G = [];

/* style */
const __vue_inject_styles__$2G = undefined;
/* scoped */
const __vue_scope_id__$2G = undefined;
/* module identifier */
const __vue_module_identifier__$2G = undefined;
/* functional template */
const __vue_is_functional_template__$2G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2G,
  staticRenderFns: __vue_staticRenderFns__$2G
}, __vue_inject_styles__$2G, __vue_script__$7, __vue_scope_id__$2G, __vue_is_functional_template__$2G, __vue_module_identifier__$2G, false, undefined, undefined, undefined);

//
var script$6 = {
  name: 'IAlertMessage',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    type: {
      type: String,
      default: 'success',
      validator: function (value) {
        return ['info', 'success', 'warning', 'error', 'neutral', 'outline'].indexOf(value) !== -1;
      }
    },
    heading: {
      type: String,
      default: undefined
    },
    message: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'success':
          return 'small-solid-check';
        case 'error':
          return 'small-solid-alert-triangle';
        case 'warning':
        case 'info':
        default:
          return 'small-solid-info';
      }
    }
  },
  methods: {
    colorClass(classType, weight) {
      let palette = this.type;
      if (['info', 'outline'].includes(this.type)) {
        palette = 'neutral';
      }
      if (['outline'].includes(this.type) && classType === 'bg') {
        return `i-${classType}-neutral-default`;
      }
      return `i-${classType}-${palette}-${weight}`;
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$2F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-alert-message",
    class: [_vm.colorClass('bg', 30), {
      sm: _vm.size === 'sm',
      md: _vm.size === 'md',
      'i-py-6 i-px-6': _vm.size === 'md',
      'i-py-4 i-px-6': _vm.size === 'sm',
      'i-radius-2xl': _vm.size === 'md',
      'i-radius-xl': _vm.size === 'sm',
      outline: _vm.type === 'outline'
    }],
    attrs: {
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "i-mr-6 d-flex flex-row align-items-center"
  }, [_c('i-icon', {
    class: _vm.colorClass('text', 100),
    attrs: {
      "symbol": _vm.icon,
      "size": _vm.size === 'md' ? 16 : 12
    }
  })], 1), _vm._v(" "), _c('div', [_vm.heading ? _c('h4', {
    staticClass: "i-m-0",
    class: [{
      'i-text-subheading-2': _vm.size === 'md',
      'i-text-subheading-3': _vm.size === 'sm'
    }, _vm.colorClass('text', 120)]
  }, [_vm._v("\n      " + _vm._s(_vm.heading) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.message ? _c('p', {
    staticClass: "i-m-0",
    class: [{
      'i-text-body-2': _vm.size === 'md',
      'i-text-body-3': _vm.size === 'sm'
    }, _vm.colorClass('text', 110)]
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]) : _vm._e()])]);
};
var __vue_staticRenderFns__$2F = [];

/* style */
const __vue_inject_styles__$2F = undefined;
/* scoped */
const __vue_scope_id__$2F = undefined;
/* module identifier */
const __vue_module_identifier__$2F = undefined;
/* functional template */
const __vue_is_functional_template__$2F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2F,
  staticRenderFns: __vue_staticRenderFns__$2F
}, __vue_inject_styles__$2F, __vue_script__$6, __vue_scope_id__$2F, __vue_is_functional_template__$2F, __vue_module_identifier__$2F, false, undefined, undefined, undefined);

//
var script$5 = {
  name: 'iModal',
  // vue component name,
  components: {
    iButton: __vue_component__$32,
    iIconButton: __vue_component__$31
  },
  props: {
    modalId: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    },
    confirmButtonText: {
      type: String,
      default: 'Submit'
    },
    closeOnCancel: {
      type: Boolean,
      default: true
    },
    closeOnSubmit: {
      type: Boolean,
      default: true
    },
    buttonsFullScreen: {
      type: Boolean,
      default: true
    },
    closeOnClickOutside: {
      type: Boolean,
      default: true
    },
    confirmButtonLoading: {
      type: Boolean,
      default: false
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false
    },
    cancelButtonDisabled: {
      type: Boolean,
      default: false
    },
    closeButtonDisabled: {
      type: Boolean,
      default: false
    },
    submitOnEnter: {
      type: Boolean,
      default: false
    },
    inputFocusOnOpen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isOpen: false,
    opaque: false,
    originalParentElement: null
  }),
  computed: {
    hasBodySlot() {
      return !!this.$slots['body-content'];
    }
  },
  mounted() {
    this.originalParentEl = this.$el.parentNode;
  },
  methods: {
    setOpen(value = true) {
      this.isOpen = value;
      if (value) {
        document.body.appendChild(this.$el);
        this.isOpen = true;
        setTimeout(() => {
          this.opaque = true;
        });
        if (this.inputFocusOnOpen) {
          this.focusInput();
        }
      } else {
        var _this$originalParentE;
        (_this$originalParentE = this.originalParentEl) === null || _this$originalParentE === void 0 || _this$originalParentE.appendChild(this.$el);
        this.opaque = false;
        setTimeout(() => {
          this.isOpen = false;
        }, 200);
        this.$emit('on-close');
      }
      document.body.style.overflow = this.isOpen ? 'hidden' : 'auto';
    },
    onCancelButtonClicked() {
      if (this.closeOnCancel) {
        this.setOpen(false);
      }
      this.$emit('on-cancel');
    },
    onSubmitButtonClicked() {
      this.$emit('on-submit');
      if (this.closeOnSubmit) {
        this.setOpen(false);
      }
    },
    stopPropagation(evt) {
      evt.stopPropagation();
    },
    onEnter() {
      if (this.submitOnEnter && !this.confirmButtonDisabled) {
        this.onSubmitButtonClicked();
      }
    },
    focusInput() {
      const modalBodyElement = this.$el.querySelector('.body');
      const inputElements = modalBodyElement.querySelectorAll('input');
      const textareaElements = modalBodyElement.querySelectorAll('textarea');
      modalBodyElement && setTimeout(() => {
        if (inputElements || textareaElements) {
          inputElements ? inputElements[0].focus() : textareaElements[0].focus();
        }
      });
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$2E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-modal modal-overlay flex-row justify-content-center align-items-center",
    class: {
      'is-open': _vm.isOpen,
      opaque: _vm.opaque,
      'buttons-full-width': _vm.buttonsFullScreen
    },
    attrs: {
      "data-modal-id": _vm.modalId
    },
    on: {
      "click": function ($event) {
        _vm.closeOnClickOutside && _vm.setOpen(false);
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.onEnter.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal-content d-flex flex-column i-radius-3xl i-p-11 i-gap-10",
    on: {
      "click": _vm.stopPropagation
    }
  }, [_c('div', {
    staticClass: "header d-flex flex-row align-items-center justify-content-space-between"
  }, [_c('div', {
    staticClass: "title i-text-heading-5"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i-icon-button', {
    attrs: {
      "slot": "buttons",
      "disabled": _vm.closeButtonDisabled,
      "symbol": "medium-delete-1",
      "size": "sm"
    },
    on: {
      "button-click": function ($event) {
        return _vm.setOpen(false);
      }
    },
    slot: "buttons"
  })], 1), _vm._v(" "), _vm.hasBodySlot ? _c('div', {
    staticClass: "body i-text-body-2 i-text-neutral-110"
  }, [_vm._t("body-content")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer d-flex flex-row align-items-center"
  }, [_c('div', {
    staticClass: "extra-content flex-grow"
  }, [_vm._t("footer-content")], 2), _vm._v(" "), _c('div', {
    staticClass: "buttons-container d-flex flex-row i-gap-6"
  }, [_c('i-button', {
    attrs: {
      "slot": "buttons",
      "text": "Cancel",
      "type": "secondary",
      "size": "lg",
      "disabled": _vm.cancelButtonDisabled
    },
    on: {
      "button-click": _vm.onCancelButtonClicked
    },
    slot: "buttons"
  }), _vm._v(" "), _c('i-button', {
    attrs: {
      "slot": "buttons",
      "text": _vm.confirmButtonText,
      "type": _vm.type,
      "loading": _vm.confirmButtonLoading,
      "disabled": _vm.confirmButtonDisabled,
      "size": "lg"
    },
    on: {
      "button-click": _vm.onSubmitButtonClicked
    },
    slot: "buttons"
  })], 1)])])]);
};
var __vue_staticRenderFns__$2E = [];

/* style */
const __vue_inject_styles__$2E = undefined;
/* scoped */
const __vue_scope_id__$2E = "data-v-3608f260";
/* module identifier */
const __vue_module_identifier__$2E = undefined;
/* functional template */
const __vue_is_functional_template__$2E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2E,
  staticRenderFns: __vue_staticRenderFns__$2E
}, __vue_inject_styles__$2E, __vue_script__$5, __vue_scope_id__$2E, __vue_is_functional_template__$2E, __vue_module_identifier__$2E, false, undefined, undefined, undefined);

const getModal = modalId => {
  const modal = document.querySelector(`[data-modal-id="${modalId}"]`);
  if (modal !== null && modal !== void 0 && modal.__vue__) {
    return modal.__vue__;
  } else {
    console.error(`Modal with id: "${modalId}" not found in page.`);
  }
};
const openModal = modalId => {
  const modalComponent = getModal(modalId);
  if (typeof (modalComponent === null || modalComponent === void 0 ? void 0 : modalComponent.setOpen) === 'function') {
    modalComponent.setOpen();
  }
};
const closeModal = modalId => {
  const modalComponent = getModal(modalId);
  if (typeof (modalComponent === null || modalComponent === void 0 ? void 0 : modalComponent.setOpen) === 'function') {
    modalComponent.setOpen(false);
  }
};

//
var script$4 = {
  name: 'IPanel',
  components: {
    iIconButton: __vue_component__$31
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    side: {
      type: String,
      default: 'right',
      validator: function (value) {
        return ['right', 'left'].indexOf(value) !== -1;
      }
    },
    animation: {
      type: String,
      default: 'slide'
    }
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.iPanel.focus();
        });
      }
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$2D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "iPanel",
    staticClass: "i-panel",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "i-panel__container i-pt-12 i-pb-10",
    class: ["i-panel__container--" + _vm.side, _vm.animation],
    attrs: {
      "role": "dialog",
      "aria-modal": _vm.visible
    }
  }, [_c('i-icon-button', {
    staticClass: "i-panel__close-button",
    attrs: {
      "symbol": "medium-delete-1",
      "aria-label": "Close panel",
      "type": "transparent",
      "size": "xl"
    },
    on: {
      "button-click": function ($event) {
        return _vm.$emit('hide-panel');
      }
    }
  }), _vm._v(" "), _vm.hasHeaderSlot ? _c('div', {
    staticClass: "i-panel__header i-mb-10 i-px-12"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "i-panel__body i-px-12"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.hasFooterSlot ? _c('div', {
    staticClass: "i-panel__footer i-pt-10 i-px-12"
  }, [_vm._t("footer")], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.visible ? _c('div', {
    staticClass: "i-panel__backdrop",
    on: {
      "click": function ($event) {
        return _vm.$emit('hide-panel');
      }
    }
  }) : _vm._e()]);
};
var __vue_staticRenderFns__$2D = [];

/* style */
const __vue_inject_styles__$2D = undefined;
/* scoped */
const __vue_scope_id__$2D = "data-v-4eac43f4";
/* module identifier */
const __vue_module_identifier__$2D = undefined;
/* functional template */
const __vue_is_functional_template__$2D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2D,
  staticRenderFns: __vue_staticRenderFns__$2D
}, __vue_inject_styles__$2D, __vue_script__$4, __vue_scope_id__$2D, __vue_is_functional_template__$2D, __vue_module_identifier__$2D, false, undefined, undefined, undefined);

//
var script$3 = {
  components: {
    'i-icon': __vue_component__$34
  },
  props: {
    group: {
      type: String,
      default: 'api'
    },
    position: {
      type: String,
      default: 'top right'
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$2C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('notifications', {
    staticClass: "i-toast",
    attrs: {
      "group": _vm.group,
      "position": _vm.position
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (ref) {
        var item = ref.item;
        var close = ref.close;
        return [_c('div', {
          staticClass: "notification d-flex align-items-center justify-content-between"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "type i-mr-6"
        }, [_c('i-icon', {
          class: item.type,
          attrs: {
            "symbol": item.type === 'success' ? 'medium-check-circle' : 'medium-delete-circle'
          }
        })], 1), _vm._v(" "), _c('div', [item.title ? _c('p', {
          staticClass: "title"
        }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")]) : _vm._e(), _vm._v(" "), item.text ? _c('p', {
          staticClass: "text i-text-subheading-2"
        }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")]) : _vm._e()])]), _vm._v(" "), _c('button', {
          staticClass: "close",
          on: {
            "click": close
          }
        }, [_c('i-icon', {
          attrs: {
            "symbol": "medium-delete-1",
            "size": 16
          }
        })], 1)])];
      }
    }])
  });
};
var __vue_staticRenderFns__$2C = [];

/* style */
const __vue_inject_styles__$2C = undefined;
/* scoped */
const __vue_scope_id__$2C = undefined;
/* module identifier */
const __vue_module_identifier__$2C = undefined;
/* functional template */
const __vue_is_functional_template__$2C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2C,
  staticRenderFns: __vue_staticRenderFns__$2C
}, __vue_inject_styles__$2C, __vue_script__$3, __vue_scope_id__$2C, __vue_is_functional_template__$2C, __vue_module_identifier__$2C, false, undefined, undefined, undefined);

//
const iTooltipBackgroundMode = {
  DARK: 'dark',
  LIGHT: 'light'
};
const iTooltipToggleMode = {
  CLICK: 'click',
  MOUSEOVER: 'mouseover'
};
const iTooltipInfoTypes = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
  NEUTRAL: 'neutral'
};
const iTooltipAlignmentMode = {
  TOP_LEFT: 'top_left',
  TOP_MIDDLE: 'top_middle',
  TOP_RIGHT: 'top_right',
  BOTTOM_LEFT: 'bottom_left',
  BOTTOM_MIDDLE: 'bottom_middle',
  BOTTOM_RIGHT: 'bottom_right',
  LEFT_TOP: 'left_top',
  LEFT_MIDDLE: 'left_middle',
  LEFT_BOTTOM: 'left_bottom',
  RIGHT_TOP: 'right_top',
  RIGHT_MIDDLE: 'right_middle',
  RIGHT_BOTTOM: 'right_bottom'
};
var script$2 = {
  name: 'ITooltip',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    description: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    infoType: {
      type: String,
      default: null
    },
    infoIcon: {
      type: String,
      default: null
    },
    backgroundMode: {
      type: String,
      default: iTooltipBackgroundMode.DARK
    },
    linkText: {
      type: String,
      default: null
    },
    linkExternalUrl: {
      type: String,
      default: null
    },
    toggleMode: {
      type: String,
      default: iTooltipToggleMode.MOUSEOVER
    },
    alignment: {
      type: String,
      default: iTooltipAlignmentMode.RIGHT_MIDDLE
    },
    openDelay: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      palette,
      iTooltipBackgroundMode,
      iTooltipToggleMode,
      isOpen: false,
      targetEl: null,
      openTimeout: null,
      closeTimeout: null,
      opaque: false,
      originalParentEl: null
    };
  },
  computed: {
    infoIconSymbol() {
      let returnSymbol = 'small-info-circle';
      if (this.infoIcon) {
        return this.infoIcon;
      } else if (this.infoType) {
        switch (this.infoType) {
          case iTooltipInfoTypes.ERROR:
            returnSymbol = 'small-alert-circle';
            break;
          case iTooltipInfoTypes.WARNING:
            returnSymbol = 'small-alert-triangle';
            break;
          case iTooltipInfoTypes.SUCCESS:
            returnSymbol = 'small-check-1';
            break;
        }
      }
      return returnSymbol;
    },
    infoIconColor() {
      return palette[`light-${this.infoType}-110`];
    },
    infoIconBackgroundColor() {
      return palette[`dark-${this.infoType}-40`];
    }
  },
  watch: {
    target: function () {
      setTimeout(() => {
        this.appendListeners();
      }, 100);
    }
  },
  mounted() {
    setTimeout(() => {
      this.appendListeners();
    }, 100);
    this.originalParentEl = this.$el.parentNode;
    document.addEventListener('scroll', this.onMouseOut);
  },
  beforeDestroy() {
    if (this.targetEl) {
      this.targetEl.removeEventListener('click', this.toggleOpen);
      this.targetEl.removeEventListener('mouseover', this.onMouseOver);
      this.targetEl.removeEventListener('mouseout', this.onMouseOut);
    }
    this.$el.removeEventListener('mouseover', this.onMouseOver);
    this.$el.removeEventListener('mouseout', this.onMouseOut);
    document.removeEventListener('scroll', this.onMouseOver);
  },
  methods: {
    appendListeners() {
      const target = document.querySelector(this.target);
      if (target) {
        this.targetEl = target;

        // listeners
        if (this.toggleMode === iTooltipToggleMode.CLICK) {
          this.targetEl.addEventListener('click', this.toggleOpen);
        } else if (this.toggleMode === iTooltipToggleMode.MOUSEOVER) {
          this.targetEl.addEventListener('mouseover', this.onMouseOver);
          this.targetEl.addEventListener('mouseout', this.onMouseOut);
          this.$el.addEventListener('mouseover', this.onMouseOver);
          this.$el.addEventListener('mouseout', this.onMouseOut);
        }
      }
    },
    setOpen(value) {
      this.isOpen = value;
      if (value) {
        setTimeout(() => {
          // make sure its fully visible
          this.positionTooltip();
        });
        document.body.appendChild(this.$el);
      } else {
        var _this$originalParentE;
        (_this$originalParentE = this.originalParentEl) === null || _this$originalParentE === void 0 || _this$originalParentE.appendChild(this.$el);
      }
    },
    toggleOpen() {
      this.isOpen ? this.onMouseOut() : this.onMouseOver();
    },
    clearTimeouts() {
      this.closeTimeout && clearTimeout(this.closeTimeout);
      this.openTimeout && clearTimeout(this.openTimeout);
    },
    onMouseOver() {
      this.clearTimeouts();
      this.openTimeout = setTimeout(() => {
        this.opaque = true;
        this.closeAllTooltips(this.target);
        this.setOpen(true);
      }, this.openDelay);
    },
    onMouseOut() {
      this.clearTimeouts();
      this.closeTimeout = setTimeout(() => {
        this.opaque = false;
        setTimeout(() => {
          this.setOpen(false);
        }, 200);
      }, 150);
    },
    closeAllTooltips(exceptTarget) {
      const tooltips = document.querySelectorAll('.i-tooltip');
      Array.from(tooltips).forEach(t => {
        if (t.__vue__ && t.target !== exceptTarget) {
          t.__vue__.isOpen = false;
        }
      });
    },
    onLinkClick() {
      this.$emit('link-clicked');
      if (this.linkExternalUrl) {
        window.open(this.linkExternalUrl, '_blank', 'noopener');
      }
    },
    positionTooltip() {
      let top;
      let left;
      const targetRect = this.targetEl.getBoundingClientRect();
      const tooltipRect = this.$el.getBoundingClientRect();
      const MARGIN = 6;
      switch (this.alignment) {
        case iTooltipAlignmentMode.TOP_LEFT:
          top = targetRect.top - tooltipRect.height - MARGIN;
          left = targetRect.left;
          break;
        case iTooltipAlignmentMode.TOP_MIDDLE:
          top = targetRect.top - tooltipRect.height - MARGIN;
          left = targetRect.left - (tooltipRect.width / 2 - targetRect.width / 2);
          break;
        case iTooltipAlignmentMode.TOP_RIGHT:
          top = targetRect.top - tooltipRect.height - MARGIN;
          left = targetRect.right - tooltipRect.width;
          break;
        case iTooltipAlignmentMode.BOTTOM_LEFT:
          top = targetRect.bottom + MARGIN;
          left = targetRect.left;
          break;
        case iTooltipAlignmentMode.BOTTOM_MIDDLE:
          top = targetRect.bottom + MARGIN;
          left = targetRect.left - (tooltipRect.width / 2 - targetRect.width / 2);
          break;
        case iTooltipAlignmentMode.BOTTOM_RIGHT:
          top = targetRect.bottom + MARGIN;
          left = targetRect.right - tooltipRect.width;
          break;
        case iTooltipAlignmentMode.LEFT_TOP:
          top = targetRect.top;
          left = targetRect.left - tooltipRect.width - MARGIN;
          break;
        case iTooltipAlignmentMode.LEFT_MIDDLE:
          top = targetRect.top - (tooltipRect.height / 2 - targetRect.height / 2);
          left = targetRect.left - tooltipRect.width - MARGIN;
          break;
        case iTooltipAlignmentMode.LEFT_BOTTOM:
          top = targetRect.bottom;
          left = targetRect.left - tooltipRect.width - MARGIN;
          break;
        case iTooltipAlignmentMode.RIGHT_TOP:
          top = targetRect.top;
          left = targetRect.right + MARGIN;
          break;
        case iTooltipAlignmentMode.RIGHT_MIDDLE:
          top = targetRect.top - (tooltipRect.height / 2 - targetRect.height / 2);
          left = targetRect.right + MARGIN;
          break;
        case iTooltipAlignmentMode.RIGHT_BOTTOM:
          top = targetRect.bottom;
          left = targetRect.right + MARGIN;
          break;
      }

      // correct if no space
      // left
      const enoughSpaceRight = this.alignment.endsWith('right') || left + tooltipRect.width < window.innerWidth;
      const enoughSpaceLeft = this.alignment.endsWith('left') || left + tooltipRect.width > tooltipRect.width;
      left = enoughSpaceLeft ? left : targetRect.right + MARGIN;
      left = enoughSpaceRight ? left : targetRect.left - tooltipRect.width - MARGIN;
      // top
      const enoughSpaceTop = top + tooltipRect.height > tooltipRect.height;
      const enoughSpaceBottom = top + tooltipRect.height < window.innerHeight;
      top = enoughSpaceTop ? top : targetRect.bottom + MARGIN;
      top = enoughSpaceBottom ? top : targetRect.top - tooltipRect.height - MARGIN;
      this.$el.style.left = `${left}px`;
      this.$el.style.top = `${top}px`;
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-tooltip i-radius-xl",
    class: {
      dark: _vm.backgroundMode === _vm.iTooltipBackgroundMode.DARK,
      light: _vm.backgroundMode === _vm.iTooltipBackgroundMode.LIGHT,
      'is-open': _vm.isOpen,
      opaque: _vm.opaque
    }
  }, [_vm.isOpen ? _c('div', {
    staticClass: "tooltip-content d-flex flex-row i-p-6"
  }, [_vm.infoType ? _c('div', {
    staticClass: "icon-container d-flex flex-row align-items-center justify-content-center i-mr-4",
    style: {
      background: _vm.infoIconBackgroundColor
    }
  }, [_c('i-icon', {
    staticClass: "icon blue",
    attrs: {
      "symbol": _vm.infoIconSymbol,
      "size": 14,
      "colour": _vm.infoIconColor
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-container d-flex flex-column align-items-start justify-content-center"
  }, [_c('div', {
    staticClass: "title-container d-flex flex-row justify-content-space-between"
  }, [_c('div', {
    staticClass: "title i-text-subheading-3 flex-grow-1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("tools")], 2), _vm._v(" "), _vm.description ? _c('div', {
    staticClass: "description d-flex flex-row i-text-body-3 i-mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkText ? _c('div', {
    staticClass: "link-container d-flex flex-row align-items-center justify-content-start i-mt-4",
    on: {
      "click": _vm.onLinkClick
    }
  }, [_c('a', {
    staticClass: "link i-text-body-3 i-mr-2"
  }, [_vm._v(_vm._s(_vm.linkText))])]) : _vm._e()])]) : _vm._e()]);
};
var __vue_staticRenderFns__$2B = [];

/* style */
const __vue_inject_styles__$2B = undefined;
/* scoped */
const __vue_scope_id__$2B = undefined;
/* module identifier */
const __vue_module_identifier__$2B = undefined;
/* functional template */
const __vue_is_functional_template__$2B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2B,
  staticRenderFns: __vue_staticRenderFns__$2B
}, __vue_inject_styles__$2B, __vue_script__$2, __vue_scope_id__$2B, __vue_is_functional_template__$2B, __vue_module_identifier__$2B, false, undefined, undefined, undefined);

//
const iStepperSizes = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
var script$1 = {
  name: 'iStepper',
  components: {
    iIcon: __vue_component__$34
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: Infinity
    },
    stepSize: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: iStepperSizes.MEDIUM
    },
    precision: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.initialValue,
      iStepperSizes
    };
  },
  computed: {
    decreaseDisabled() {
      return this.currentValue <= parseFloat(this.minValue);
    },
    increaseDisabled() {
      return this.currentValue >= parseFloat(this.maxValue);
    }
  },
  mounted() {
    this.currentValue = this.value ? parseFloat(this.value) : 0;
  },
  methods: {
    onInput() {
      this.adjustValue();
    },
    decreaseValue() {
      this.currentValue -= parseFloat(this.stepSize);
      this.adjustValue();
    },
    increaseValue() {
      this.currentValue += parseFloat(this.stepSize);
      this.adjustValue();
    },
    adjustValue() {
      this.currentValue = parseFloat(this.currentValue);
      this.currentValue = this.currentValue > parseFloat(this.maxValue) ? parseFloat(this.maxValue) : this.currentValue;
      this.currentValue = this.currentValue < parseFloat(this.minValue) ? parseFloat(this.minValue) : this.currentValue;
      this.currentValue = parseFloat((Math.round(this.currentValue / this.stepSize) * this.stepSize).toFixed(2));
      this.$emit('value-changed', this.currentValue);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$2A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "i-stepper d-flex flex-row",
    class: {
      disabled: _vm.disabled,
      small: _vm.size === _vm.iStepperSizes.SMALL,
      medium: _vm.size === _vm.iStepperSizes.MEDIUM,
      'full-width': _vm.fullWidth
    }
  }, [_c('button', {
    staticClass: "action decrease d-flex justify-content-center align-items-center",
    class: {
      disabled: _vm.disabled || _vm.decreaseDisabled
    },
    attrs: {
      "data-testid": "stepper-decrease"
    },
    on: {
      "click": function ($event) {
        return _vm.decreaseValue();
      }
    }
  }, [_c('i-icon', {
    class: {
      'i-text-neutral-80': _vm.disabled || _vm.decreaseDisabled,
      'i-text-neutral-120': !_vm.disabled && !_vm.decreaseDisabled
    },
    attrs: {
      "symbol": "small-remove-1",
      "size": 16
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value-container d-flex justify-content-center align-items-center",
    class: {
      'i-text-neutral-80': _vm.disabled,
      'i-text-neutral-120': !_vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentValue,
      expression: "currentValue"
    }],
    staticClass: "i-text-body-2",
    attrs: {
      "type": "number",
      "min": _vm.minValue,
      "max": _vm.maxValue,
      "step": _vm.stepSize
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.currentValue = $event.target.value;
      }, _vm.onInput]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "action increase d-flex justify-content-center align-items-center",
    class: {
      disabled: _vm.disabled || _vm.increaseDisabled
    },
    attrs: {
      "data-testid": "stepper-increase"
    },
    on: {
      "click": function ($event) {
        return _vm.increaseValue();
      }
    }
  }, [_c('i-icon', {
    class: {
      'i-text-neutral-80': _vm.disabled || _vm.increaseDisabled,
      'i-text-neutral-120': !_vm.disabled && !_vm.increaseDisabled
    },
    attrs: {
      "symbol": "small-add-1",
      "size": 16
    }
  })], 1)]);
};
var __vue_staticRenderFns__$2A = [];

/* style */
const __vue_inject_styles__$2A = undefined;
/* scoped */
const __vue_scope_id__$2A = undefined;
/* module identifier */
const __vue_module_identifier__$2A = undefined;
/* functional template */
const __vue_is_functional_template__$2A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2A,
  staticRenderFns: __vue_staticRenderFns__$2A
}, __vue_inject_styles__$2A, __vue_script__$1, __vue_scope_id__$2A, __vue_is_functional_template__$2A, __vue_module_identifier__$2A, false, undefined, undefined, undefined);

const iDropzoneTypes = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
var script = {
  name: 'iDropzone',
  // vue component name,
  components: {
    iButton: __vue_component__$32,
    iFeaturedIcon: __vue_component__$2_
  },
  props: {
    multiFile: {
      type: Boolean,
      default: true
    },
    acceptedExtensions: {
      type: Array,
      default: () => ['pdf']
    },
    type: {
      type: String,
      default: iDropzoneTypes.VERTICAL
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withBrowseButton: {
      type: Boolean,
      default: false
    },
    browseButtonText: {
      type: String,
      default: 'Select Documents'
    }
  },
  data: () => ({
    dragging: false,
    hovering: false,
    iDropzoneTypes,
    iFeaturedIconSizes,
    iFeaturedIconTypes
  }),
  computed: {
    iconType() {
      if (!this.disabled && (this.hovering || this.dragging)) {
        return iFeaturedIconTypes.PRIMARY;
      } else {
        return iFeaturedIconTypes.NEUTRAL;
      }
    },
    bgColor() {
      return palette[`light-neutral-10`];
    },
    borderColor() {
      let returnColor = palette[`light-neutral-70`];
      if (this.disabled) {
        returnColor = palette[`light-neutral-70`];
      } else if (this.hovering) {
        returnColor = palette[`light-primary-60`];
      } else if (this.dragging) {
        returnColor = palette[`light-primary-80`];
      }
      return returnColor;
    },
    cssVars() {
      return {
        '--bg-color': this.bgColor,
        '--border-color': this.borderColor
      };
    }
  },
  mounted() {
    // start event listeners
    const dropArea = this.$refs.dropArea;
    const inputElement = this.$refs.hiddenInput;
    if (dropArea && !this.disabled) {
      dropArea.addEventListener('dragenter', this.handlerFunction, false);
      dropArea.addEventListener('dragleave', this.handlerFunction, false);
      dropArea.addEventListener('dragover', this.handlerFunction, false);
      dropArea.addEventListener('drop', this.handlerFunction, false);
    }
    if (inputElement) {
      inputElement.addEventListener('change', evt => {
        if (evt.target.files) {
          this.validateDrop(Array.from(evt.target.files));
        }
      });
    }
  },
  methods: {
    handlerFunction(evt) {
      this.dragging = ['dragover'].includes(evt.type);
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.type === 'drop') {
        const dataTransfer = evt.dataTransfer;
        this.validateDrop(Array.from(dataTransfer.files));
      }
    },
    /**
     * this will check if the files dropped will be valid
     * send an events for valid file, and one for errors
     * todo add size validation?
     */
    validateDrop(files) {
      const validFiles = files.filter(file => {
        const lastDotIndex = file.name.lastIndexOf('.');
        const extension = file.name.substring(lastDotIndex + 1);
        return this.acceptedExtensions.includes(extension);
      });
      if (validFiles.length) {
        this.$emit('files-selected', validFiles);
      }
    },
    browseDevice() {
      const inputElement = this.$refs.hiddenInput;
      if (inputElement) {
        inputElement.click();
      }
    },
    onZoneClick() {
      if (!this.withBrowseButton && !this.disabled) {
        this.browseDevice();
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__$2z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "dropArea",
    staticClass: "i-dropzone d-flex align-items-center justify-content-center i-radius-2xl",
    class: {
      'i-px-8': _vm.type === _vm.iDropzoneTypes.VERTICAL,
      'i-py-12': _vm.type === _vm.iDropzoneTypes.VERTICAL,
      'i-px-10': _vm.type === _vm.iDropzoneTypes.HORIZONTAL,
      'i-py-9': _vm.type === _vm.iDropzoneTypes.HORIZONTAL,
      clickable: !_vm.withBrowseButton,
      disabled: _vm.disabled
    },
    style: _vm.cssVars,
    on: {
      "mouseenter": function ($event) {
        _vm.hovering = true;
      },
      "mouseleave": function ($event) {
        _vm.hovering = false;
      },
      "click": _vm.onZoneClick
    }
  }, [_c('input', {
    ref: "hiddenInput",
    attrs: {
      "type": "file",
      "accept": _vm.acceptedExtensions.map(function (e) {
        return "." + e;
      }),
      "multiple": _vm.multiFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content d-flex align-items-center i-gap-8",
    class: {
      'flex-column': _vm.type === _vm.iDropzoneTypes.VERTICAL,
      'flex-row': _vm.type === _vm.iDropzoneTypes.HORIZONTAL
    }
  }, [_c('i-featured-icon', {
    attrs: {
      "size": _vm.iFeaturedIconSizes.XXL,
      "type": _vm.iconType,
      "symbol": "medium-upload-1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text d-flex flex-column i-gap-1",
    class: {
      'align-items-center': _vm.type === _vm.iDropzoneTypes.VERTICAL
    }
  }, [_c('div', {
    staticClass: "title i-text-button-2",
    class: {
      'i-text-neutral-90': _vm.disabled,
      'i-text-neutral-120': !_vm.disabled && !_vm.dragging && !_vm.hovering,
      'i-text-primary-120': !_vm.disabled && (_vm.dragging || _vm.hovering)
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle i-text-body-2",
    class: {
      'i-text-neutral-90': _vm.disabled,
      'i-text-neutral-110': !_vm.disabled && !_vm.dragging && !_vm.hovering,
      'i-text-primary-110': !_vm.disabled && (_vm.dragging || _vm.hovering)
    }
  }, [_vm._v("\n        " + _vm._s(_vm.subTitle) + "\n      ")])]), _vm._v(" "), _vm.withBrowseButton && _vm.type === _vm.iDropzoneTypes.VERTICAL ? _c('i-button', {
    attrs: {
      "text": _vm.browseButtonText,
      "type": "neutral",
      "subtype": "outline",
      "size": "xs"
    },
    on: {
      "button-click": _vm.browseDevice
    }
  }) : _vm._e()], 1)]);
};
var __vue_staticRenderFns__$2z = [];

/* style */
const __vue_inject_styles__$2z = undefined;
/* scoped */
const __vue_scope_id__$2z = "data-v-50b95aeb";
/* module identifier */
const __vue_module_identifier__$2z = undefined;
/* functional template */
const __vue_is_functional_template__$2z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2z,
  staticRenderFns: __vue_staticRenderFns__$2z
}, __vue_inject_styles__$2z, __vue_script__, __vue_scope_id__$2z, __vue_is_functional_template__$2z, __vue_module_identifier__$2z, false, undefined, undefined, undefined);

// buttons

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  iButton: __vue_component__$32,
  iIconButton: __vue_component__$31,
  iButtonsGroup: __vue_component__$30,
  iButtonsGroupTypes: iButtonsGroupTypes,
  iIcon: __vue_component__$34,
  iAlertIcon: __vue_component__$2$,
  iFeaturedIcon: __vue_component__$2_,
  iFeaturedIconSizes: iFeaturedIconSizes,
  iFeaturedIconTypes: iFeaturedIconTypes,
  iCopyInput: __vue_component__$2Z,
  iInlineInput: __vue_component__$2Y,
  iRadio: __vue_component__$2X,
  iCheckbox: __vue_component__$2W,
  iCheckboxGroup: __vue_component__$2V,
  iSearchInput: __vue_component__$2U,
  iSelect: __vue_component__$2T,
  iSwitch: __vue_component__$2S,
  iTextInput: __vue_component__$2R,
  iTextInputModes: iTextInputModes,
  iTextInputSizes: iTextInputSizes,
  iFilter: __vue_component__$2Q,
  iAmountRangeFilter: __vue_component__$2P,
  iSort: __vue_component__$2N,
  iMenu: __vue_component__$2M,
  iMenuItem: __vue_component__$2L,
  iMenuTriggerAlignOptions: iMenuTriggerAlignOptions,
  iToggle: __vue_component__$2K,
  IToggleSizes: IToggleSizes,
  iIconToggle: __vue_component__$2J,
  iAccordion: __vue_component__$2I,
  iAccordionItem: __vue_component__$2H,
  iAccordionItemSizes: iAccordionItemSizes,
  iTitleBanner: __vue_component__$2G,
  iAlertMessage: __vue_component__$2F,
  iBadge: __vue_component__$2O,
  iBadgeColours: iBadgeColours,
  iBadgeDotSizes: iBadgeDotSizes,
  iModal: __vue_component__$2E,
  iPanel: __vue_component__$2D,
  iSpinner: __vue_component__$33,
  iToast: __vue_component__$2C,
  iTooltip: __vue_component__$2B,
  iTooltipAlignmentMode: iTooltipAlignmentMode,
  iTooltipBackgroundMode: iTooltipBackgroundMode,
  iTooltipInfoTypes: iTooltipInfoTypes,
  iTooltipToggleMode: iTooltipToggleMode,
  iStepper: __vue_component__$2A,
  iStepperSizes: iStepperSizes,
  iDropzone: __vue_component__$2z,
  iDropzoneTypes: iDropzoneTypes,
  positionMenu: positionMenu,
  getModal: getModal,
  openModal: openModal,
  closeModal: closeModal
});

// Import vue components

// install function executed by Vue.use()
const install = function installSignal(Vue) {
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
};

/* script */

/* template */
var __vue_render__$2y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-add-1"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M8.00018 2V14",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M2.00018 8H14.0002",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2y = [];

/* style */
const __vue_inject_styles__$2y = undefined;
/* scoped */
const __vue_scope_id__$2y = undefined;
/* module identifier */
const __vue_module_identifier__$2y = undefined;
/* functional template */
const __vue_is_functional_template__$2y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2y,
  staticRenderFns: __vue_staticRenderFns__$2y
}, __vue_inject_styles__$2y, {}, __vue_scope_id__$2y, __vue_is_functional_template__$2y, __vue_module_identifier__$2y, false, undefined, undefined, undefined);

var smallAdd1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2y
});

/* script */

/* template */
var __vue_render__$2x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-add-circle"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M0.799988 8.00005C0.799988 9.90961 1.55856 11.741 2.90882 13.0912C4.25908 14.4415 6.09043 15.2 7.99999 15.2C9.90955 15.2 11.7409 14.4415 13.0912 13.0912C14.4414 11.741 15.2 9.90961 15.2 8.00005C15.2 6.09049 14.4414 4.25914 13.0912 2.90888C11.7409 1.55862 9.90955 0.800049 7.99999 0.800049C6.09043 0.800049 4.25908 1.55862 2.90882 2.90888C1.55856 4.25914 0.799988 6.09049 0.799988 8.00005V8.00005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M8 4.80005V11.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_3",
      "d": "M4.79999 8H11.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2x = [];

/* style */
const __vue_inject_styles__$2x = undefined;
/* scoped */
const __vue_scope_id__$2x = undefined;
/* module identifier */
const __vue_module_identifier__$2x = undefined;
/* functional template */
const __vue_is_functional_template__$2x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2x,
  staticRenderFns: __vue_staticRenderFns__$2x
}, __vue_inject_styles__$2x, {}, __vue_scope_id__$2x, __vue_is_functional_template__$2x, __vue_module_identifier__$2x, false, undefined, undefined, undefined);

var smallAddCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2x
});

/* script */

/* template */
var __vue_render__$2w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0.799805 8.00005C0.799805 9.90961 1.55837 11.741 2.90864 13.0912C4.2589 14.4415 6.09025 15.2 7.9998 15.2C9.90936 15.2 11.7407 14.4415 13.091 13.0912C14.4412 11.741 15.1998 9.90961 15.1998 8.00005C15.1998 6.09049 14.4412 4.25914 13.091 2.90888C11.7407 1.55862 9.90936 0.800049 7.9998 0.800049C6.09025 0.800049 4.2589 1.55862 2.90864 2.90888C1.55837 4.25914 0.799805 6.09049 0.799805 8.00005V8.00005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 4.80005V8.00005",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6.80029 11.0002C6.80029 11.3184 6.92673 11.6236 7.15179 11.8487C7.37684 12.0737 7.68209 12.2001 8.00037 12.2001C8.31865 12.2001 8.62389 12.0737 8.84895 11.8487C9.074 11.6236 9.20044 11.3184 9.20044 11.0002C9.20044 10.6819 9.074 10.3767 8.84895 10.1516C8.62389 9.9266 8.31865 9.80017 8.00037 9.80017C7.68209 9.80017 7.37684 9.9266 7.15179 10.1516C6.92673 10.3767 6.80029 10.6819 6.80029 11.0002Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs')]);
};
var __vue_staticRenderFns__$2w = [];

/* style */
const __vue_inject_styles__$2w = undefined;
/* scoped */
const __vue_scope_id__$2w = undefined;
/* module identifier */
const __vue_module_identifier__$2w = undefined;
/* functional template */
const __vue_is_functional_template__$2w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2w,
  staticRenderFns: __vue_staticRenderFns__$2w
}, __vue_inject_styles__$2w, {}, __vue_scope_id__$2w, __vue_is_functional_template__$2w, __vue_module_identifier__$2w, false, undefined, undefined, undefined);

var smallAlertCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2w
});

/* script */

/* template */
var __vue_render__$2v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.21621 15.2H12.781C13.2009 15.2 13.6136 15.0906 13.9783 14.8825C14.343 14.6745 14.6472 14.3749 14.8609 14.0135C15.0746 13.652 15.1904 13.2411 15.1969 12.8212C15.2033 12.4014 15.1003 11.9871 14.8978 11.6192L9.29461 1.5664C9.1676 1.33406 8.9804 1.1402 8.75265 1.00515C8.5249 0.870094 8.26499 0.798828 8.00021 0.798828C7.73543 0.798828 7.47553 0.870094 7.24778 1.00515C7.02003 1.1402 6.83282 1.33406 6.70581 1.5664L1.10261 11.624C0.900466 11.9914 0.797546 12.4051 0.803997 12.8243C0.810447 13.2436 0.926046 13.6539 1.1394 14.0149C1.35275 14.3758 1.65649 14.675 2.02067 14.8828C2.38485 15.0906 2.79691 15.1999 3.21621 15.2V15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 5.19995V8.39995",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6.80029 11.3999C6.80029 11.7182 6.92673 12.0234 7.15179 12.2484C7.37684 12.4735 7.68209 12.5999 8.00037 12.5999C8.31865 12.5999 8.62389 12.4735 8.84895 12.2484C9.074 12.0234 9.20044 11.7182 9.20044 11.3999C9.20044 11.0817 9.074 10.7765 8.84895 10.5514C8.62389 10.3264 8.31865 10.2 8.00037 10.2C7.68209 10.2 7.37684 10.3264 7.15179 10.5514C6.92673 10.7765 6.80029 11.0817 6.80029 11.3999Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$2v = [];

/* style */
const __vue_inject_styles__$2v = undefined;
/* scoped */
const __vue_scope_id__$2v = undefined;
/* module identifier */
const __vue_module_identifier__$2v = undefined;
/* functional template */
const __vue_is_functional_template__$2v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2v,
  staticRenderFns: __vue_staticRenderFns__$2v
}, __vue_inject_styles__$2v, {}, __vue_scope_id__$2v, __vue_is_functional_template__$2v, __vue_module_identifier__$2v, false, undefined, undefined, undefined);

var smallAlertTriangle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2v
});

/* script */

/* template */
var __vue_render__$2u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 1.8C0.799805 1.24772 1.24752 0.800003 1.7998 0.800003H10.9998C11.5521 0.800003 11.9998 1.24772 11.9998 1.8V11C11.9998 11.5523 11.5521 12 10.9998 12H1.7998C1.24752 12 0.799805 11.5523 0.799805 11V1.8Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.1998 4.1232V13.6C15.1998 14.0243 15.0313 14.4313 14.7312 14.7314C14.4312 15.0314 14.0242 15.2 13.5998 15.2H4.12305",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2u = [];

/* style */
const __vue_inject_styles__$2u = undefined;
/* scoped */
const __vue_scope_id__$2u = undefined;
/* module identifier */
const __vue_module_identifier__$2u = undefined;
/* functional template */
const __vue_is_functional_template__$2u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2u,
  staticRenderFns: __vue_staticRenderFns__$2u
}, __vue_inject_styles__$2u, {}, __vue_scope_id__$2u, __vue_is_functional_template__$2u, __vue_module_identifier__$2u, false, undefined, undefined, undefined);

var smallAlignBack = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2u
});

/* script */

/* template */
var __vue_render__$2t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 12V4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.99988 9L7.99988 12L10.9999 9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2t = [];

/* style */
const __vue_inject_styles__$2t = undefined;
/* scoped */
const __vue_scope_id__$2t = undefined;
/* module identifier */
const __vue_module_identifier__$2t = undefined;
/* functional template */
const __vue_is_functional_template__$2t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2t,
  staticRenderFns: __vue_staticRenderFns__$2t
}, __vue_inject_styles__$2t, {}, __vue_scope_id__$2t, __vue_is_functional_template__$2t, __vue_module_identifier__$2t, false, undefined, undefined, undefined);

var smallArrowsDownSmall = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2t
});

/* script */

/* template */
var __vue_render__$2s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M6.3998 0.799988H2.3998C1.97546 0.799988 1.56849 0.968559 1.26843 1.26862C0.968376 1.56868 0.799805 1.97564 0.799805 2.39999V13.6C0.799805 14.0243 0.968376 14.4313 1.26843 14.7314C1.56849 15.0314 1.97546 15.2 2.3998 15.2H13.5998C14.0242 15.2 14.4311 15.0314 14.7312 14.7314C15.0312 14.4313 15.1998 14.0243 15.1998 13.6V9.59999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.1997 0.799988H15.1997V4.79999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.2 0.799988L8 7.99999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs')]);
};
var __vue_staticRenderFns__$2s = [];

/* style */
const __vue_inject_styles__$2s = undefined;
/* scoped */
const __vue_scope_id__$2s = undefined;
/* module identifier */
const __vue_module_identifier__$2s = undefined;
/* functional template */
const __vue_is_functional_template__$2s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2s,
  staticRenderFns: __vue_staticRenderFns__$2s
}, __vue_inject_styles__$2s, {}, __vue_scope_id__$2s, __vue_is_functional_template__$2s, __vue_module_identifier__$2s, false, undefined, undefined, undefined);

var smallArrowsExpand = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2s
});

/* script */

/* template */
var __vue_render__$2r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "17",
      "height": "17",
      "viewBox": "0 0 17 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.5 8.5H12.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.5 11.5L4.5 8.5L7.5 5.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2r = [];

/* style */
const __vue_inject_styles__$2r = undefined;
/* scoped */
const __vue_scope_id__$2r = undefined;
/* module identifier */
const __vue_module_identifier__$2r = undefined;
/* functional template */
const __vue_is_functional_template__$2r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2r,
  staticRenderFns: __vue_staticRenderFns__$2r
}, __vue_inject_styles__$2r, {}, __vue_scope_id__$2r, __vue_is_functional_template__$2r, __vue_module_identifier__$2r, false, undefined, undefined, undefined);

var smallArrowsLeftSmall = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2r
});

/* script */

/* template */
var __vue_render__$2q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.4 0.799988L13.6 3.59999L10.4 6.39999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799988 7.19998V5.19998C0.799988 4.77563 0.968559 4.36866 1.26862 4.0686C1.56868 3.76855 1.97564 3.59998 2.39999 3.59998H13.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59996 15.2L2.39996 12.4L5.59996 9.59998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.2 8.79999V10.8C15.2 11.2243 15.0314 11.6313 14.7313 11.9314C14.4313 12.2314 14.0243 12.4 13.6 12.4H2.39996",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2q = [];

/* style */
const __vue_inject_styles__$2q = undefined;
/* scoped */
const __vue_scope_id__$2q = undefined;
/* module identifier */
const __vue_module_identifier__$2q = undefined;
/* functional template */
const __vue_is_functional_template__$2q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2q,
  staticRenderFns: __vue_staticRenderFns__$2q
}, __vue_inject_styles__$2q, {}, __vue_scope_id__$2q, __vue_is_functional_template__$2q, __vue_module_identifier__$2q, false, undefined, undefined, undefined);

var smallArrowsReload = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2q
});

/* script */

/* template */
var __vue_render__$2p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8H4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 5L12 8L9 11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2p = [];

/* style */
const __vue_inject_styles__$2p = undefined;
/* scoped */
const __vue_scope_id__$2p = undefined;
/* module identifier */
const __vue_module_identifier__$2p = undefined;
/* functional template */
const __vue_is_functional_template__$2p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2p,
  staticRenderFns: __vue_staticRenderFns__$2p
}, __vue_inject_styles__$2p, {}, __vue_scope_id__$2p, __vue_is_functional_template__$2p, __vue_module_identifier__$2p, false, undefined, undefined, undefined);

var smallArrowsRightSmall = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2p
});

/* script */

/* template */
var __vue_render__$2o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 4V12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 7L8 4L11 7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2o = [];

/* style */
const __vue_inject_styles__$2o = undefined;
/* scoped */
const __vue_scope_id__$2o = undefined;
/* module identifier */
const __vue_module_identifier__$2o = undefined;
/* functional template */
const __vue_is_functional_template__$2o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2o,
  staticRenderFns: __vue_staticRenderFns__$2o
}, __vue_inject_styles__$2o, {}, __vue_scope_id__$2o, __vue_is_functional_template__$2o, __vue_module_identifier__$2o, false, undefined, undefined, undefined);

var smallArrowsUpSmall = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2o
});

/* script */

/* template */
var __vue_render__$2n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 1.50001L6 10.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.25 5.25001L6 1.50001L9.75 5.25001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2n = [];

/* style */
const __vue_inject_styles__$2n = undefined;
/* scoped */
const __vue_scope_id__$2n = undefined;
/* module identifier */
const __vue_module_identifier__$2n = undefined;
/* functional template */
const __vue_is_functional_template__$2n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2n,
  staticRenderFns: __vue_staticRenderFns__$2n
}, __vue_inject_styles__$2n, {}, __vue_scope_id__$2n, __vue_is_functional_template__$2n, __vue_module_identifier__$2n, false, undefined, undefined, undefined);

var smallArrowsUp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2n
});

/* script */

/* template */
var __vue_render__$2m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.99994 15.2C7.99994 12.9248 4.35834 12.2672 2.25434 12.0768C1.85571 12.0403 1.48522 11.8558 1.21597 11.5596C0.946721 11.2634 0.79828 10.877 0.799941 10.4768V2.39995C0.800023 2.17558 0.847295 1.95373 0.938687 1.74882C1.03008 1.5439 1.16355 1.3605 1.33043 1.21052C1.49731 1.06054 1.69387 0.947332 1.90734 0.878254C2.12082 0.809175 2.34643 0.785768 2.56954 0.809551C4.70074 1.03515 7.99994 1.73435 7.99994 3.90075V15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 15.2C8 12.9248 11.6416 12.2672 13.7456 12.0768C14.1442 12.0403 14.5147 11.8558 14.784 11.5596C15.0532 11.2634 15.2017 10.877 15.2 10.4768V2.39995C15.1999 2.17558 15.1526 1.95373 15.0613 1.74882C14.9699 1.5439 14.8364 1.3605 14.6695 1.21052C14.5026 1.06054 14.3061 0.947332 14.0926 0.878254C13.8791 0.809175 13.6535 0.785768 13.4304 0.809551C11.2992 1.03515 8 1.73435 8 3.90075V15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2m = [];

/* style */
const __vue_inject_styles__$2m = undefined;
/* scoped */
const __vue_scope_id__$2m = undefined;
/* module identifier */
const __vue_module_identifier__$2m = undefined;
/* functional template */
const __vue_is_functional_template__$2m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2m,
  staticRenderFns: __vue_staticRenderFns__$2m
}, __vue_inject_styles__$2m, {}, __vue_scope_id__$2m, __vue_is_functional_template__$2m, __vue_module_identifier__$2m, false, undefined, undefined, undefined);

var smallBookOpen = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2m
});

/* script */

/* template */
var __vue_render__$2l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.2 15.2L6.39998 11.2L1.59998 15.2V5.6C1.59998 5.17565 1.76855 4.76869 2.0686 4.46863C2.36866 4.16857 2.77563 4 3.19998 4H9.59998C10.0243 4 10.4313 4.16857 10.7313 4.46863C11.0314 4.76869 11.2 5.17565 11.2 5.6V15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.40002 0.800049H12.8C13.2244 0.800049 13.6313 0.96862 13.9314 1.26868C14.2315 1.56874 14.4 1.9757 14.4 2.40005V12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2l = [];

/* style */
const __vue_inject_styles__$2l = undefined;
/* scoped */
const __vue_scope_id__$2l = undefined;
/* module identifier */
const __vue_module_identifier__$2l = undefined;
/* functional template */
const __vue_is_functional_template__$2l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2l,
  staticRenderFns: __vue_staticRenderFns__$2l
}, __vue_inject_styles__$2l, {}, __vue_scope_id__$2l, __vue_is_functional_template__$2l, __vue_module_identifier__$2l, false, undefined, undefined, undefined);

var smallBookmarkDouble = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2l
});

/* script */

/* template */
var __vue_render__$2k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.6 15.2L8.00002 11.2L2.40002 15.2V2.40005C2.40002 1.9757 2.5686 1.56874 2.86865 1.26868C3.16871 0.96862 3.57568 0.800049 4.00002 0.800049H12C12.4244 0.800049 12.8313 0.96862 13.1314 1.26868C13.4315 1.56874 13.6 1.9757 13.6 2.40005V15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2k = [];

/* style */
const __vue_inject_styles__$2k = undefined;
/* scoped */
const __vue_scope_id__$2k = undefined;
/* module identifier */
const __vue_module_identifier__$2k = undefined;
/* functional template */
const __vue_is_functional_template__$2k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2k,
  staticRenderFns: __vue_staticRenderFns__$2k
}, __vue_inject_styles__$2k, {}, __vue_scope_id__$2k, __vue_is_functional_template__$2k, __vue_module_identifier__$2k, false, undefined, undefined, undefined);

var smallBookmark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2k
});

/* script */

/* template */
var __vue_render__$2j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.5998 2.4H2.3998C1.51615 2.4 0.799805 3.11634 0.799805 4V13.6C0.799805 14.4837 1.51615 15.2 2.3998 15.2H13.5998C14.4835 15.2 15.1998 14.4837 15.1998 13.6V4C15.1998 3.11634 14.4835 2.4 13.5998 2.4Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 0.799999V4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 0.799999V4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 7.2H15.1998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2j = [];

/* style */
const __vue_inject_styles__$2j = undefined;
/* scoped */
const __vue_scope_id__$2j = undefined;
/* module identifier */
const __vue_module_identifier__$2j = undefined;
/* functional template */
const __vue_is_functional_template__$2j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2j,
  staticRenderFns: __vue_staticRenderFns__$2j
}, __vue_inject_styles__$2j, {}, __vue_scope_id__$2j, __vue_is_functional_template__$2j, __vue_module_identifier__$2j, false, undefined, undefined, undefined);

var smallCalendarDate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2j
});

/* script */

/* template */
var __vue_render__$2i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-check-1"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M3 9.25L6.75 13L13 3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2i = [];

/* style */
const __vue_inject_styles__$2i = undefined;
/* scoped */
const __vue_scope_id__$2i = undefined;
/* module identifier */
const __vue_module_identifier__$2i = undefined;
/* functional template */
const __vue_is_functional_template__$2i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2i,
  staticRenderFns: __vue_staticRenderFns__$2i
}, __vue_inject_styles__$2i, {}, __vue_scope_id__$2i, __vue_is_functional_template__$2i, __vue_module_identifier__$2i, false, undefined, undefined, undefined);

var smallCheck1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2i
});

/* script */

/* template */
var __vue_render__$2h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M0.799805 8.00005C0.799805 9.90961 1.55837 11.741 2.90864 13.0912C4.2589 14.4415 6.09025 15.2 7.9998 15.2C9.90936 15.2 11.7407 14.4415 13.091 13.0912C14.4412 11.741 15.1998 9.90961 15.1998 8.00005C15.1998 6.09049 14.4412 4.25914 13.091 2.90888C11.7407 1.55862 9.90936 0.800049 7.9998 0.800049C6.09025 0.800049 4.2589 1.55862 2.90864 2.90888C1.55837 4.25914 0.799805 6.09049 0.799805 8.00005V8.00005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.6001 8.80005L7.0001 11.2L11.0001 4.80005",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs')]);
};
var __vue_staticRenderFns__$2h = [];

/* style */
const __vue_inject_styles__$2h = undefined;
/* scoped */
const __vue_scope_id__$2h = undefined;
/* module identifier */
const __vue_module_identifier__$2h = undefined;
/* functional template */
const __vue_is_functional_template__$2h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2h,
  staticRenderFns: __vue_staticRenderFns__$2h
}, __vue_inject_styles__$2h, {}, __vue_scope_id__$2h, __vue_is_functional_template__$2h, __vue_module_identifier__$2h, false, undefined, undefined, undefined);

var smallCheckCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2h
});

/* script */

/* template */
var __vue_render__$2g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.7998 8.79999L7.1998 11.2L11.1998 4.79999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2g = [];

/* style */
const __vue_inject_styles__$2g = undefined;
/* scoped */
const __vue_scope_id__$2g = undefined;
/* module identifier */
const __vue_module_identifier__$2g = undefined;
/* functional template */
const __vue_is_functional_template__$2g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2g,
  staticRenderFns: __vue_staticRenderFns__$2g
}, __vue_inject_styles__$2g, {}, __vue_scope_id__$2g, __vue_is_functional_template__$2g, __vue_module_identifier__$2g, false, undefined, undefined, undefined);

var smallCheck = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2g
});

/* script */

/* template */
var __vue_render__$2f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.7998 6.79999L7.9998 9.99999L11.1998 6.79999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2f = [];

/* style */
const __vue_inject_styles__$2f = undefined;
/* scoped */
const __vue_scope_id__$2f = undefined;
/* module identifier */
const __vue_module_identifier__$2f = undefined;
/* functional template */
const __vue_is_functional_template__$2f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2f,
  staticRenderFns: __vue_staticRenderFns__$2f
}, __vue_inject_styles__$2f, {}, __vue_scope_id__$2f, __vue_is_functional_template__$2f, __vue_module_identifier__$2f, false, undefined, undefined, undefined);

var smallChevronDown = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2f
});

/* script */

/* template */
var __vue_render__$2e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.7998 4.79999L9.9998 7.99999L6.7998 11.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2e = [];

/* style */
const __vue_inject_styles__$2e = undefined;
/* scoped */
const __vue_scope_id__$2e = undefined;
/* module identifier */
const __vue_module_identifier__$2e = undefined;
/* functional template */
const __vue_is_functional_template__$2e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2e,
  staticRenderFns: __vue_staticRenderFns__$2e
}, __vue_inject_styles__$2e, {}, __vue_scope_id__$2e, __vue_is_functional_template__$2e, __vue_module_identifier__$2e, false, undefined, undefined, undefined);

var smallChevronRight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2e
});

/* script */

/* template */
var __vue_render__$2d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-chevron-up"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M4.8 9.2L8 6L11.2 9.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2d = [];

/* style */
const __vue_inject_styles__$2d = undefined;
/* scoped */
const __vue_scope_id__$2d = undefined;
/* module identifier */
const __vue_module_identifier__$2d = undefined;
/* functional template */
const __vue_is_functional_template__$2d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2d,
  staticRenderFns: __vue_staticRenderFns__$2d
}, __vue_inject_styles__$2d, {}, __vue_scope_id__$2d, __vue_is_functional_template__$2d, __vue_module_identifier__$2d, false, undefined, undefined, undefined);

var smallChevronUp = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2d
});

/* script */

/* template */
var __vue_render__$2c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-dashboard-1"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M15.2 14.4H9.59999M9.59999 10.4H15.2M0.799988 0.800049H6.39999V6.40005H0.799988V0.800049ZM15.2 6.40005H9.59999L12.2512 0.800049L15.2 6.40005ZM0.799988 12.4C0.799988 13.1427 1.09499 13.8548 1.62009 14.3799C2.14519 14.9051 2.85738 15.2 3.59999 15.2C4.34259 15.2 5.05479 14.9051 5.57989 14.3799C6.10499 13.8548 6.39999 13.1427 6.39999 12.4C6.39999 11.6574 6.10499 10.9453 5.57989 10.4201C5.05479 9.89505 4.34259 9.60005 3.59999 9.60005C2.85738 9.60005 2.14519 9.89505 1.62009 10.4201C1.09499 10.9453 0.799988 11.6574 0.799988 12.4Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2c = [];

/* style */
const __vue_inject_styles__$2c = undefined;
/* scoped */
const __vue_scope_id__$2c = undefined;
/* module identifier */
const __vue_module_identifier__$2c = undefined;
/* functional template */
const __vue_is_functional_template__$2c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2c,
  staticRenderFns: __vue_staticRenderFns__$2c
}, __vue_inject_styles__$2c, {}, __vue_scope_id__$2c, __vue_is_functional_template__$2c, __vue_module_identifier__$2c, false, undefined, undefined, undefined);

var smallDashboard1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2c
});

/* script */

/* template */
var __vue_render__$2b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.81799 2.81802L9.18195 9.18198M2.81799 9.18198L9.18195 2.81802",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$2b = [];

/* style */
const __vue_inject_styles__$2b = undefined;
/* scoped */
const __vue_scope_id__$2b = undefined;
/* module identifier */
const __vue_module_identifier__$2b = undefined;
/* functional template */
const __vue_is_functional_template__$2b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2b,
  staticRenderFns: __vue_staticRenderFns__$2b
}, __vue_inject_styles__$2b, {}, __vue_scope_id__$2b, __vue_is_functional_template__$2b, __vue_module_identifier__$2b, false, undefined, undefined, undefined);

var smallDelete1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2b
});

/* script */

/* template */
var __vue_render__$2a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "17",
      "viewBox": "0 0 16 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-delete-2"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M10.3996 6.1001L5.59961 10.9001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M5.59961 6.1001L10.3996 10.9001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$2a = [];

/* style */
const __vue_inject_styles__$2a = undefined;
/* scoped */
const __vue_scope_id__$2a = undefined;
/* module identifier */
const __vue_module_identifier__$2a = undefined;
/* functional template */
const __vue_is_functional_template__$2a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2a,
  staticRenderFns: __vue_staticRenderFns__$2a
}, __vue_inject_styles__$2a, {}, __vue_scope_id__$2a, __vue_is_functional_template__$2a, __vue_module_identifier__$2a, false, undefined, undefined, undefined);

var smallDelete2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2a
});

/* script */

/* template */
var __vue_render__$29 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-delete-bin-1"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M1.2002 4.00635H14.8002",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M11.5998 15.2H4.3998C3.97546 15.2 3.56849 15.0314 3.26843 14.7314C2.96838 14.4313 2.7998 14.0243 2.7998 13.6V4H13.1998V13.6C13.1998 14.0243 13.0312 14.4313 12.7312 14.7314C12.4311 15.0314 12.0242 15.2 11.5998 15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_3",
      "d": "M5.13281 3.9998V3.6334C5.13281 2.88189 5.43135 2.16115 5.96275 1.62975C6.49416 1.09834 7.2149 0.799805 7.96641 0.799805C8.71793 0.799805 9.43867 1.09834 9.97007 1.62975C10.5015 2.16115 10.8 2.88189 10.8 3.6334V3.9998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$29 = [];

/* style */
const __vue_inject_styles__$29 = undefined;
/* scoped */
const __vue_scope_id__$29 = undefined;
/* module identifier */
const __vue_module_identifier__$29 = undefined;
/* functional template */
const __vue_is_functional_template__$29 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$29 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$29,
  staticRenderFns: __vue_staticRenderFns__$29
}, __vue_inject_styles__$29, {}, __vue_scope_id__$29, __vue_is_functional_template__$29, __vue_module_identifier__$29, false, undefined, undefined, undefined);

var smallDeleteBin1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$29
});

/* script */

/* template */
var __vue_render__$28 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_72_3377)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.3996 5.6001L5.59961 10.4001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59961 5.6001L10.3996 10.4001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 8.00005C0.799805 9.90961 1.55837 11.741 2.90864 13.0912C4.2589 14.4415 6.09025 15.2 7.9998 15.2C9.90936 15.2 11.7407 14.4415 13.091 13.0912C14.4412 11.741 15.1998 9.90961 15.1998 8.00005C15.1998 6.09049 14.4412 4.25914 13.091 2.90888C11.7407 1.55862 9.90936 0.800049 7.9998 0.800049C6.09025 0.800049 4.2589 1.55862 2.90864 2.90888C1.55837 4.25914 0.799805 6.09049 0.799805 8.00005V8.00005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_72_3377"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$28 = [];

/* style */
const __vue_inject_styles__$28 = undefined;
/* scoped */
const __vue_scope_id__$28 = undefined;
/* module identifier */
const __vue_module_identifier__$28 = undefined;
/* functional template */
const __vue_is_functional_template__$28 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$28 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$28,
  staticRenderFns: __vue_staticRenderFns__$28
}, __vue_inject_styles__$28, {}, __vue_scope_id__$28, __vue_is_functional_template__$28, __vue_module_identifier__$28, false, undefined, undefined, undefined);

var smallDeleteCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$28
});

/* script */

/* template */
var __vue_render__$27 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.4001 5.59998L5.6001 10.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.6001 5.59998L10.4001 10.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$27 = [];

/* style */
const __vue_inject_styles__$27 = undefined;
/* scoped */
const __vue_scope_id__$27 = undefined;
/* module identifier */
const __vue_module_identifier__$27 = undefined;
/* functional template */
const __vue_is_functional_template__$27 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$27 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$27,
  staticRenderFns: __vue_staticRenderFns__$27
}, __vue_inject_styles__$27, {}, __vue_scope_id__$27, __vue_is_functional_template__$27, __vue_module_identifier__$27, false, undefined, undefined, undefined);

var smallDelete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$27
});

/* script */

/* template */
var __vue_render__$26 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 0.799805V10.3998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.1998 7.19971L7.9998 10.3997L4.7998 7.19971",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 12V13.6C0.799805 14.0244 0.968376 14.4313 1.26843 14.7314C1.56849 15.0314 1.97545 15.2 2.3998 15.2H13.5998C14.0242 15.2 14.4311 15.0314 14.7312 14.7314C15.0312 14.4313 15.1998 14.0244 15.1998 13.6V12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$26 = [];

/* style */
const __vue_inject_styles__$26 = undefined;
/* scoped */
const __vue_scope_id__$26 = undefined;
/* module identifier */
const __vue_module_identifier__$26 = undefined;
/* functional template */
const __vue_is_functional_template__$26 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$26 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$26,
  staticRenderFns: __vue_staticRenderFns__$26
}, __vue_inject_styles__$26, {}, __vue_scope_id__$26, __vue_is_functional_template__$26, __vue_module_identifier__$26, false, undefined, undefined, undefined);

var smallDownloadButton2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$26
});

/* script */

/* template */
var __vue_render__$25 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "10.5",
      "cy": "1.5",
      "r": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "10.5",
      "cy": "8",
      "r": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "10.5",
      "cy": "14.5",
      "r": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "5.5",
      "cy": "1.5",
      "r": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "5.5",
      "cy": "8",
      "r": "1.5",
      "fill": "black"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "fill-override",
    attrs: {
      "cx": "5.5",
      "cy": "14.5",
      "r": "1.5",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$25 = [];

/* style */
const __vue_inject_styles__$25 = undefined;
/* scoped */
const __vue_scope_id__$25 = undefined;
/* module identifier */
const __vue_module_identifier__$25 = undefined;
/* functional template */
const __vue_is_functional_template__$25 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$25 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$25,
  staticRenderFns: __vue_staticRenderFns__$25
}, __vue_inject_styles__$25, {}, __vue_scope_id__$25, __vue_is_functional_template__$25, __vue_module_identifier__$25, false, undefined, undefined, undefined);

var smallDragHandleVertical = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$25
});

/* script */

/* template */
var __vue_render__$24 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_801_482)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 1.8C0.799805 1.24772 1.24752 0.800003 1.7998 0.800003H10.9998C11.5521 0.800003 11.9998 1.24772 11.9998 1.8V11C11.9998 11.5523 11.5521 12 10.9998 12H1.7998C1.24752 12 0.799805 11.5523 0.799805 11V1.8Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.12305 15.2C4.12305 15.2 9.52747 15.2 13.2017 15.2C14.3063 15.2 15.1998 14.3046 15.1998 13.2V4.1232",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_801_482"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$24 = [];

/* style */
const __vue_inject_styles__$24 = undefined;
/* scoped */
const __vue_scope_id__$24 = undefined;
/* module identifier */
const __vue_module_identifier__$24 = undefined;
/* functional template */
const __vue_is_functional_template__$24 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$24 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$24,
  staticRenderFns: __vue_staticRenderFns__$24
}, __vue_inject_styles__$24, {}, __vue_scope_id__$24, __vue_is_functional_template__$24, __vue_module_identifier__$24, false, undefined, undefined, undefined);

var smallEditCopy = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$24
});

/* script */

/* template */
var __vue_render__$23 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_72_3431)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.95187 14.048L0.851074 15.168L1.97107 10.0656L10.8703 1.1296C11.106 0.925565 11.4127 0.822863 11.7237 0.843838C12.0348 0.864813 12.3249 1.00777 12.5311 1.2416L14.7471 3.456C14.9816 3.66248 15.1249 3.95342 15.1456 4.26522C15.1663 4.57702 15.0627 4.88434 14.8575 5.12L5.95187 14.048Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_72_3431"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$23 = [];

/* style */
const __vue_inject_styles__$23 = undefined;
/* scoped */
const __vue_scope_id__$23 = undefined;
/* module identifier */
const __vue_module_identifier__$23 = undefined;
/* functional template */
const __vue_is_functional_template__$23 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$23 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$23,
  staticRenderFns: __vue_staticRenderFns__$23
}, __vue_inject_styles__$23, {}, __vue_scope_id__$23, __vue_is_functional_template__$23, __vue_module_identifier__$23, false, undefined, undefined, undefined);

var smallEditPencil = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$23
});

/* script */

/* template */
var __vue_render__$22 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_72_3477)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.6 5.9888C14.0608 6.3754 14.4969 6.79062 14.9056 7.232C15.0944 7.43115 15.1997 7.69515 15.1997 7.9696C15.1997 8.24405 15.0944 8.50804 14.9056 8.7072C13.7376 9.968 11.0848 12.4 8 12.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.39999 9.9616C1.94102 9.56893 1.5051 9.1501 1.09439 8.7072C0.905555 8.50804 0.800293 8.24405 0.800293 7.9696C0.800293 7.69515 0.905555 7.43115 1.09439 7.232C2.83606 5.16901 5.31326 3.86612 7.99999 3.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.2002 14.8L14.8002 1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_72_3477"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$22 = [];

/* style */
const __vue_inject_styles__$22 = undefined;
/* scoped */
const __vue_scope_id__$22 = undefined;
/* module identifier */
const __vue_module_identifier__$22 = undefined;
/* functional template */
const __vue_is_functional_template__$22 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$22 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$22,
  staticRenderFns: __vue_staticRenderFns__$22
}, __vue_inject_styles__$22, {}, __vue_scope_id__$22, __vue_is_functional_template__$22, __vue_module_identifier__$22, false, undefined, undefined, undefined);

var smallEditViewOff = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$22
});

/* script */

/* template */
var __vue_render__$21 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.9056 7.232C15.0944 7.43115 15.1997 7.69515 15.1997 7.9696C15.1997 8.24405 15.0944 8.50804 14.9056 8.7072C13.7376 9.968 11 12.4 7.99999 12.4C5 12.4 2.26239 9.968 1.09439 8.7072C0.905555 8.50804 0.800293 8.24405 0.800293 7.9696C0.800293 7.69515 0.905555 7.43115 1.09439 7.232C2.83606 5.16901 5 3.6 7.99999 3.6C11 3.6 13.1639 5.16901 14.9056 7.232Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6 8C6 8.53043 6.21071 9.03914 6.58579 9.41421C6.96086 9.78929 7.46957 10 8 10C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8C10 7.46957 9.78929 6.96086 9.41421 6.58579C9.03914 6.21071 8.53043 6 8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$21 = [];

/* style */
const __vue_inject_styles__$21 = undefined;
/* scoped */
const __vue_scope_id__$21 = undefined;
/* module identifier */
const __vue_module_identifier__$21 = undefined;
/* functional template */
const __vue_is_functional_template__$21 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$21 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$21,
  staticRenderFns: __vue_staticRenderFns__$21
}, __vue_inject_styles__$21, {}, __vue_scope_id__$21, __vue_is_functional_template__$21, __vue_module_identifier__$21, false, undefined, undefined, undefined);

var smallEditView = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$21
});

/* script */

/* template */
var __vue_render__$20 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0V0ZM9 12C9 12.2652 8.89465 12.5196 8.70711 12.7071C8.51957 12.8946 8.26522 13 8 13C7.73479 13 7.48043 12.8946 7.2929 12.7071C7.10536 12.5196 7 12.2652 7 12V8.8C7 8.53478 7.10536 8.28043 7.2929 8.09289C7.48043 7.90536 7.73479 7.8 8 7.8C8.26522 7.8 8.51957 7.90536 8.70711 8.09289C8.89465 8.28043 9 8.53478 9 8.8V12ZM8 6.4C7.68355 6.4 7.37421 6.30616 7.11109 6.13035C6.84797 5.95454 6.6429 5.70466 6.5218 5.41229C6.4007 5.11993 6.36901 4.79823 6.43075 4.48786C6.49248 4.17749 6.64487 3.89239 6.86863 3.66863C7.0924 3.44487 7.37749 3.29248 7.68786 3.23074C7.99823 3.16901 8.31994 3.20069 8.6123 3.32179C8.90466 3.44289 9.15454 3.64797 9.33036 3.91109C9.50617 4.17421 9.6 4.48355 9.6 4.8C9.6 5.22435 9.43143 5.63131 9.13137 5.93137C8.83132 6.23143 8.42435 6.4 8 6.4Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$20 = [];

/* style */
const __vue_inject_styles__$20 = undefined;
/* scoped */
const __vue_scope_id__$20 = undefined;
/* module identifier */
const __vue_module_identifier__$20 = undefined;
/* functional template */
const __vue_is_functional_template__$20 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$20 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$20,
  staticRenderFns: __vue_staticRenderFns__$20
}, __vue_inject_styles__$20, {}, __vue_scope_id__$20, __vue_is_functional_template__$20, __vue_module_identifier__$20, false, undefined, undefined, undefined);

var smallExclamationMark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$20
});

/* script */

/* template */
var __vue_render__$1$ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-file-accept"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M8.10098 15.1998H12.501C13.1637 15.1998 13.701 14.6625 13.701 13.9998V6.3998L8.10098 0.799805H3.70098C3.03823 0.799805 2.50098 1.33706 2.50098 1.9998V7.9998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_2",
      "d": "M8.10059 0.799805V6.3998H13.7006",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_3",
      "d": "M1 13L3 15L7 11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$1$ = [];

/* style */
const __vue_inject_styles__$1$ = undefined;
/* scoped */
const __vue_scope_id__$1$ = undefined;
/* module identifier */
const __vue_module_identifier__$1$ = undefined;
/* functional template */
const __vue_is_functional_template__$1$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1$,
  staticRenderFns: __vue_staticRenderFns__$1$
}, __vue_inject_styles__$1$, {}, __vue_scope_id__$1$, __vue_is_functional_template__$1$, __vue_module_identifier__$1$, false, undefined, undefined, undefined);

var smallFileAccept = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1$
});

/* script */

/* template */
var __vue_render__$1_ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.5 15.2H12.501C13.1637 15.2 13.701 14.6627 13.701 14V6.4L8.10098 0.800003H3.70098C3.03823 0.800003 2.50098 1.33726 2.50098 2V6.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.10059 0.800003V6.4H13.7006",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.09923 14.0112L3.73923 9.25921C3.80854 9.13455 3.90991 9.03069 4.03284 8.95838C4.15578 8.88608 4.29581 8.84795 4.43843 8.84795C4.58106 8.84795 4.72109 8.88608 4.84402 8.95838C4.96696 9.03069 5.06833 9.13455 5.13763 9.25921L7.77763 14.0112C7.84529 14.1329 7.88002 14.2701 7.87841 14.4093C7.8768 14.5485 7.8389 14.6848 7.76844 14.8049C7.69799 14.925 7.59743 15.0246 7.4767 15.0938C7.35596 15.1631 7.21924 15.1997 7.08003 15.2H1.80003C1.66069 15.2 1.52377 15.1636 1.40281 15.0944C1.28186 15.0253 1.18107 14.9257 1.11043 14.8056C1.03979 14.6855 1.00174 14.549 1.00006 14.4097C0.998375 14.2703 1.03311 14.133 1.10083 14.0112H1.09923Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1_ = [];

/* style */
const __vue_inject_styles__$1_ = undefined;
/* scoped */
const __vue_scope_id__$1_ = undefined;
/* module identifier */
const __vue_module_identifier__$1_ = undefined;
/* functional template */
const __vue_is_functional_template__$1_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1_,
  staticRenderFns: __vue_staticRenderFns__$1_
}, __vue_inject_styles__$1_, {}, __vue_scope_id__$1_, __vue_is_functional_template__$1_, __vue_module_identifier__$1_, false, undefined, undefined, undefined);

var smallFileAlert = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1_
});

/* script */

/* template */
var __vue_render__$1Z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.10098 15.1998H12.501C13.1637 15.1998 13.701 14.6625 13.701 13.9998V6.3998L8.10098 0.799805H3.70098C3.03823 0.799805 2.50098 1.33706 2.50098 1.9998V7.9998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.10059 0.799805V6.3998H13.7006",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 11L5 15",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 11L1 15",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1Z = [];

/* style */
const __vue_inject_styles__$1Z = undefined;
/* scoped */
const __vue_scope_id__$1Z = undefined;
/* module identifier */
const __vue_module_identifier__$1Z = undefined;
/* functional template */
const __vue_is_functional_template__$1Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Z,
  staticRenderFns: __vue_staticRenderFns__$1Z
}, __vue_inject_styles__$1Z, {}, __vue_scope_id__$1Z, __vue_is_functional_template__$1Z, __vue_module_identifier__$1Z, false, undefined, undefined, undefined);

var smallFileReject = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1Z
});

/* script */

/* template */
var __vue_render__$1Y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 11.0544V0.799988",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.7998 3.99999L7.9998 0.799988L11.1998 3.99999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 12V13.6C0.799805 14.0244 0.968376 14.4313 1.26843 14.7314C1.56849 15.0314 1.97545 15.2 2.3998 15.2H13.5998C14.0242 15.2 14.4311 15.0314 14.7312 14.7314C15.0312 14.4313 15.1998 14.0244 15.1998 13.6V12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1Y = [];

/* style */
const __vue_inject_styles__$1Y = undefined;
/* scoped */
const __vue_scope_id__$1Y = undefined;
/* module identifier */
const __vue_module_identifier__$1Y = undefined;
/* functional template */
const __vue_is_functional_template__$1Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Y,
  staticRenderFns: __vue_staticRenderFns__$1Y
}, __vue_inject_styles__$1Y, {}, __vue_scope_id__$1Y, __vue_is_functional_template__$1Y, __vue_module_identifier__$1Y, false, undefined, undefined, undefined);

var smallFileUpload = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1Y
});

/* script */

/* template */
var __vue_render__$1X = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.701 14.2C13.701 14.7523 13.2533 15.2 12.701 15.2H3.50098C2.94869 15.2 2.50098 14.7523 2.50098 14.2V1.80005C2.50098 1.24776 2.94869 0.800049 3.50098 0.800049H7.68676C7.95198 0.800049 8.20633 0.905406 8.39387 1.09294L13.4081 6.10716C13.5956 6.29469 13.701 6.54905 13.701 6.81426V14.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.10107 1V6.40005H13.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1X = [];

/* style */
const __vue_inject_styles__$1X = undefined;
/* scoped */
const __vue_scope_id__$1X = undefined;
/* module identifier */
const __vue_module_identifier__$1X = undefined;
/* functional template */
const __vue_is_functional_template__$1X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1X,
  staticRenderFns: __vue_staticRenderFns__$1X
}, __vue_inject_styles__$1X, {}, __vue_scope_id__$1X, __vue_is_functional_template__$1X, __vue_module_identifier__$1X, false, undefined, undefined, undefined);

var smallFile = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1X
});

/* script */

/* template */
var __vue_render__$1W = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 7.99999C0.799805 9.90955 1.55837 11.7409 2.90864 13.0912C4.2589 14.4414 6.09025 15.2 7.9998 15.2C9.90936 15.2 11.7407 14.4414 13.091 13.0912C14.4412 11.7409 15.1998 9.90955 15.1998 7.99999C15.1998 6.09043 14.4412 4.25908 13.091 2.90882C11.7407 1.55856 9.90936 0.799988 7.9998 0.799988C6.09025 0.799988 4.2589 1.55856 2.90864 2.90882C1.55837 4.25908 0.799805 6.09043 0.799805 7.99999V7.99999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.9999 8C8.34082 8 8.67607 7.91286 8.97383 7.74684C9.27159 7.58083 9.52198 7.34146 9.7012 7.05146C9.88043 6.76147 9.98256 6.43047 9.99788 6.0899C10.0132 5.74933 9.94122 5.4105 9.78876 5.10557C9.6363 4.80065 9.40842 4.53976 9.12677 4.34768C8.84512 4.1556 8.51905 4.0387 8.17951 4.00808C7.83998 3.97747 7.49825 4.03415 7.18679 4.17275C6.87532 4.31135 6.60445 4.52727 6.3999 4.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12C7.72385 12 7.5 11.7761 7.5 11.5C7.5 11.2239 7.72385 11 8 11"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12C8.27615 12 8.5 11.7761 8.5 11.5C8.5 11.2239 8.27615 11 8 11"
    }
  })]);
};
var __vue_staticRenderFns__$1W = [];

/* style */
const __vue_inject_styles__$1W = undefined;
/* scoped */
const __vue_scope_id__$1W = undefined;
/* module identifier */
const __vue_module_identifier__$1W = undefined;
/* functional template */
const __vue_is_functional_template__$1W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1W,
  staticRenderFns: __vue_staticRenderFns__$1W
}, __vue_inject_styles__$1W, {}, __vue_scope_id__$1W, __vue_is_functional_template__$1W, __vue_module_identifier__$1W, false, undefined, undefined, undefined);

var smallHelpQuestionCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1W
});

/* script */

/* template */
var __vue_render__$1V = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15.2001C9.48844 15.1908 10.9127 14.593 11.962 13.5372C13.0112 12.4814 13.6 11.0533 13.6 9.56488V6.43528C13.6015 5.55494 13.3954 4.68665 12.9984 3.90088",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.40003 7.68799V9.56479C2.38982 11.064 2.97372 12.5062 4.02403 13.576",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.2 1.26238C8.93179 0.714409 7.50642 0.651565 6.19488 1.08579C4.88334 1.52002 3.77708 2.42105 3.08643 3.61758",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.23999 4.59201C6.66051 4.27655 7.16013 4.08363 7.68353 4.03462C8.20693 3.98561 8.73368 4.08242 9.20545 4.31433C9.67722 4.54624 10.0756 4.9042 10.3565 5.34857C10.6373 5.79293 10.7897 6.30637 10.7968 6.83201V8.68801",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.37604 11.6128C8.86219 11.91 8.26754 12.0373 7.67704 11.9764C7.08654 11.9155 6.53039 11.6695 6.08804 11.2736C5.79941 11.0069 5.57092 10.6817 5.4178 10.3197C5.26468 9.95774 5.19045 9.5673 5.20004 9.1744V8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 7.19995V8.79995",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1V = [];

/* style */
const __vue_inject_styles__$1V = undefined;
/* scoped */
const __vue_scope_id__$1V = undefined;
/* module identifier */
const __vue_module_identifier__$1V = undefined;
/* functional template */
const __vue_is_functional_template__$1V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1V,
  staticRenderFns: __vue_staticRenderFns__$1V
}, __vue_inject_styles__$1V, {}, __vue_scope_id__$1V, __vue_is_functional_template__$1V, __vue_module_identifier__$1V, false, undefined, undefined, undefined);

var smallIdThumbMark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1V
});

/* script */

/* template */
var __vue_render__$1U = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.9998 15.2C11.9763 15.2 15.1998 11.9765 15.1998 8.00005C15.1998 4.0236 11.9763 0.800049 7.9998 0.800049C4.02336 0.800049 0.799805 4.0236 0.799805 8.00005C0.799805 11.9765 4.02336 15.2 7.9998 15.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12V8.80005",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.9999 5.74724C7.66853 5.74724 7.3999 5.47862 7.3999 5.14724C7.3999 4.81587 7.66853 4.54724 7.9999 4.54724"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 5.74724C8.33138 5.74724 8.6 5.47862 8.6 5.14724C8.6 4.81587 8.33138 4.54724 8 4.54724"
    }
  })]);
};
var __vue_staticRenderFns__$1U = [];

/* style */
const __vue_inject_styles__$1U = undefined;
/* scoped */
const __vue_scope_id__$1U = undefined;
/* module identifier */
const __vue_module_identifier__$1U = undefined;
/* functional template */
const __vue_is_functional_template__$1U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1U,
  staticRenderFns: __vue_staticRenderFns__$1U
}, __vue_inject_styles__$1U, {}, __vue_scope_id__$1U, __vue_is_functional_template__$1U, __vue_module_identifier__$1U, false, undefined, undefined, undefined);

var smallInfoCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1U
});

/* script */

/* template */
var __vue_render__$1T = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.8002 5.60005C12.8002 9.60005 8.0002 15.2 8.0002 15.2C8.0002 15.2 3.2002 9.60005 3.2002 5.60005C3.2002 4.32701 3.70591 3.10611 4.60608 2.20594C5.50626 1.30576 6.72716 0.800049 8.0002 0.800049C9.27323 0.800049 10.4941 1.30576 11.3943 2.20594C12.2945 3.10611 12.8002 4.32701 12.8002 5.60005V5.60005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6.40039 5.6C6.40039 6.02435 6.56896 6.43131 6.86902 6.73137C7.16908 7.03143 7.57604 7.2 8.00039 7.2C8.42474 7.2 8.8317 7.03143 9.13176 6.73137C9.43182 6.43131 9.60039 6.02435 9.60039 5.6C9.60039 5.17565 9.43182 4.76869 9.13176 4.46863C8.8317 4.16857 8.42474 4 8.00039 4C7.57604 4 7.16908 4.16857 6.86902 4.46863C6.56896 4.76869 6.40039 5.17565 6.40039 5.6V5.6Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$1T = [];

/* style */
const __vue_inject_styles__$1T = undefined;
/* scoped */
const __vue_scope_id__$1T = undefined;
/* module identifier */
const __vue_module_identifier__$1T = undefined;
/* functional template */
const __vue_is_functional_template__$1T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1T,
  staticRenderFns: __vue_staticRenderFns__$1T
}, __vue_inject_styles__$1T, {}, __vue_scope_id__$1T, __vue_is_functional_template__$1T, __vue_module_identifier__$1T, false, undefined, undefined, undefined);

var smallLocationPin = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1T
});

/* script */

/* template */
var __vue_render__$1S = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.3999 8.70001C2.3999 7.87159 3.07148 7.20001 3.8999 7.20001H12.0999C12.9283 7.20001 13.5999 7.87159 13.5999 8.70001V13.7C13.5999 14.5284 12.9283 15.2 12.0999 15.2H3.8999C3.07147 15.2 2.3999 14.5284 2.3999 13.7V8.70001Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6.7998 11.2C6.7998 11.5183 6.92623 11.8235 7.15128 12.0485C7.37632 12.2736 7.68154 12.4 7.9998 12.4C8.31806 12.4 8.62329 12.2736 8.84833 12.0485C9.07338 11.8235 9.1998 11.5183 9.1998 11.2C9.1998 10.8817 9.07338 10.5765 8.84833 10.3515C8.62329 10.1264 8.31806 10 7.9998 10C7.68154 10 7.37632 10.1264 7.15128 10.3515C6.92623 10.5765 6.7998 10.8817 6.7998 11.2Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 7.19999V4.79999C4 3.73912 4.42143 2.72171 5.17157 1.97156C5.92172 1.22142 6.93913 0.799988 8 0.799988C9.06087 0.799988 10.0783 1.22142 10.8284 1.97156C11.5786 2.72171 12 3.73912 12 4.79999V7.19999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1S = [];

/* style */
const __vue_inject_styles__$1S = undefined;
/* scoped */
const __vue_scope_id__$1S = undefined;
/* module identifier */
const __vue_module_identifier__$1S = undefined;
/* functional template */
const __vue_is_functional_template__$1S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1S,
  staticRenderFns: __vue_staticRenderFns__$1S
}, __vue_inject_styles__$1S, {}, __vue_scope_id__$1S, __vue_is_functional_template__$1S, __vue_module_identifier__$1S, false, undefined, undefined, undefined);

var smallLock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1S
});

/* script */

/* template */
var __vue_render__$1R = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-logout"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M5 8L14 8M14 8L12 6M14 8L12 10M10 12V14.2222C10 14.4285 9.92098 14.6263 9.78033 14.7722C9.63968 14.9181 9.44891 15 9.25 15H1.75C1.55109 15 1.36032 14.9181 1.21967 14.7722C1.07902 14.6263 1 14.4285 1 14.2222V1.77778C1 1.5715 1.07902 1.37367 1.21967 1.22781C1.36032 1.08194 1.55109 1 1.75 1H9.25C9.44891 1 9.63968 1.08194 9.78033 1.22781C9.92098 1.37367 10 1.5715 10 1.77778V4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$1R = [];

/* style */
const __vue_inject_styles__$1R = undefined;
/* scoped */
const __vue_scope_id__$1R = undefined;
/* module identifier */
const __vue_module_identifier__$1R = undefined;
/* functional template */
const __vue_is_functional_template__$1R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1R,
  staticRenderFns: __vue_staticRenderFns__$1R
}, __vue_inject_styles__$1R, {}, __vue_scope_id__$1R, __vue_is_functional_template__$1R, __vue_module_identifier__$1R, false, undefined, undefined, undefined);

var smallLogout = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1R
});

/* script */

/* template */
var __vue_render__$1Q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 3.6001C0.799805 2.49553 1.69524 1.6001 2.7998 1.6001H13.1998C14.3044 1.6001 15.1998 2.49553 15.1998 3.6001V12.4001C15.1998 13.5047 14.3044 14.4001 13.1998 14.4001H2.79981C1.69524 14.4001 0.799805 13.5047 0.799805 12.4001V3.6001Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 3.2002L6.9678 8.405C7.25648 8.64865 7.62205 8.7823 7.9998 8.7823C8.37756 8.7823 8.74313 8.64865 9.0318 8.405L15.1998 3.2002",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1Q = [];

/* style */
const __vue_inject_styles__$1Q = undefined;
/* scoped */
const __vue_scope_id__$1Q = undefined;
/* module identifier */
const __vue_module_identifier__$1Q = undefined;
/* functional template */
const __vue_is_functional_template__$1Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1Q, {}, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, undefined, undefined, undefined);

var smallMailSendEnvelope = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1Q
});

/* script */

/* template */
var __vue_render__$1P = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 4.80005H15.1998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 11.2H15.1998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.7999 0.800049L10.3999 15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.4 0.800049L4 15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1P = [];

/* style */
const __vue_inject_styles__$1P = undefined;
/* scoped */
const __vue_scope_id__$1P = undefined;
/* module identifier */
const __vue_module_identifier__$1P = undefined;
/* functional template */
const __vue_is_functional_template__$1P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1P, {}, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, undefined, undefined, undefined);

var smallMailSignHashtag = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1P
});

/* script */

/* template */
var __vue_render__$1O = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-message-warning"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector",
      "d": "M13.5998 0.0500488C13.1856 0.0500488 12.8498 0.385835 12.8498 0.800049C12.8498 1.21426 13.1856 1.55005 13.5998 1.55005V0.0500488ZM14.7312 1.26868L15.2615 0.738357L15.2615 0.738342L14.7312 1.26868ZM14.7312 11.5314L15.2615 12.0618L15.2615 12.0617L14.7312 11.5314ZM7.9998 12V11.25C7.8295 11.25 7.66427 11.308 7.53128 11.4144L7.9998 12ZM3.9998 15.2H3.2498C3.2498 15.4884 3.41506 15.7511 3.67491 15.876C3.93476 16.0009 4.2432 15.9658 4.46833 15.7857L3.9998 15.2ZM3.9998 12H4.7498C4.7498 11.5858 4.41402 11.25 3.9998 11.25V12ZM1.26843 11.5314L0.738098 12.0617L0.738113 12.0618L1.26843 11.5314ZM1.26843 1.26868L0.738105 0.738346L0.738102 0.738349L1.26843 1.26868ZM2.3998 1.55005C2.81402 1.55005 3.1498 1.21426 3.1498 0.800049C3.1498 0.385835 2.81402 0.0500488 2.3998 0.0500488V1.55005ZM8.75 0.800049C8.75 0.385835 8.41421 0.0500488 8 0.0500488C7.58579 0.0500488 7.25 0.385835 7.25 0.800049H8.75ZM7.25 4.00005C7.25 4.41426 7.58579 4.75005 8 4.75005C8.41421 4.75005 8.75 4.41426 8.75 4.00005H7.25ZM13.5998 1.55005C13.8252 1.55005 14.0414 1.6396 14.2009 1.79901L15.2615 0.738342C14.8208 0.29764 14.2231 0.0500488 13.5998 0.0500488V1.55005ZM14.2008 1.799C14.3603 1.95841 14.4498 2.17462 14.4498 2.40005H15.9498C15.9498 1.77678 15.7022 1.17906 15.2615 0.738357L14.2008 1.799ZM14.4498 2.40005V10.4H15.9498V2.40005H14.4498ZM14.4498 10.4C14.4498 10.6255 14.3603 10.8417 14.2008 11.0011L15.2615 12.0617C15.7022 11.621 15.9498 11.0233 15.9498 10.4H14.4498ZM14.2009 11.0011C14.0414 11.1605 13.8252 11.25 13.5998 11.25V12.75C14.2231 12.75 14.8208 12.5024 15.2615 12.0618L14.2009 11.0011ZM13.5998 11.25H7.9998V12.75H13.5998V11.25ZM7.53128 11.4144L3.53128 14.6144L4.46833 15.7857L8.46833 12.5857L7.53128 11.4144ZM4.7498 15.2V12H3.2498V15.2H4.7498ZM3.9998 11.25H2.3998V12.75H3.9998V11.25ZM2.3998 11.25C2.17437 11.25 1.95817 11.1605 1.79875 11.0011L0.738113 12.0618C1.17882 12.5025 1.77653 12.75 2.3998 12.75V11.25ZM1.79877 11.0011C1.63936 10.8417 1.5498 10.6255 1.5498 10.4H0.0498047C0.0498047 11.0233 0.297396 11.621 0.738098 12.0617L1.79877 11.0011ZM1.5498 10.4V2.40005H0.0498047V10.4H1.5498ZM1.5498 2.40005C1.5498 2.17461 1.63936 1.95842 1.79876 1.79901L0.738102 0.738349C0.297395 1.17906 0.0498047 1.77678 0.0498047 2.40005H1.5498ZM1.79876 1.79901C1.95817 1.6396 2.17437 1.55005 2.3998 1.55005V0.0500488C1.77654 0.0500488 1.17881 0.297639 0.738105 0.738346L1.79876 1.79901ZM7.25 0.800049V4.00005H8.75V0.800049H7.25ZM7.9999 7.8499C8.08274 7.8499 8.1499 7.91706 8.1499 7.9999H6.6499C6.6499 8.74549 7.25431 9.3499 7.9999 9.3499V7.8499ZM8.1499 7.9999C8.1499 8.08274 8.08274 8.1499 7.9999 8.1499V6.6499C7.25431 6.6499 6.6499 7.25431 6.6499 7.9999H8.1499ZM7.9999 9.3499C8.74533 9.3499 9.35 8.74565 9.35 7.9999H7.85C7.85 7.91691 7.91722 7.8499 7.9999 7.8499V9.3499ZM9.35 7.9999C9.35 7.25415 8.74533 6.6499 7.9999 6.6499V8.1499C7.91722 8.1499 7.85 8.0829 7.85 7.9999H9.35Z",
      "fill": "currentColor"
    }
  })])]);
};
var __vue_staticRenderFns__$1O = [];

/* style */
const __vue_inject_styles__$1O = undefined;
/* scoped */
const __vue_scope_id__$1O = undefined;
/* module identifier */
const __vue_module_identifier__$1O = undefined;
/* functional template */
const __vue_is_functional_template__$1O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1O, {}, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, undefined, undefined, undefined);

var smallMessageWarning = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1O
});

/* script */

/* template */
var __vue_render__$1N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.6 2.3999H2.40005C1.51639 2.3999 0.800049 3.11625 0.800049 3.9999V11.9999C0.800049 12.8836 1.51639 13.5999 2.40005 13.5999H13.6C14.4837 13.5999 15.2 12.8836 15.2 11.9999V3.9999C15.2 3.11625 14.4837 2.3999 13.6 2.3999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.800049 6.3999H15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.2001 10.3999H12.0001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1N = [];

/* style */
const __vue_inject_styles__$1N = undefined;
/* scoped */
const __vue_scope_id__$1N = undefined;
/* module identifier */
const __vue_module_identifier__$1N = undefined;
/* functional template */
const __vue_is_functional_template__$1N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1N, {}, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, undefined, undefined, undefined);

var smallMoneyAtmCard1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1N
});

/* script */

/* template */
var __vue_render__$1M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.5472 6.39996H1.45283C1.32649 6.41651 1.19825 6.39011 1.08873 6.32498C0.979212 6.25986 0.89477 6.1598 0.84898 6.0409C0.80319 5.92199 0.79871 5.79114 0.836262 5.66938C0.873814 5.54762 0.951215 5.44202 1.05603 5.36956L7.60323 0.919961C7.72147 0.840444 7.86073 0.797974 8.00323 0.797974C8.14572 0.797974 8.28498 0.840444 8.40323 0.919961L14.944 5.36956C15.0488 5.44202 15.1262 5.54762 15.1638 5.66938C15.2013 5.79114 15.1969 5.92199 15.1511 6.0409C15.1053 6.1598 15.0208 6.25986 14.9113 6.32498C14.8018 6.39011 14.6736 6.41651 14.5472 6.39996V6.39996Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 12H15.1998V15.2H0.799805V12Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.3999 6.3999V11.9999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59961 6.3999V11.9999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.3999 6.3999V11.9999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.5996 6.3999V11.9999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1M = [];

/* style */
const __vue_inject_styles__$1M = undefined;
/* scoped */
const __vue_scope_id__$1M = undefined;
/* module identifier */
const __vue_module_identifier__$1M = undefined;
/* functional template */
const __vue_is_functional_template__$1M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1M, {}, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, undefined, undefined, undefined);

var smallMoneyBank = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1M
});

/* script */

/* template */
var __vue_render__$1L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.3393 12.9488C13.5751 12.7387 13.7585 12.4763 13.8749 12.1827C13.9913 11.889 14.0374 11.5723 14.0097 11.2576C14.0097 8.89605 12.9489 4.96965 9.58732 4.02405L10.6881 1.74245C10.7371 1.64461 10.7606 1.53602 10.7565 1.42669C10.7525 1.31736 10.7209 1.21082 10.6648 1.11691C10.6086 1.02299 10.5298 0.944734 10.4354 0.889354C10.3411 0.833975 10.2343 0.803262 10.1249 0.800049H5.87532C5.76596 0.803262 5.65917 0.833975 5.56482 0.889354C5.47045 0.944734 5.39157 1.02299 5.33546 1.11691C5.27933 1.21082 5.24777 1.31736 5.24369 1.42669C5.23962 1.53602 5.26314 1.64461 5.31212 1.74245L6.41292 4.02405C3.05292 4.96965 1.99052 8.89605 1.99052 11.2576C1.96175 11.5778 2.00991 11.9002 2.13098 12.198C2.25204 12.4958 2.44252 12.7604 2.68652 12.9696",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 14.136V15.2001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 7.20007V8.03542",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.52535 9.05217C9.31599 8.4598 8.66428 8.0354 8.00023 8.0354C7.18969 8.0354 6.4751 8.69249 6.4751 9.50303C6.4751 10.1344 6.90479 10.6847 7.51729 10.8378L8.37895 11.0533C9.05271 11.2217 9.52537 11.8271 9.52537 12.5215V12.6108C9.52537 13.4531 8.84254 14.1359 8.00023 14.1359C7.33619 14.1359 6.68447 13.7115 6.4751 13.1192",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1L = [];

/* style */
const __vue_inject_styles__$1L = undefined;
/* scoped */
const __vue_scope_id__$1L = undefined;
/* module identifier */
const __vue_module_identifier__$1L = undefined;
/* functional template */
const __vue_is_functional_template__$1L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1L, {}, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, undefined, undefined, undefined);

var smallMoneyCashBagDollar = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1L
});

/* script */

/* template */
var __vue_render__$1K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.59961 9.60007C5.59961 10.2366 6.10532 10.847 7.0055 11.2971C7.90567 11.7472 9.12657 12.0001 10.3996 12.0001C11.6726 12.0001 12.8935 11.7472 13.7937 11.2971C14.6939 10.847 15.1996 10.2366 15.1996 9.60007C15.1996 8.96355 14.6939 8.3531 13.7937 7.90302C12.8935 7.45293 11.6726 7.20007 10.3996 7.20007C9.12657 7.20007 7.90567 7.45293 7.0055 7.90302C6.10532 8.3531 5.59961 8.96355 5.59961 9.60007V9.60007Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59961 9.6001V12.8001C5.59961 14.1249 7.74841 15.2001 10.3996 15.2001C13.0508 15.2001 15.1996 14.1249 15.1996 12.8001V9.6001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 3.20005C0.799805 3.51522 0.92396 3.82731 1.16518 4.11849C1.40641 4.40967 1.75997 4.67424 2.20569 4.89711C2.65141 5.11997 3.18056 5.29675 3.76292 5.41736C4.34529 5.53797 4.96946 5.60005 5.5998 5.60005C6.23015 5.60005 6.85432 5.53797 7.43669 5.41736C8.01905 5.29675 8.5482 5.11997 8.99392 4.89711C9.43964 4.67424 9.7932 4.40967 10.0344 4.11849C10.2756 3.82731 10.3998 3.51522 10.3998 3.20005C10.3998 2.88488 10.2756 2.57279 10.0344 2.28161C9.7932 1.99043 9.43964 1.72585 8.99392 1.50299C8.5482 1.28013 8.01905 1.10335 7.43669 0.982738C6.85432 0.862127 6.23015 0.800049 5.5998 0.800049C4.96946 0.800049 4.34529 0.862127 3.76292 0.982738C3.18056 1.10335 2.65141 1.28013 2.20569 1.50299C1.75997 1.72585 1.40641 1.99043 1.16518 2.28161C0.92396 2.57279 0.799805 2.88488 0.799805 3.20005V3.20005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 3.20007V11.2001C0.799805 11.9105 1.4174 12.5489 2.3998 12.9889",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799805 7.20007C0.799805 7.91047 1.4174 8.54887 2.3998 8.98887",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1K = [];

/* style */
const __vue_inject_styles__$1K = undefined;
/* scoped */
const __vue_scope_id__$1K = undefined;
/* module identifier */
const __vue_module_identifier__$1K = undefined;
/* functional template */
const __vue_is_functional_template__$1K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1K, {}, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, undefined, undefined, undefined);

var smallMoneyCashCoinsStack = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1K
});

/* script */

/* template */
var __vue_render__$1J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.4 6H10.8C10.3582 6 10 6.35817 10 6.8V10C10 10.4418 10.3582 10.8 10.8 10.8H14.4C14.8418 10.8 15.2 10.4418 15.2 10V6.8C15.2 6.35817 14.8418 6 14.4 6Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.5998 10.8V12.8C13.5998 13.2243 13.4312 13.6313 13.1312 13.9313C12.8311 14.2314 12.4242 14.4 11.9998 14.4H2.3998C1.97546 14.4 1.56849 14.2314 1.26843 13.9313C0.968376 13.6313 0.799805 13.2243 0.799805 12.8V3.19998C0.799805 2.77563 0.968376 2.36866 1.26843 2.0686C1.56849 1.76855 1.97546 1.59998 2.3998 1.59998H11.9998C12.4242 1.59998 12.8311 1.76855 13.1312 2.0686C13.4312 2.36866 13.5998 2.77563 13.5998 3.19998V5.99998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1J = [];

/* style */
const __vue_inject_styles__$1J = undefined;
/* scoped */
const __vue_scope_id__$1J = undefined;
/* module identifier */
const __vue_module_identifier__$1J = undefined;
/* functional template */
const __vue_is_functional_template__$1J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1J, {}, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, undefined, undefined, undefined);

var smallMoneyWallet1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1J
});

/* script */

/* template */
var __vue_render__$1I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.6 0.800049H2.39999C1.51633 0.800049 0.799988 1.51639 0.799988 2.40005V13.6C0.799988 14.4837 1.51633 15.2 2.39999 15.2H13.6C14.4836 15.2 15.2 14.4837 15.2 13.6V2.40005C15.2 1.51639 14.4836 0.800049 13.6 0.800049Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.799988 4H15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59998 7.6001L3.19998 9.6001L4.79998 10.8001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.2 8.40002L12.8 9.60002L10.4 11.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.19998 12.8L8.79998 6.80005",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1I = [];

/* style */
const __vue_inject_styles__$1I = undefined;
/* scoped */
const __vue_scope_id__$1I = undefined;
/* module identifier */
const __vue_module_identifier__$1I = undefined;
/* functional template */
const __vue_is_functional_template__$1I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1I, {}, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, undefined, undefined, undefined);

var smallProgrammingBrowserCode2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1I
});

/* script */

/* template */
var __vue_render__$1H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8.23993 4.78833C7.50068 4.64128 6.77547 5.23646 6.77547 5.99018C6.77547 6.39928 6.44383 6.73092 6.03473 6.73092C5.62562 6.73092 5.29399 6.39928 5.29399 5.99018C5.29399 4.3022 6.87342 3.00601 8.52896 3.33531C9.5856 3.54549 10.4456 4.40548 10.6558 5.46213C10.7613 5.99284 10.6994 6.49448 10.471 6.94399C10.2491 7.38055 9.89678 7.71598 9.50475 7.97794C9.14373 8.21916 8.81967 8.49268 8.81967 8.49268C8.81967 8.49268 8.74039 8.60863 8.74151 8.6115C8.74151 9.02059 8.40997 9.35252 8.00086 9.35252C7.59176 9.35252 7.26012 9.02087 7.26012 8.61178C7.26012 8.12679 7.47283 7.75609 7.75151 7.46611C8.00271 7.20474 8.34552 6.97075 8.68167 6.74613C8.9363 6.576 9.07791 6.41512 9.15029 6.27271C9.21611 6.14324 9.24891 5.98323 9.20275 5.75115C9.10946 5.28219 8.70888 4.88161 8.23993 4.78833ZM8.74074 11.6389C8.74074 11.2298 8.4091 10.8981 8 10.8981C7.5909 10.8981 7.25926 11.2298 7.25926 11.6389V11.9753C7.25926 12.3844 7.5909 12.7161 8 12.7161C8.4091 12.7161 8.74074 12.3844 8.74074 11.9753V11.6389Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1117_3584"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1H = [];

/* style */
const __vue_inject_styles__$1H = undefined;
/* scoped */
const __vue_scope_id__$1H = undefined;
/* module identifier */
const __vue_module_identifier__$1H = undefined;
/* functional template */
const __vue_is_functional_template__$1H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1H, {}, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, undefined, undefined, undefined);

var smallQuestionMark = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1H
});

/* script */

/* template */
var __vue_render__$1G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.0002 8H14.0002",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1G = [];

/* style */
const __vue_inject_styles__$1G = undefined;
/* scoped */
const __vue_scope_id__$1G = undefined;
/* module identifier */
const __vue_module_identifier__$1G = undefined;
/* functional template */
const __vue_is_functional_template__$1G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1G, {}, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, undefined, undefined, undefined);

var smallRemove1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1G
});

/* script */

/* template */
var __vue_render__$1F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 6.80005C0.799805 8.39135 1.43195 9.91747 2.55716 11.0427C3.68238 12.1679 5.20851 12.8 6.7998 12.8C8.3911 12.8 9.91723 12.1679 11.0424 11.0427C12.1677 9.91747 12.7998 8.39135 12.7998 6.80005C12.7998 5.20875 12.1677 3.68263 11.0424 2.55741C9.91723 1.43219 8.3911 0.800049 6.7998 0.800049C5.20851 0.800049 3.68238 1.43219 2.55716 2.55741C1.43195 3.68263 0.799805 5.20875 0.799805 6.80005V6.80005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.1998 15.2L11.043 11.0432",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1F = [];

/* style */
const __vue_inject_styles__$1F = undefined;
/* scoped */
const __vue_scope_id__$1F = undefined;
/* module identifier */
const __vue_module_identifier__$1F = undefined;
/* functional template */
const __vue_is_functional_template__$1F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1F, {}, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, undefined, undefined, undefined);

var smallSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1F
});

/* script */

/* template */
var __vue_render__$1E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-setting-cog"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M6.03356 2.73914L6.51356 1.50394C6.59502 1.29559 6.73769 1.1168 6.92277 0.991133C7.10785 0.865463 7.32665 0.798806 7.55036 0.799941H8.44956C8.67245 0.799775 8.8902 0.866885 9.07433 0.992492C9.25846 1.1181 9.40039 1.29635 9.48156 1.50394L9.96156 2.73914L11.5616 3.66714L12.8736 3.46874C13.0929 3.43636 13.317 3.4706 13.5167 3.56702C13.7164 3.66344 13.8825 3.81761 13.9936 4.00954L14.4448 4.79034C14.5558 4.98332 14.6062 5.20527 14.5894 5.42729C14.5726 5.64931 14.4893 5.86112 14.3504 6.03514L13.5232 7.07194V8.92794L14.3504 9.96474C14.4893 10.1388 14.5726 10.3506 14.5894 10.5726C14.6062 10.7946 14.5558 11.0166 14.4448 11.2095L13.9936 11.9903C13.8825 12.1823 13.7164 12.3364 13.5167 12.4329C13.317 12.5293 13.0929 12.5635 12.8736 12.5311L11.5616 12.3327L9.96156 13.2607L9.48156 14.4959C9.40039 14.7035 9.25846 14.8818 9.07433 15.0074C8.8902 15.133 8.67245 15.2001 8.44956 15.1999H7.55036C7.32747 15.2001 7.10972 15.133 6.92559 15.0074C6.74146 14.8818 6.59953 14.7035 6.51836 14.4959L6.03836 13.2607L4.43836 12.3327L3.12636 12.5311C2.90699 12.5635 2.68294 12.5293 2.48325 12.4329C2.28356 12.3364 2.11742 12.1823 2.00636 11.9903L1.53916 11.2095C1.42809 11.0166 1.3777 10.7946 1.39453 10.5726C1.41137 10.3506 1.49466 10.1388 1.63356 9.96474L2.46076 8.92794V7.07194L1.63356 6.03514C1.49466 5.86112 1.41137 5.64931 1.39453 5.42729C1.3777 5.20527 1.42809 4.98332 1.53916 4.79034L1.99036 4.00954C2.10142 3.81761 2.26756 3.66344 2.46725 3.56702C2.66694 3.4706 2.89099 3.43636 3.11036 3.46874L4.42236 3.66714L6.03356 2.73914ZM5.99996 7.99994C5.99996 8.3955 6.11726 8.78218 6.33702 9.11108C6.55678 9.43998 6.86914 9.69632 7.23459 9.8477C7.60005 9.99908 8.00218 10.0387 8.39014 9.96151C8.7781 9.88434 9.13447 9.69386 9.41417 9.41415C9.69388 9.13445 9.88436 8.77808 9.96153 8.39012C10.0387 8.00216 9.9991 7.60003 9.84772 7.23457C9.69634 6.86912 9.44 6.55676 9.1111 6.337C8.7822 6.11724 8.39552 5.99994 7.99996 5.99994C7.46953 5.99994 6.96082 6.21065 6.58575 6.58573C6.21067 6.9608 5.99996 7.46951 5.99996 7.99994Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$1E = [];

/* style */
const __vue_inject_styles__$1E = undefined;
/* scoped */
const __vue_scope_id__$1E = undefined;
/* module identifier */
const __vue_module_identifier__$1E = undefined;
/* functional template */
const __vue_is_functional_template__$1E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1E, {}, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, undefined, undefined, undefined);

var smallSettingCog = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1E
});

/* script */

/* template */
var __vue_render__$1D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.800049 8.00005C0.800049 9.90961 1.55862 11.741 2.90888 13.0912C4.25914 14.4415 6.09049 15.2 8.00005 15.2C9.90961 15.2 11.741 14.4415 13.0912 13.0912C14.4415 11.741 15.2 9.90961 15.2 8.00005C15.2 6.09049 14.4415 4.25914 13.0912 2.90888C11.741 1.55862 9.90961 0.800049 8.00005 0.800049C6.09049 0.800049 4.25914 1.55862 2.90888 2.90888C1.55862 4.25914 0.800049 6.09049 0.800049 8.00005V8.00005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.3232 5.23047L8 10.7697",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.35364 10.7695H14.6464",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1D = [];

/* style */
const __vue_inject_styles__$1D = undefined;
/* scoped */
const __vue_scope_id__$1D = undefined;
/* module identifier */
const __vue_module_identifier__$1D = undefined;
/* functional template */
const __vue_is_functional_template__$1D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1D, {}, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, undefined, undefined, undefined);

var smallSettingGaugeDashboard1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1D
});

/* script */

/* template */
var __vue_render__$1C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.5998 8.80001C1.15798 8.80001 0.799805 8.44184 0.799805 8.00001C0.799805 7.55819 1.15798 7.20001 1.5998 7.20001"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.59961 8.80001C2.04143 8.80001 2.39961 8.44184 2.39961 8.00001C2.39961 7.55819 2.04143 7.20001 1.59961 7.20001"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.99971 8.80001C7.55788 8.80001 7.19971 8.44184 7.19971 8.00001C7.19971 7.55819 7.55788 7.20001 7.99971 7.20001"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 8.80001C8.44182 8.80001 8.8 8.44184 8.8 8.00001C8.8 7.55819 8.44182 7.20001 8 7.20001"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.3996 8.80001C13.9578 8.80001 13.5996 8.44184 13.5996 8.00001C13.5996 7.55819 13.9578 7.20001 14.3996 7.20001"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.3999 8.80001C14.8417 8.80001 15.1999 8.44184 15.1999 8.00001C15.1999 7.55819 14.8417 7.20001 14.3999 7.20001"
    }
  })]);
};
var __vue_staticRenderFns__$1C = [];

/* style */
const __vue_inject_styles__$1C = undefined;
/* scoped */
const __vue_scope_id__$1C = undefined;
/* module identifier */
const __vue_module_identifier__$1C = undefined;
/* functional template */
const __vue_is_functional_template__$1C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1C, {}, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, undefined, undefined, undefined);

var smallSettingMenuHorizontal = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1C
});

/* script */

/* template */
var __vue_render__$1B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.4 4.80005L5.60005 0.800049L0.800049 4.80005V15.2H10.4V4.80005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.4 7.19995H15.2V15.2H10.4V7.19995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 7.19995H7.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 10.4001H7.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1B = [];

/* style */
const __vue_inject_styles__$1B = undefined;
/* scoped */
const __vue_scope_id__$1B = undefined;
/* module identifier */
const __vue_module_identifier__$1B = undefined;
/* functional template */
const __vue_is_functional_template__$1B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1B, {}, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, undefined, undefined, undefined);

var smallShoppingStore2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1B
});

/* script */

/* template */
var __vue_render__$1A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1079_2531)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM7 4C7 3.73478 7.10536 3.48043 7.2929 3.29289C7.48043 3.10536 7.73479 3 8 3C8.26522 3 8.51957 3.10536 8.70711 3.29289C8.89465 3.48043 9 3.73478 9 4V7.2C9 7.46522 8.89465 7.71957 8.70711 7.90711C8.51957 8.09464 8.26522 8.2 8 8.2C7.73479 8.2 7.48043 8.09464 7.2929 7.90711C7.10536 7.71957 7 7.46522 7 7.2V4ZM8 12.8C7.68355 12.8 7.37421 12.7062 7.11109 12.5304C6.84797 12.3545 6.6429 12.1047 6.5218 11.8123C6.4007 11.5199 6.36901 11.1982 6.43075 10.8879C6.49248 10.5775 6.64487 10.2924 6.86863 10.0686C7.0924 9.84487 7.37749 9.69248 7.68786 9.63074C7.99823 9.56901 8.31994 9.60069 8.6123 9.72179C8.90466 9.84289 9.15454 10.048 9.33036 10.3111C9.50617 10.5742 9.6 10.8836 9.6 11.2C9.6 11.6243 9.43143 12.0313 9.13137 12.3314C8.83132 12.6314 8.42435 12.8 8 12.8Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1079_2531"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1A = [];

/* style */
const __vue_inject_styles__$1A = undefined;
/* scoped */
const __vue_scope_id__$1A = undefined;
/* module identifier */
const __vue_module_identifier__$1A = undefined;
/* functional template */
const __vue_is_functional_template__$1A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1A, {}, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, undefined, undefined, undefined);

var smallSolidAlertCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1A
});

/* script */

/* template */
var __vue_render__$1z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1079_2530)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M15.5966 11.2304L9.99658 1.18082C9.79956 0.823964 9.51048 0.526456 9.15943 0.319273C8.80838 0.112089 8.40821 0.00280762 8.00058 0.00280762C7.59296 0.00280762 7.19278 0.112089 6.84173 0.319273C6.49068 0.526456 6.2016 0.823964 6.00458 1.18082L0.401382 11.2384C0.13223 11.7276 -0.00479972 12.2784 0.00379911 12.8367C0.0123979 13.395 0.166329 13.9413 0.450418 14.422C0.734508 14.9026 1.13895 15.3009 1.62387 15.5776C2.10879 15.8544 2.65746 15.9999 3.21578 16H12.7806C13.3398 16 13.8894 15.8542 14.3751 15.577C14.8608 15.2997 15.2658 14.9006 15.5501 14.4191C15.8344 13.9375 15.9882 13.3901 15.9964 12.8309C16.0045 12.2717 15.8667 11.7201 15.5966 11.2304ZM7.19978 4.80002C7.19978 4.58784 7.28407 4.38436 7.4341 4.23433C7.58413 4.0843 7.78761 4.00002 7.99978 4.00002C8.21196 4.00002 8.41544 4.0843 8.56547 4.23433C8.7155 4.38436 8.79978 4.58784 8.79978 4.80002V8.00002C8.79978 8.21219 8.7155 8.41567 8.56547 8.5657C8.41544 8.71573 8.21196 8.80002 7.99978 8.80002C7.78761 8.80002 7.58413 8.71573 7.4341 8.5657C7.28407 8.41567 7.19978 8.21219 7.19978 8.00002V4.80002ZM7.99978 13.6C7.68333 13.6 7.37399 13.5062 7.11087 13.3304C6.84775 13.1546 6.64267 12.9047 6.52157 12.6123C6.40047 12.3199 6.36879 11.9982 6.43053 11.6879C6.49226 11.3775 6.64465 11.0924 6.86841 10.8686C7.09218 10.6449 7.37727 10.4925 7.68764 10.4308C7.99801 10.369 8.31971 10.4007 8.61207 10.5218C8.90444 10.6429 9.15432 10.848 9.33013 11.1111C9.50594 11.3742 9.59978 11.6836 9.59978 12C9.59978 12.4244 9.43121 12.8313 9.13115 13.1314C8.83109 13.4314 8.42413 13.6 7.99978 13.6Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1079_2530"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1z = [];

/* style */
const __vue_inject_styles__$1z = undefined;
/* scoped */
const __vue_scope_id__$1z = undefined;
/* module identifier */
const __vue_module_identifier__$1z = undefined;
/* functional template */
const __vue_is_functional_template__$1z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1z, {}, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, undefined, undefined, undefined);

var smallSolidAlertTriangle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1z
});

/* script */

/* template */
var __vue_render__$1y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM11.9072 6.7072L7.5072 11.1072C7.41434 11.2001 7.30409 11.2738 7.18275 11.324C7.06141 11.3743 6.93135 11.4002 6.8 11.4002C6.66866 11.4002 6.5386 11.3743 6.41726 11.324C6.29592 11.2738 6.18567 11.2001 6.0928 11.1072L4.0928 9.1072C3.90524 8.91964 3.79987 8.66525 3.79987 8.4C3.79987 8.13475 3.90524 7.88036 4.0928 7.6928C4.28036 7.50524 4.53475 7.39987 4.8 7.39987C5.06526 7.39987 5.31964 7.50524 5.5072 7.6928L6.8 8.9856L10.4928 5.2928C10.5857 5.19993 10.6959 5.12626 10.8173 5.076C10.9386 5.02574 11.0687 4.99987 11.2 4.99987C11.3313 4.99987 11.4614 5.02574 11.5827 5.076C11.7041 5.12626 11.8143 5.19993 11.9072 5.2928C12.0001 5.38567 12.0737 5.49592 12.124 5.61727C12.1743 5.73861 12.2001 5.86866 12.2001 6C12.2001 6.13134 12.1743 6.26139 12.124 6.38273C12.0737 6.50408 12.0001 6.61433 11.9072 6.7072Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1079_2527"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1y = [];

/* style */
const __vue_inject_styles__$1y = undefined;
/* scoped */
const __vue_scope_id__$1y = undefined;
/* module identifier */
const __vue_module_identifier__$1y = undefined;
/* functional template */
const __vue_is_functional_template__$1y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1y, {}, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, undefined, undefined, undefined);

var smallSolidCheck = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1y
});

/* script */

/* template */
var __vue_render__$1x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM11.648 9.952C11.7659 10.0619 11.8605 10.1943 11.9261 10.3415C11.9916 10.4887 12.0269 10.6476 12.0297 10.8088C12.0326 10.9699 12.003 11.1299 11.9426 11.2794C11.8822 11.4288 11.7924 11.5645 11.6785 11.6785C11.5645 11.7924 11.4288 11.8822 11.2794 11.9426C11.1299 12.003 10.9699 12.0326 10.8088 12.0297C10.6476 12.0269 10.4887 11.9916 10.3415 11.9261C10.1943 11.8605 10.0619 11.7659 9.952 11.648L8 9.6976L6.048 11.648C5.82052 11.86 5.51965 11.9754 5.20877 11.9699C4.89789 11.9644 4.60127 11.8385 4.38141 11.6186C4.16155 11.3987 4.03561 11.1021 4.03012 10.7912C4.02464 10.4804 4.14004 10.1795 4.352 9.952L6.3024 8L4.352 6.048C4.14004 5.82052 4.02464 5.51965 4.03012 5.20876C4.03561 4.89788 4.16155 4.60127 4.38141 4.38141C4.60127 4.16154 4.89789 4.03561 5.20877 4.03012C5.51965 4.02464 5.82052 4.14003 6.048 4.352L8 6.3024L9.952 4.352C10.1795 4.14003 10.4804 4.02464 10.7912 4.03012C11.1021 4.03561 11.3987 4.16154 11.6186 4.38141C11.8385 4.60127 11.9644 4.89788 11.9699 5.20876C11.9754 5.51965 11.86 5.82052 11.648 6.048L9.6976 8L11.648 9.952Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1084_474"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1x = [];

/* style */
const __vue_inject_styles__$1x = undefined;
/* scoped */
const __vue_scope_id__$1x = undefined;
/* module identifier */
const __vue_module_identifier__$1x = undefined;
/* functional template */
const __vue_is_functional_template__$1x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1x, {}, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, undefined, undefined, undefined);

var smallSolidDelete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1x
});

/* script */

/* template */
var __vue_render__$1w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_2828_4894)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M3.79824 3.90072C3.90423 3.90005 4.0058 3.85816 4.08144 3.78392C4.15626 3.70866 4.19826 3.60685 4.19824 3.50072V2.09912H11.7982V5.89592C11.7982 6.00201 11.8404 6.10375 11.9154 6.17876C11.9904 6.25378 12.0922 6.29592 12.1982 6.29592H13.3982C13.5043 6.29592 13.6061 6.25378 13.6811 6.17876C13.7561 6.10375 13.7982 6.00201 13.7982 5.89592V1.89592C13.7966 1.41962 13.6065 0.963338 13.2695 0.626692C12.9326 0.290047 12.4761 0.100386 11.9998 0.0991211H3.99984C3.52216 0.0995448 3.06416 0.289492 2.72639 0.627265C2.38861 0.965039 2.19867 1.42304 2.19824 1.90072V3.50072C2.19824 3.60681 2.24039 3.70855 2.3154 3.78356C2.39041 3.85858 2.49216 3.90072 2.59824 3.90072H3.79824Z",
      "fill": "#889096"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M13.6548 15.901H2.37162C1.88642 15.9024 1.41891 15.7189 1.06428 15.3878C0.70965 15.0566 0.494564 14.6027 0.462817 14.1186L0.000416589 6.93299C-0.0105172 6.74856 0.0164655 6.56384 0.0796992 6.39025C0.142933 6.21665 0.241075 6.05785 0.368069 5.92366C0.495062 5.78947 0.648212 5.68273 0.818063 5.61004C0.987914 5.53734 1.17086 5.50023 1.35562 5.50099H5.65802C5.95949 5.49992 6.25267 5.59964 6.49097 5.78431C6.72927 5.96897 6.89901 6.22799 6.97322 6.52019L7.29322 7.89619H14.6532C14.8407 7.89641 15.0262 7.93532 15.198 8.01048C15.3698 8.08564 15.5242 8.19543 15.6516 8.33299C15.7764 8.46931 15.8718 8.62987 15.9318 8.80467C15.9918 8.97947 16.0152 9.16476 16.0004 9.34899L15.562 14.1602C15.5175 14.6355 15.2974 15.0772 14.9448 15.3991C14.5921 15.721 14.1322 15.8999 13.6548 15.901Z",
      "fill": "#889096"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2828_4894"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1w = [];

/* style */
const __vue_inject_styles__$1w = undefined;
/* scoped */
const __vue_scope_id__$1w = undefined;
/* module identifier */
const __vue_module_identifier__$1w = undefined;
/* functional template */
const __vue_is_functional_template__$1w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1w, {}, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, undefined, undefined, undefined);

var smallSolidFolder = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1w
});

/* script */

/* template */
var __vue_render__$1v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1079_2528)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM9 12C9 12.2652 8.89465 12.5196 8.70711 12.7071C8.51957 12.8946 8.26522 13 8 13C7.73479 13 7.48043 12.8946 7.2929 12.7071C7.10536 12.5196 7 12.2652 7 12V8.8C7 8.53478 7.10536 8.28043 7.2929 8.09289C7.48043 7.90536 7.73479 7.8 8 7.8C8.26522 7.8 8.51957 7.90536 8.70711 8.09289C8.89465 8.28043 9 8.53478 9 8.8V12ZM8 6.4C7.68355 6.4 7.37421 6.30616 7.11109 6.13035C6.84797 5.95454 6.6429 5.70466 6.5218 5.41229C6.4007 5.11993 6.36901 4.79823 6.43075 4.48786C6.49248 4.17749 6.64487 3.89239 6.86863 3.66863C7.0924 3.44487 7.37749 3.29248 7.68786 3.23074C7.99823 3.16901 8.31994 3.20069 8.6123 3.32179C8.90466 3.44289 9.15454 3.64797 9.33036 3.91109C9.50617 4.17421 9.6 4.48355 9.6 4.8C9.6 5.22435 9.43143 5.63131 9.13137 5.93137C8.83132 6.23143 8.42435 6.4 8 6.4Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1079_2528"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1v = [];

/* style */
const __vue_inject_styles__$1v = undefined;
/* scoped */
const __vue_scope_id__$1v = undefined;
/* module identifier */
const __vue_module_identifier__$1v = undefined;
/* functional template */
const __vue_is_functional_template__$1v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1v, {}, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, undefined, undefined, undefined);

var smallSolidInfo = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1v
});

/* script */

/* template */
var __vue_render__$1u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1084_480)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87905 15.1538 3.84569 13.6541 2.34595C12.1543 0.846211 10.121 0.00254057 8 0ZM11.6 9.2H4.4C4.08174 9.2 3.77652 9.07357 3.55148 8.84853C3.32643 8.62349 3.2 8.31826 3.2 8C3.2 7.68174 3.32643 7.37652 3.55148 7.15147C3.77652 6.92643 4.08174 6.8 4.4 6.8H11.6C11.9183 6.8 12.2235 6.92643 12.4485 7.15147C12.6736 7.37652 12.8 7.68174 12.8 8C12.8 8.31826 12.6736 8.62349 12.4485 8.84853C12.2235 9.07357 11.9183 9.2 11.6 9.2Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1084_480"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1u = [];

/* style */
const __vue_inject_styles__$1u = undefined;
/* scoped */
const __vue_scope_id__$1u = undefined;
/* module identifier */
const __vue_module_identifier__$1u = undefined;
/* functional template */
const __vue_is_functional_template__$1u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1u, {}, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, undefined, undefined, undefined);

var smallSolidMinus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1u
});

/* script */

/* template */
var __vue_render__$1t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "17",
      "viewBox": "0 0 16 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-solid-user-2",
      "clip-path": "url(#clip0_3766_25300)"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector",
      "d": "M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346625 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0823 16 8.5C15.9975 6.37905 15.1538 4.34569 13.6541 2.84595C12.1543 1.34621 10.121 0.502541 8 0.5ZM8 3.7C8.47468 3.7 8.93869 3.84076 9.33337 4.10447C9.72805 4.36819 10.0357 4.74302 10.2173 5.18156C10.399 5.6201 10.4465 6.10266 10.3539 6.56822C10.2613 7.03377 10.0327 7.46141 9.69706 7.79706C9.36141 8.1327 8.93377 8.36128 8.46822 8.45389C8.00267 8.54649 7.52011 8.49896 7.08156 8.31731C6.64302 8.13566 6.26819 7.82805 6.00448 7.43337C5.74076 7.03869 5.6 6.57468 5.6 6.1C5.6 5.46348 5.85286 4.85303 6.30295 4.40294C6.75303 3.95286 7.36348 3.7 8 3.7ZM12.1296 13.3752C10.9786 14.3603 9.51342 14.9016 7.9984 14.9016C6.48339 14.9016 5.01824 14.3603 3.8672 13.3752C3.82665 13.3407 3.79334 13.2985 3.76919 13.251C3.74505 13.2035 3.73055 13.1517 3.72653 13.0986C3.72252 13.0455 3.72906 12.9921 3.74579 12.9416C3.76252 12.891 3.7891 12.8442 3.824 12.804C4.34248 12.2058 4.98348 11.7261 5.70357 11.3973C6.42366 11.0685 7.20601 10.8984 7.9976 10.8984C8.7892 10.8984 9.57155 11.0685 10.2916 11.3973C11.0117 11.7261 11.6527 12.2058 12.1712 12.804C12.2059 12.844 12.2324 12.8905 12.2491 12.9407C12.2659 12.9909 12.2726 13.044 12.2688 13.0968C12.2656 13.1502 12.2516 13.2024 12.2276 13.2502C12.2037 13.2981 12.1704 13.3406 12.1296 13.3752Z",
      "fill": "#889096"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_3766_25300"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white",
      "transform": "translate(0 0.5)"
    }
  })])])]);
};
var __vue_staticRenderFns__$1t = [];

/* style */
const __vue_inject_styles__$1t = undefined;
/* scoped */
const __vue_scope_id__$1t = undefined;
/* module identifier */
const __vue_module_identifier__$1t = undefined;
/* functional template */
const __vue_is_functional_template__$1t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1t, {}, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, undefined, undefined, undefined);

var smallSolidUser2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1t
});

/* script */

/* template */
var __vue_render__$1s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-solid-user-multiple"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.51294 4.87151C2.37223 4.5318 2.2998 4.1677 2.2998 3.8C2.2998 3.4323 2.37223 3.0682 2.51294 2.72849C2.65366 2.38877 2.8599 2.08011 3.11991 1.8201C3.37991 1.5601 3.68858 1.35385 4.02829 1.21314C4.368 1.07242 4.7321 1 5.0998 1C5.46751 1 5.83161 1.07242 6.17132 1.21314C6.51103 1.35385 6.8197 1.5601 7.0797 1.8201C7.33971 2.08011 7.54595 2.38877 7.68667 2.72849C7.82738 3.0682 7.8998 3.4323 7.8998 3.8C7.8998 4.1677 7.82738 4.5318 7.68667 4.87151C7.54595 5.21123 7.33971 5.5199 7.0797 5.7799C6.8197 6.0399 6.51103 6.24615 6.17132 6.38686C5.83161 6.52758 5.46751 6.6 5.0998 6.6C4.7321 6.6 4.368 6.52758 4.02829 6.38686C3.68858 6.24615 3.37991 6.0399 3.11991 5.7799C2.8599 5.5199 2.65366 5.21123 2.51294 4.87151ZM9.66549 15.1657C9.51546 15.3157 9.31198 15.4 9.0998 15.4H1.0998C0.887631 15.4 0.684148 15.3157 0.534119 15.1657C0.38409 15.0157 0.299805 14.8122 0.299805 14.6V13.8C0.299805 12.527 0.805517 11.3061 1.70569 10.4059C2.60587 9.50571 3.82677 9 5.0998 9C6.37284 9 7.59374 9.50571 8.49392 10.4059C9.39409 11.3061 9.89981 12.527 9.89981 13.8V14.6C9.89981 14.8122 9.81552 15.0157 9.66549 15.1657ZM10.9061 1C10.407 1.00097 9.91752 1.13757 9.49006 1.3952C9.40925 1.445 9.34879 1.52192 9.31948 1.61219C9.29017 1.70247 9.29392 1.80023 9.33006 1.888C9.58037 2.49723 9.70971 3.14935 9.71086 3.808C9.70977 4.46355 9.58041 5.11254 9.33006 5.7184C9.29382 5.8064 9.29001 5.90442 9.31931 5.99497C9.34862 6.08551 9.40913 6.16271 9.49006 6.2128C9.91823 6.46785 10.4077 6.60169 10.9061 6.6C11.6487 6.6 12.3609 6.305 12.886 5.7799C13.4111 5.2548 13.7061 4.54261 13.7061 3.8C13.7061 3.05739 13.4111 2.3452 12.886 1.8201C12.3609 1.295 11.6487 1 10.9061 1ZM10.642 9H10.906C12.1791 9 13.4 9.50571 14.3001 10.4059C15.2003 11.3061 15.706 12.527 15.706 13.8V14.6C15.706 14.8122 15.6217 15.0157 15.4717 15.1657C15.3217 15.3157 15.1182 15.4 14.906 15.4H12.0804C12.0235 15.4 11.9673 15.3879 11.9154 15.3645C11.8635 15.341 11.8172 15.3069 11.7795 15.2642C11.7418 15.2215 11.7137 15.1714 11.6969 15.117C11.6801 15.0626 11.675 15.0053 11.682 14.9488C11.6981 14.8332 11.7061 14.7167 11.706 14.6V13.8C11.7066 12.3015 11.2291 10.8419 10.3428 9.6336C10.3003 9.5757 10.2741 9.5074 10.2671 9.43589C10.26 9.36438 10.2724 9.29229 10.3028 9.2272C10.334 9.16257 10.3819 9.10744 10.4415 9.0675C10.5012 9.02755 10.5704 9.00425 10.642 9Z",
      "fill": "#889096"
    }
  })])]);
};
var __vue_staticRenderFns__$1s = [];

/* style */
const __vue_inject_styles__$1s = undefined;
/* scoped */
const __vue_scope_id__$1s = undefined;
/* module identifier */
const __vue_module_identifier__$1s = undefined;
/* functional template */
const __vue_is_functional_template__$1s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1s, {}, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, undefined, undefined, undefined);

var smallSolidUserMultiple = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1s
});

/* script */

/* template */
var __vue_render__$1r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 1.5998C0.799805 1.38763 0.88409 1.18415 1.03412 1.03412C1.18415 0.88409 1.38763 0.799805 1.5998 0.799805H6.3998L14.731 9.131C15.031 9.43105 15.1995 9.83794 15.1995 10.2622C15.1995 10.6865 15.031 11.0934 14.731 11.3934L11.3934 14.731C11.0934 15.031 10.6865 15.1995 10.2622 15.1995C9.83794 15.1995 9.43105 15.031 9.131 14.731L0.799805 6.3998V1.5998Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M3.2002 4.39971C3.2002 4.55729 3.23123 4.71334 3.29154 4.85893C3.35185 5.00452 3.44024 5.13681 3.55167 5.24824C3.6631 5.35967 3.79538 5.44806 3.94098 5.50836C4.08657 5.56867 4.24261 5.59971 4.4002 5.59971C4.55778 5.59971 4.71382 5.56867 4.85942 5.50836C5.00501 5.44806 5.13729 5.35967 5.24872 5.24824C5.36015 5.13681 5.44855 5.00452 5.50885 4.85893C5.56916 4.71334 5.6002 4.55729 5.6002 4.39971C5.6002 4.24212 5.56916 4.08608 5.50885 3.94049C5.44855 3.7949 5.36015 3.66261 5.24872 3.55118C5.13729 3.43975 5.00501 3.35136 4.85942 3.29105C4.71382 3.23075 4.55778 3.19971 4.4002 3.19971C4.24261 3.19971 4.08657 3.23075 3.94098 3.29105C3.79538 3.35136 3.6631 3.43975 3.55167 3.55118C3.44024 3.66261 3.35185 3.7949 3.29154 3.94049C3.23123 4.08608 3.2002 4.24212 3.2002 4.39971Z",
      "fill": "#687076"
    }
  })]);
};
var __vue_staticRenderFns__$1r = [];

/* style */
const __vue_inject_styles__$1r = undefined;
/* scoped */
const __vue_scope_id__$1r = undefined;
/* module identifier */
const __vue_module_identifier__$1r = undefined;
/* functional template */
const __vue_is_functional_template__$1r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1r, {}, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, undefined, undefined, undefined);

var smallTag = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1r
});

/* script */

/* template */
var __vue_render__$1q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.799805 7.99999C0.799805 9.90955 1.55837 11.7409 2.90864 13.0912C4.2589 14.4414 6.09025 15.2 7.9998 15.2C9.90936 15.2 11.7407 14.4414 13.091 13.0912C14.4412 11.7409 15.1998 9.90955 15.1998 7.99999C15.1998 6.09043 14.4412 4.25908 13.091 2.90882C11.7407 1.55856 9.90936 0.799988 7.9998 0.799988C6.09025 0.799988 4.2589 1.55856 2.90864 2.90882C1.55837 4.25908 0.799805 6.09043 0.799805 7.99999V7.99999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 5.23038V7.99998L10.8144 11.2832",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1q = [];

/* style */
const __vue_inject_styles__$1q = undefined;
/* scoped */
const __vue_scope_id__$1q = undefined;
/* module identifier */
const __vue_module_identifier__$1q = undefined;
/* functional template */
const __vue_is_functional_template__$1q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1q, {}, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, undefined, undefined, undefined);

var smallTimeClockCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1q
});

/* script */

/* template */
var __vue_render__$1p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.8 5.60005C12.8 9.60005 8.00001 15.2 8.00001 15.2C8.00001 15.2 3.20001 9.60005 3.20001 5.60005C3.20001 4.32701 3.70573 3.10611 4.6059 2.20594C5.50607 1.30576 6.72697 0.800049 8.00001 0.800049C9.27305 0.800049 10.494 1.30576 11.3941 2.20594C12.2943 3.10611 12.8 4.32701 12.8 5.60005V5.60005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M7.39898 6.20104C7.23958 6.04163 7.15002 5.82543 7.15002 5.6C7.15002 5.37457 7.23958 5.15837 7.39898 4.99896C7.55839 4.83955 7.77459 4.75 8.00002 4.75C8.22546 4.75 8.44166 4.83955 8.60106 4.99896C8.76047 5.15837 8.85002 5.37457 8.85002 5.6C8.85002 5.82543 8.76047 6.04163 8.60107 6.20104C8.44166 6.36045 8.22546 6.45 8.00002 6.45C7.77459 6.45 7.55839 6.36045 7.39898 6.20104Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$1p = [];

/* style */
const __vue_inject_styles__$1p = undefined;
/* scoped */
const __vue_scope_id__$1p = undefined;
/* module identifier */
const __vue_module_identifier__$1p = undefined;
/* functional template */
const __vue_is_functional_template__$1p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1p, {}, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, undefined, undefined, undefined);

var smallTravelMapLocationPin = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1p
});

/* script */

/* template */
var __vue_render__$1o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.5998 13.2L0.799805 14.8V2.79995L5.5998 1.19995V13.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.59961 13.2L10.3996 14.8V2.79995L5.59961 1.19995V13.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.1999 13.2L10.3999 14.8V2.79995L15.1999 1.19995V13.2Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1o = [];

/* style */
const __vue_inject_styles__$1o = undefined;
/* scoped */
const __vue_scope_id__$1o = undefined;
/* module identifier */
const __vue_module_identifier__$1o = undefined;
/* functional template */
const __vue_is_functional_template__$1o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1o, {}, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, undefined, undefined, undefined);

var smallTravelMap = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1o
});

/* script */

/* template */
var __vue_render__$1n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.3999 8.70001C2.3999 7.87159 3.07148 7.20001 3.8999 7.20001H12.0999C12.9283 7.20001 13.5999 7.87159 13.5999 8.70001V13.7C13.5999 14.5284 12.9283 15.2 12.0999 15.2H3.8999C3.07147 15.2 2.3999 14.5284 2.3999 13.7V8.70001Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M6.7998 11.2C6.7998 11.5183 6.92623 11.8235 7.15128 12.0485C7.37632 12.2736 7.68154 12.4 7.9998 12.4C8.31806 12.4 8.62329 12.2736 8.84833 12.0485C9.07338 11.8235 9.1998 11.5183 9.1998 11.2C9.1998 10.8817 9.07338 10.5765 8.84833 10.3515C8.62329 10.1264 8.31806 10 7.9998 10C7.68154 10 7.37632 10.1264 7.15128 10.3515C6.92623 10.5765 6.7998 10.8817 6.7998 11.2Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 7.19999V4.79999C4 3.96046 4.26415 3.14221 4.75503 2.46115C5.24591 1.78008 5.93864 1.27074 6.73509 1.00525C7.53154 0.739772 8.39133 0.731613 9.19267 0.981934C9.99401 1.23225 10.6963 1.72836 11.2 2.39999",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1n = [];

/* style */
const __vue_inject_styles__$1n = undefined;
/* scoped */
const __vue_scope_id__$1n = undefined;
/* module identifier */
const __vue_module_identifier__$1n = undefined;
/* functional template */
const __vue_is_functional_template__$1n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1n, {}, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, undefined, undefined, undefined);

var smallUnlock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1n
});

/* script */

/* template */
var __vue_render__$1m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-user-add"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M12.4 9.60005V15.2M9.59999 12.4H15.2M7.99999 9.44005C7.27007 9.01863 6.44206 8.79684 5.59922 8.79697C4.75638 8.79711 3.92844 9.01917 3.19866 9.44082C2.46887 9.86247 1.86298 10.4688 1.44191 11.199C1.02085 11.9291 0.799449 12.7572 0.799989 13.6V15.2M2.79999 3.60005C2.79999 4.34265 3.09499 5.05485 3.62009 5.57995C4.14519 6.10505 4.85738 6.40005 5.59999 6.40005C6.3426 6.40005 7.05479 6.10505 7.57989 5.57995C8.10499 5.05485 8.39999 4.34265 8.39999 3.60005C8.39999 2.85744 8.10499 2.14525 7.57989 1.62015C7.05479 1.09505 6.3426 0.800049 5.59999 0.800049C4.85738 0.800049 4.14519 1.09505 3.62009 1.62015C3.09499 2.14525 2.79999 2.85744 2.79999 3.60005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$1m = [];

/* style */
const __vue_inject_styles__$1m = undefined;
/* scoped */
const __vue_scope_id__$1m = undefined;
/* module identifier */
const __vue_module_identifier__$1m = undefined;
/* functional template */
const __vue_is_functional_template__$1m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1m, {}, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, undefined, undefined, undefined);

var smallUserAdd = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1m
});

/* script */

/* template */
var __vue_render__$1l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.1998 9.5998L10.9998 15.1998L8.19981 13.1006M7.99981 9.43981C7.26989 9.01839 6.44187 8.79659 5.59904 8.79673C4.7562 8.79686 3.92826 9.01892 3.19847 9.44057C2.46869 9.86223 1.8628 10.4686 1.44173 11.1987C1.02066 11.9288 0.799266 12.757 0.799806 13.5998V15.1998M2.79981 3.5998C2.79981 4.34241 3.09481 5.0546 3.61991 5.5797C4.14501 6.10481 4.8572 6.3998 5.59981 6.3998C6.34241 6.3998 7.0546 6.10481 7.57971 5.5797C8.10481 5.0546 8.39981 4.34241 8.39981 3.5998C8.39981 2.8572 8.10481 2.14501 7.57971 1.61991C7.0546 1.0948 6.34241 0.799805 5.59981 0.799805C4.8572 0.799805 4.14501 1.0948 3.61991 1.61991C3.09481 2.14501 2.79981 2.8572 2.79981 3.5998Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1l = [];

/* style */
const __vue_inject_styles__$1l = undefined;
/* scoped */
const __vue_scope_id__$1l = undefined;
/* module identifier */
const __vue_module_identifier__$1l = undefined;
/* functional template */
const __vue_is_functional_template__$1l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1l, {}, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, undefined, undefined, undefined);

var smallUserApprove = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1l
});

/* script */

/* template */
var __vue_render__$1k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.37162 14.0285C7.62148 13.2783 7.20005 12.2609 7.20005 11.2C7.20005 10.1392 7.62148 9.12177 8.37162 8.37162C9.12177 7.62148 10.1392 7.20005 11.2 7.20005C12.2609 7.20005 13.2783 7.62148 14.0285 8.37162M8.37162 14.0285C9.12177 14.7786 10.1392 15.2 11.2 15.2C12.2609 15.2 13.2783 14.7786 14.0285 14.0285C14.7786 13.2783 15.2 12.2609 15.2 11.2C15.2 10.1392 14.7786 9.12177 14.0285 8.37162M8.37162 14.0285L14.0285 8.37162M5.60005 8.80005C4.32701 8.80005 3.10611 9.30576 2.20594 10.2059C1.30576 11.1061 0.800049 12.327 0.800049 13.6V15.2M2.80005 3.60005C2.80005 4.34265 3.09505 5.05485 3.62015 5.57995C4.14525 6.10505 4.85744 6.40005 5.60005 6.40005C6.34266 6.40005 7.05485 6.10505 7.57995 5.57995C8.10505 5.05485 8.40005 4.34265 8.40005 3.60005C8.40005 2.85744 8.10505 2.14525 7.57995 1.62015C7.05485 1.09505 6.34266 0.800049 5.60005 0.800049C4.85744 0.800049 4.14525 1.09505 3.62015 1.62015C3.09505 2.14525 2.80005 2.85744 2.80005 3.60005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1k = [];

/* style */
const __vue_inject_styles__$1k = undefined;
/* scoped */
const __vue_scope_id__$1k = undefined;
/* module identifier */
const __vue_module_identifier__$1k = undefined;
/* functional template */
const __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1k, {}, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);

var smallUserBlock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1k
});

/* script */

/* template */
var __vue_render__$1j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.2001 9.04801L9.40973 14.84L6.79053 15.2L7.15053 12.5808L12.9409 6.79041L15.2001 9.04801Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.7998 3.59999C2.7998 4.34259 3.0948 5.05478 3.61991 5.57989C4.14501 6.10499 4.8572 6.39999 5.5998 6.39999C6.34241 6.39999 7.0546 6.10499 7.5797 5.57989C8.10481 5.05478 8.3998 4.34259 8.3998 3.59999C8.3998 2.85738 8.10481 2.14519 7.5797 1.62009C7.0546 1.09499 6.34241 0.799988 5.5998 0.799988C4.8572 0.799988 4.14501 1.09499 3.61991 1.62009C3.0948 2.14519 2.7998 2.85738 2.7998 3.59999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.11821 9.04483C6.39651 8.80418 5.62796 8.73851 4.8759 8.85324C4.12385 8.96797 3.40983 9.25982 2.79273 9.70472C2.17562 10.1496 1.6731 10.7348 1.3266 11.4121C0.980098 12.0893 0.799537 12.8393 0.799805 13.6V15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1j = [];

/* style */
const __vue_inject_styles__$1j = undefined;
/* scoped */
const __vue_scope_id__$1j = undefined;
/* module identifier */
const __vue_module_identifier__$1j = undefined;
/* functional template */
const __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1j, {}, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);

var smallUserEdit = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1j
});

/* script */

/* template */
var __vue_render__$1i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "small-user-multiple"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M10.4 15.2V13.6C10.4 12.327 9.89428 11.1061 8.9941 10.2059C8.09393 9.30576 6.87303 8.80005 5.59999 8.80005C4.32695 8.80005 3.10605 9.30576 2.20588 10.2059C1.3057 11.1061 0.799988 12.327 0.799988 13.6V15.2M12.1488 1.41285C12.5054 1.69834 12.7869 2.06671 12.9685 2.48587C13.1502 2.90503 13.2266 3.36226 13.1911 3.81771C13.1557 4.27317 13.0093 4.71304 12.7649 5.09899C12.5205 5.48494 12.1854 5.80526 11.7888 6.03205M15.2 15.2V13.6C15.2002 12.7711 14.9858 11.9562 14.5775 11.2348C14.1693 10.5133 13.5811 9.90988 12.8704 9.48325M2.79999 3.60005C2.79999 4.34265 3.09499 5.05485 3.62009 5.57995C4.14519 6.10505 4.85738 6.40005 5.59999 6.40005C6.34259 6.40005 7.05478 6.10505 7.57989 5.57995C8.10499 5.05485 8.39999 4.34265 8.39999 3.60005C8.39999 2.85744 8.10499 2.14525 7.57989 1.62015C7.05478 1.09505 6.34259 0.800049 5.59999 0.800049C4.85738 0.800049 4.14519 1.09505 3.62009 1.62015C3.09499 2.14525 2.79999 2.85744 2.79999 3.60005Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$1i = [];

/* style */
const __vue_inject_styles__$1i = undefined;
/* scoped */
const __vue_scope_id__$1i = undefined;
/* module identifier */
const __vue_module_identifier__$1i = undefined;
/* functional template */
const __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1i, {}, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);

var smallUserMultiple = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1i
});

/* script */

/* template */
var __vue_render__$1h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.2046 9.60501L9.6046 15.205M9.6046 9.58581L15.2046 15.1858M6.3838 8.85941C6.12447 8.81879 5.8623 8.799 5.5998 8.80021C4.32677 8.80021 3.10587 9.30592 2.20569 10.2061C1.30552 11.1063 0.799805 12.3272 0.799805 13.6002V15.2002M2.795 3.59541C2.795 4.33802 3.09 5.05021 3.61511 5.57531C4.14021 6.10041 4.8524 6.39541 5.595 6.39541C6.33761 6.39541 7.0498 6.10041 7.5749 5.57531C8.10001 5.05021 8.39501 4.33802 8.39501 3.59541C8.39501 2.8528 8.10001 2.14061 7.5749 1.61551C7.0498 1.09041 6.33761 0.79541 5.595 0.79541C4.8524 0.79541 4.14021 1.09041 3.61511 1.61551C3.09 2.14061 2.795 2.8528 2.795 3.59541Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1h = [];

/* style */
const __vue_inject_styles__$1h = undefined;
/* scoped */
const __vue_scope_id__$1h = undefined;
/* module identifier */
const __vue_module_identifier__$1h = undefined;
/* functional template */
const __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1h, {}, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);

var smallUserReject = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1h
});

/* script */

/* template */
var __vue_render__$1g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.3999 4.39999C4.3999 4.87275 4.49302 5.34088 4.67394 5.77765C4.85485 6.21442 5.12003 6.61128 5.45432 6.94557C5.78861 7.27986 6.18547 7.54504 6.62224 7.72595C7.05901 7.90687 7.52714 7.99999 7.9999 7.99999C8.47266 7.99999 8.94079 7.90687 9.37756 7.72595C9.81433 7.54504 10.2112 7.27986 10.5455 6.94557C10.8798 6.61128 11.145 6.21442 11.3259 5.77765C11.5068 5.34088 11.5999 4.87275 11.5999 4.39999C11.5999 3.92723 11.5068 3.4591 11.3259 3.02233C11.145 2.58556 10.8798 2.18869 10.5455 1.8544C10.2112 1.52011 9.81433 1.25494 9.37756 1.07402C8.94079 0.893105 8.47266 0.799988 7.9999 0.799988C7.52714 0.799988 7.05901 0.893105 6.62224 1.07402C6.18547 1.25494 5.78861 1.52011 5.45432 1.8544C5.12003 2.18869 4.85485 2.58556 4.67394 3.02233C4.49302 3.4591 4.3999 3.92723 4.3999 4.39999V4.39999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.7903 15.2C14.2949 13.7948 13.3757 12.5778 12.1595 11.717C10.9432 10.8561 9.48991 10.3939 7.99987 10.3939C6.50984 10.3939 5.0565 10.8561 3.84028 11.717C2.62407 12.5778 1.70488 13.7948 1.20947 15.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1g = [];

/* style */
const __vue_inject_styles__$1g = undefined;
/* scoped */
const __vue_scope_id__$1g = undefined;
/* module identifier */
const __vue_module_identifier__$1g = undefined;
/* functional template */
const __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, {}, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

var smallUserSingle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1g
});

/* script */

/* template */
var __vue_render__$1f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1819_62)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.64961 6.39999C6.39222 6.39999 7.10441 6.10499 7.62951 5.57989C8.15461 5.05478 8.44961 4.34259 8.44961 3.59999C8.44961 2.85738 8.15461 2.14519 7.62951 1.62009C7.10441 1.09499 6.39222 0.799988 5.64961 0.799988C4.907 0.799988 4.19481 1.09499 3.66971 1.62009C3.14461 2.14519 2.84961 2.85738 2.84961 3.59999C2.84961 4.34259 3.14461 5.05478 3.66971 5.57989C4.19481 6.10499 4.907 6.39999 5.64961 6.39999Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.848145 15.2V13.6C0.848055 12.7597 1.06855 11.9342 1.48758 11.2058C1.90661 10.4775 2.50949 9.87191 3.23595 9.44964C3.96241 9.02737 4.787 8.8032 5.62727 8.79954C6.46753 8.79589 7.29404 9.01288 8.02414 9.42881",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.1744 15.2C13.0683 15.2 12.9666 15.1579 12.8916 15.0829C12.8166 15.0079 12.7744 14.9061 12.7744 14.8C12.7744 14.6939 12.8166 14.5922 12.8916 14.5172C12.9666 14.4422 13.0683 14.4 13.1744 14.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.1743 15.2C13.2804 15.2 13.3821 15.1579 13.4572 15.0829C13.5322 15.0079 13.5743 14.9061 13.5743 14.8C13.5743 14.6939 13.5322 14.5922 13.4572 14.5172C13.3821 14.4422 13.2804 14.4 13.1743 14.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.5112 8.88886C11.731 8.55996 12.0434 8.30362 12.4088 8.15224C12.7743 8.00087 13.1764 7.96126 13.5644 8.03843C13.9523 8.1156 14.3087 8.30608 14.5884 8.58579C14.8681 8.86549 15.0586 9.22186 15.1357 9.60982C15.2129 9.99778 15.1733 10.3999 15.0219 10.7654C14.8706 11.1308 14.6142 11.4432 14.2853 11.6629C13.9564 11.8827 13.5697 12 13.1742 12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1819_62"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1f = [];

/* style */
const __vue_inject_styles__$1f = undefined;
/* scoped */
const __vue_scope_id__$1f = undefined;
/* module identifier */
const __vue_module_identifier__$1f = undefined;
/* functional template */
const __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, {}, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

var smallUserUnresolved = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1f
});

/* script */

/* template */
var __vue_render__$1e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 4V20",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 11.9508H20",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$1e = [];

/* style */
const __vue_inject_styles__$1e = undefined;
/* scoped */
const __vue_scope_id__$1e = undefined;
/* module identifier */
const __vue_module_identifier__$1e = undefined;
/* functional template */
const __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, {}, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);

var mediumAdd1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1e
});

/* script */

/* template */
var __vue_render__$1d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-add-circle",
      "clip-path": "url(#clip0_6196_3665)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M8.0001 4.57227V11.4294M4.57153 8.00084H11.4287M15.4287 8.00084C15.4287 12.1035 12.1028 15.4294 8.00011 15.4294C3.89742 15.4294 0.571533 12.1035 0.571533 8.00084C0.571533 3.89815 3.89742 0.572266 8.00011 0.572266C12.1028 0.572266 15.4287 3.89815 15.4287 8.00084Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_6196_3665"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1d = [];

/* style */
const __vue_inject_styles__$1d = undefined;
/* scoped */
const __vue_scope_id__$1d = undefined;
/* module identifier */
const __vue_module_identifier__$1d = undefined;
/* functional template */
const __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, {}, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

var mediumAddCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1d
});

/* script */

/* template */
var __vue_render__$1c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_105_1976)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.2856 22.7144H13.7142",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.8572 9.85714C18.8572 8.03852 18.1348 6.29437 16.8488 5.00841C15.5629 3.72245 13.8187 3 12.0001 3C10.1815 3 8.43734 3.72245 7.15137 5.00841C5.86541 6.29437 5.14296 8.03852 5.14296 9.85714V15.8571C5.14296 16.5391 4.87204 17.1932 4.38981 17.6754C3.90757 18.1577 3.25352 18.4286 2.57153 18.4286H21.4287C20.7467 18.4286 20.0926 18.1577 19.6104 17.6754C19.1282 17.1932 18.8572 16.5391 18.8572 15.8571V9.85714Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.857178 9.63434C0.858102 8.00258 1.24724 6.39446 1.99244 4.94281C2.73764 3.49115 3.81753 2.23762 5.14289 1.28577",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.1429 9.63434C23.142 8.00258 22.7528 6.39446 22.0076 4.94281C21.2624 3.49115 20.1825 2.23762 18.8572 1.28577",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_105_1976"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1c = [];

/* style */
const __vue_inject_styles__$1c = undefined;
/* scoped */
const __vue_scope_id__$1c = undefined;
/* module identifier */
const __vue_module_identifier__$1c = undefined;
/* functional template */
const __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, {}, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

var mediumAlertAlarmBell = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1c
});

/* script */

/* template */
var __vue_render__$1b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_30_755)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.1541 0.857178 12 0.857178C5.846 0.857178 0.857178 5.846 0.857178 12C0.857178 18.1541 5.846 23.1429 12 23.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 6V11.1429",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.3928 16.2857C10.3928 15.3981 11.1124 14.6786 12 14.6786C12.8876 14.6786 13.6071 15.3981 13.6071 16.2857C13.6071 17.1733 12.8876 17.8929 12 17.8929C11.1124 17.8929 10.3928 17.1733 10.3928 16.2857Z",
      "fill": "black"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_30_755"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1b = [];

/* style */
const __vue_inject_styles__$1b = undefined;
/* scoped */
const __vue_scope_id__$1b = undefined;
/* module identifier */
const __vue_module_identifier__$1b = undefined;
/* functional template */
const __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, {}, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

var mediumAlertCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1b
});

/* script */

/* template */
var __vue_render__$1a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M10 7.14307V11.4288",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.66113 15.7143C8.66113 14.9746 9.26075 14.375 10.0004 14.375C10.7401 14.375 11.3397 14.9746 11.3397 15.7143C11.3397 16.454 10.7401 17.0536 10.0004 17.0536C9.26075 17.0536 8.66113 16.454 8.66113 15.7143Z",
      "fill": "#CD2B31"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.2716 1.5001C11.1517 1.2661 10.9696 1.06972 10.7452 0.93259C10.5209 0.79546 10.2631 0.7229 10.0001 0.7229C9.73722 0.7229 9.47939 0.79546 9.25506 0.93259C9.03073 1.06972 8.8486 1.2661 8.72871 1.5001L0.87157 17.2144C0.761984 17.4319 0.70981 17.6737 0.720002 17.917C0.730194 18.1603 0.802414 18.397 0.929803 18.6046C1.05719 18.8121 1.23552 18.9836 1.44786 19.1029C1.66019 19.2221 1.89948 19.2851 2.143 19.2858H17.8573C18.1008 19.2851 18.3401 19.2221 18.5524 19.1029C18.7648 18.9836 18.9431 18.8121 19.0705 18.6046C19.1979 18.397 19.2701 18.1603 19.2803 17.917C19.2905 17.6737 19.2383 17.4319 19.1287 17.2144L11.2716 1.5001Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1119_566"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1a = [];

/* style */
const __vue_inject_styles__$1a = undefined;
/* scoped */
const __vue_scope_id__$1a = undefined;
/* module identifier */
const __vue_module_identifier__$1a = undefined;
/* functional template */
const __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, {}, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

var mediumAlertTriangle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1a
});

/* script */

/* template */
var __vue_render__$19 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.1428 12H4.14282",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 6L4 12L10 18",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$19 = [];

/* style */
const __vue_inject_styles__$19 = undefined;
/* scoped */
const __vue_scope_id__$19 = undefined;
/* module identifier */
const __vue_module_identifier__$19 = undefined;
/* functional template */
const __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, {}, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);

var mediumArrowLeft = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$19
});

/* script */

/* template */
var __vue_render__$18 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 12L20 12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.1428 18L20.1428 12L14.1428 6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$18 = [];

/* style */
const __vue_inject_styles__$18 = undefined;
/* scoped */
const __vue_scope_id__$18 = undefined;
/* module identifier */
const __vue_module_identifier__$18 = undefined;
/* functional template */
const __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, {}, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);

var mediumArrowRight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$18
});

/* script */

/* template */
var __vue_render__$17 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_4740_3504)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6522 12.9072C12.0304 13.5463 11.2881 14.0675 10.4621 14.4343",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.60864 15.0372C6.68532 15.0372 5.80353 14.8594 4.99565 14.5361",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.64172 12.9855C2.04595 12.3918 1.5559 11.6921 1.20241 10.917",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.6194 8.61426C14.5671 9.21864 14.4385 9.80116 14.2431 10.3521",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.571459 8.00008C0.571459 4.11355 3.72209 0.962891 7.60866 0.962891C10.2212 0.962891 12.5012 2.38646 13.7153 4.50022",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.2712 1.69824L13.7244 4.51287L10.8792 4.33142",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.5953 8.39094C7.81058 8.39094 7.98511 8.21641 7.98511 8.00113C7.98511 7.78585 7.81058 7.61133 7.5953 7.61133",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.59534 8.39094C7.38006 8.39094 7.20553 8.21641 7.20553 8.00113C7.20553 7.78585 7.38006 7.61133 7.59534 7.61133",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_4740_3504"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white",
      "transform": "matrix(-1 0 0 1 16 0)"
    }
  })])])]);
};
var __vue_staticRenderFns__$17 = [];

/* style */
const __vue_inject_styles__$17 = undefined;
/* scoped */
const __vue_scope_id__$17 = undefined;
/* module identifier */
const __vue_module_identifier__$17 = undefined;
/* functional template */
const __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, {}, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);

var mediumArrowsRotate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$17
});

/* script */

/* template */
var __vue_render__$16 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_11_1722)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22.7657 16.0972L16.0971 22.7657C15.856 23.0065 15.5292 23.1417 15.1885 23.1417C14.8478 23.1417 14.521 23.0065 14.28 22.7657L1.04567 9.53144C0.979168 9.46787 0.927723 9.39024 0.895096 9.30422C0.862469 9.2182 0.849486 9.12598 0.857095 9.0343L1.86852 2.46859C1.87678 2.31213 1.94264 2.16427 2.05342 2.05348C2.16421 1.9427 2.31207 1.87684 2.46852 1.86859L9.03424 0.857157C9.12592 0.849547 9.21814 0.86253 9.30416 0.895157C9.39018 0.927784 9.46781 0.979229 9.53138 1.04573L22.7657 14.28C23.0064 14.5211 23.1417 14.8479 23.1417 15.1886C23.1417 15.5293 23.0064 15.8561 22.7657 16.0972V16.0972Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.04562 7.90288C7.51901 7.90288 7.90276 7.51913 7.90276 7.04574C7.90276 6.57235 7.51901 6.1886 7.04562 6.1886C6.57223 6.1886 6.18848 6.57235 6.18848 7.04574C6.18848 7.51913 6.57223 7.90288 7.04562 7.90288Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_11_1722"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$16 = [];

/* style */
const __vue_inject_styles__$16 = undefined;
/* scoped */
const __vue_scope_id__$16 = undefined;
/* module identifier */
const __vue_module_identifier__$16 = undefined;
/* functional template */
const __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, {}, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

var mediumBookmarkTag = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$16
});

/* script */

/* template */
var __vue_render__$15 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-check-1"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M15.8337 5L7.28216 15L4.16699 11.875",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$15 = [];

/* style */
const __vue_inject_styles__$15 = undefined;
/* scoped */
const __vue_scope_id__$15 = undefined;
/* module identifier */
const __vue_module_identifier__$15 = undefined;
/* functional template */
const __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, {}, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

var mediumCheck1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$15
});

/* script */

/* template */
var __vue_render__$14 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_45_1010)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 8L10 16L7 13",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.1541 0.857178 12 0.857178C5.846 0.857178 0.857178 5.846 0.857178 12C0.857178 18.1541 5.846 23.1429 12 23.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_45_1010"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$14 = [];

/* style */
const __vue_inject_styles__$14 = undefined;
/* scoped */
const __vue_scope_id__$14 = undefined;
/* module identifier */
const __vue_module_identifier__$14 = undefined;
/* functional template */
const __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, {}, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

var mediumCheckCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$14
});

/* script */

/* template */
var __vue_render__$13 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.85718 13.7143L10.3715 16.5257C10.4658 16.6035 10.5764 16.6592 10.695 16.6888C10.8136 16.7185 10.9373 16.7213 11.0572 16.6972C11.1782 16.6745 11.2929 16.626 11.3934 16.555C11.494 16.484 11.5781 16.3922 11.64 16.2857L17.1429 6.85718",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$13 = [];

/* style */
const __vue_inject_styles__$13 = undefined;
/* scoped */
const __vue_scope_id__$13 = undefined;
/* module identifier */
const __vue_module_identifier__$13 = undefined;
/* functional template */
const __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, {}, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

var mediumCheck = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$13
});

/* script */

/* template */
var __vue_render__$12 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.1429 10.2857L12 15.4286L6.85718 10.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$12 = [];

/* style */
const __vue_inject_styles__$12 = undefined;
/* scoped */
const __vue_scope_id__$12 = undefined;
/* module identifier */
const __vue_module_identifier__$12 = undefined;
/* functional template */
const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, {}, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

var mediumChevronDown = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$12
});

/* script */

/* template */
var __vue_render__$11 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.7144 6.85712L12.5715 12L17.7144 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.1429 6.85712L6 12L11.1429 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$11 = [];

/* style */
const __vue_inject_styles__$11 = undefined;
/* scoped */
const __vue_scope_id__$11 = undefined;
/* module identifier */
const __vue_module_identifier__$11 = undefined;
/* functional template */
const __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, {}, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

var mediumChevronLeftDouble = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$11
});

/* script */

/* template */
var __vue_render__$10 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.7144 6.85712L8.57153 12L13.7144 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$10 = [];

/* style */
const __vue_inject_styles__$10 = undefined;
/* scoped */
const __vue_scope_id__$10 = undefined;
/* module identifier */
const __vue_module_identifier__$10 = undefined;
/* functional template */
const __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, {}, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

var mediumChevronLeft = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$10
});

/* script */

/* template */
var __vue_render__$$ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.99997 6.85712L12.1428 12L6.99997 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.5715 6.85712L18.7144 12L13.5715 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$$ = [];

/* style */
const __vue_inject_styles__$$ = undefined;
/* scoped */
const __vue_scope_id__$$ = undefined;
/* module identifier */
const __vue_module_identifier__$$ = undefined;
/* functional template */
const __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, {}, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

var mediumChevronRightDouble = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$$
});

/* script */

/* template */
var __vue_render__$_ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.2856 6.85712L15.4285 12L10.2856 17.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$_ = [];

/* style */
const __vue_inject_styles__$_ = undefined;
/* scoped */
const __vue_scope_id__$_ = undefined;
/* module identifier */
const __vue_module_identifier__$_ = undefined;
/* functional template */
const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, {}, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var mediumChevronRight = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$_
});

/* script */

/* template */
var __vue_render__$Z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1351_544)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.0001 6V12.8571L7.54297 15.0857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.15527 14.5714C2.31613 19.4857 6.73097 23.1428 12 23.1428C18.1541 23.1428 23.1428 18.1541 23.1428 12C23.1428 5.84595 18.1541 0.857117 12 0.857117C7.70101 0.857117 3.97066 3.29159 2.11232 6.85712",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.857178 3.42853V7.71424H5.14289",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1351_544"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$Z = [];

/* style */
const __vue_inject_styles__$Z = undefined;
/* scoped */
const __vue_scope_id__$Z = undefined;
/* module identifier */
const __vue_module_identifier__$Z = undefined;
/* functional template */
const __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, {}, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

var mediumClockRewind = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$Z
});

/* script */

/* template */
var __vue_render__$Y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.0001 4L4 20.0001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 4L20.0001 20.0001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$Y = [];

/* style */
const __vue_inject_styles__$Y = undefined;
/* scoped */
const __vue_scope_id__$Y = undefined;
/* module identifier */
const __vue_module_identifier__$Y = undefined;
/* functional template */
const __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, {}, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

var mediumDelete1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$Y
});

/* script */

/* template */
var __vue_render__$X = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_108_1419)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.71436 6H22.2858",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.28564 6H19.7142V21.4286C19.7142 21.8832 19.5336 22.3193 19.2121 22.6408C18.8906 22.9622 18.4546 23.1429 17.9999 23.1429H5.99993C5.54527 23.1429 5.10924 22.9622 4.78775 22.6408C4.46626 22.3193 4.28564 21.8832 4.28564 21.4286V6Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.71436 6.00003V5.14289C7.71436 4.00625 8.16588 2.91616 8.96961 2.11243C9.77334 1.30871 10.8634 0.857178 12.0001 0.857178C13.1367 0.857178 14.2268 1.30871 15.0305 2.11243C15.8343 2.91616 16.2858 4.00625 16.2858 5.14289V6.00003",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_108_1419"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$X = [];

/* style */
const __vue_inject_styles__$X = undefined;
/* scoped */
const __vue_scope_id__$X = undefined;
/* module identifier */
const __vue_module_identifier__$X = undefined;
/* functional template */
const __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, {}, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

var mediumDeleteBin1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$X
});

/* script */

/* template */
var __vue_render__$W = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_108_1476)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.6343 8.36572L8.36572 15.6343",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.36572 8.36572L15.6343 15.6343",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 23.1429C18.1541 23.1429 23.1429 18.1541 23.1429 12C23.1429 5.846 18.1541 0.857178 12 0.857178C5.846 0.857178 0.857178 5.846 0.857178 12C0.857178 18.1541 5.846 23.1429 12 23.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_108_1476"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$W = [];

/* style */
const __vue_inject_styles__$W = undefined;
/* scoped */
const __vue_scope_id__$W = undefined;
/* module identifier */
const __vue_module_identifier__$W = undefined;
/* functional template */
const __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, {}, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

var mediumDeleteCircle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$W
});

/* script */

/* template */
var __vue_render__$V = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.6343 8.36572L8.36572 15.6343",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.36572 8.36572L15.6343 15.6343",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$V = [];

/* style */
const __vue_inject_styles__$V = undefined;
/* scoped */
const __vue_scope_id__$V = undefined;
/* module identifier */
const __vue_module_identifier__$V = undefined;
/* functional template */
const __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, {}, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

var mediumDelete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$V
});

/* script */

/* template */
var __vue_render__$U = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_11_1681)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.857178 18V19.7143C0.857178 20.6236 1.2184 21.4957 1.86138 22.1387C2.50436 22.7816 3.37644 23.1429 4.28575 23.1429H19.7143C20.6236 23.1429 21.4957 22.7816 22.1387 22.1387C22.7817 21.4957 23.1429 20.6236 23.1429 19.7143V18",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.85718 10.2857L12 16.2857L17.1429 10.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 16.2857V0.857142",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_11_1681"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$U = [];

/* style */
const __vue_inject_styles__$U = undefined;
/* scoped */
const __vue_scope_id__$U = undefined;
/* module identifier */
const __vue_module_identifier__$U = undefined;
/* functional template */
const __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, {}, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

var mediumDownload = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$U
});

/* script */

/* template */
var __vue_render__$T = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-edit-pencil"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M7.95013 15.3745L3.33325 16.6667L4.62598 12.0516L13.08 3.64191C13.1755 3.54423 13.2897 3.46662 13.4156 3.41363C13.5416 3.36064 13.6769 3.33334 13.8136 3.33334C13.9502 3.33334 14.0855 3.36064 14.2115 3.41363C14.3375 3.46662 14.4516 3.54423 14.5471 3.64191L16.3631 5.46743C16.4593 5.56277 16.5356 5.6762 16.5877 5.80118C16.6398 5.92615 16.6666 6.0602 16.6666 6.19559C16.6666 6.33097 16.6398 6.46502 16.5877 6.59C16.5356 6.71497 16.4593 6.8284 16.3631 6.92374L7.95013 15.3745Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$T = [];

/* style */
const __vue_inject_styles__$T = undefined;
/* scoped */
const __vue_scope_id__$T = undefined;
/* module identifier */
const __vue_module_identifier__$T = undefined;
/* functional template */
const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, {}, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

var mediumEditPencil = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$T
});

/* script */

/* template */
var __vue_render__$S = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-file-alert"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M5 9.83333V3C5 2.46956 5.21072 1.96086 5.58578 1.58579C5.96086 1.21071 6.46956 1 7 1H17L27 11V25C27 25.5304 26.7892 26.0392 26.4142 26.4142C26.0392 26.7892 25.5304 27 25 27H20.1667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_2",
      "d": "M17 1V11H27",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_3",
      "d": "M15.016 25.3121C15.114 25.4933 15.1654 25.6961 15.1654 25.9021C15.1654 26.1081 15.114 26.3109 15.016 26.4921C14.9238 26.6727 14.7836 26.8243 14.6106 26.9303C14.4376 27.0361 14.2388 27.0921 14.036 27.0921H2.29599C2.09321 27.0921 1.89437 27.0361 1.72141 26.9303C1.54847 26.8243 1.40817 26.6727 1.31599 26.4921C1.21797 26.3109 1.16663 26.1081 1.16663 25.9021C1.16663 25.6961 1.21797 25.4933 1.31599 25.3121L7.21599 14.6721C7.29705 14.4734 7.43545 14.3033 7.61357 14.1836C7.79167 14.0639 8.00139 14 8.21597 14C8.43057 14 8.64037 14.0639 8.81837 14.1836C8.99657 14.3033 9.13497 14.4734 9.21597 14.6721L15.016 25.3121Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$S = [];

/* style */
const __vue_inject_styles__$S = undefined;
/* scoped */
const __vue_scope_id__$S = undefined;
/* module identifier */
const __vue_module_identifier__$S = undefined;
/* functional template */
const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, {}, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

var mediumFileAlert = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$S
});

/* script */

/* template */
var __vue_render__$R = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "group"
    }
  }, [_c('g', {
    attrs: {
      "id": "group_2"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M5 15V3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H17L27 11V25C27 25.5304 26.7893 26.0391 26.4142 26.4142C26.0391 26.7893 25.5304 27 25 27H15",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M17 1V11H27",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_3",
      "d": "M14.76 16L6.5 27L1 22.88",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]);
};
var __vue_staticRenderFns__$R = [];

/* style */
const __vue_inject_styles__$R = undefined;
/* scoped */
const __vue_scope_id__$R = undefined;
/* module identifier */
const __vue_module_identifier__$R = undefined;
/* functional template */
const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, {}, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var mediumFileCheckAlternate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$R
});

/* script */

/* template */
var __vue_render__$Q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 22 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.57101 20.2857L1.71387 17.4286L4.57101 14.5714",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.85645 20.2857L11.7136 17.4286L8.85645 14.5714",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.57129 11.7142V3.1428C4.57129 2.76392 4.7218 2.40056 4.98971 2.13265C5.25762 1.86474 5.62098 1.71423 5.99986 1.71423H13.1427L20.2856 8.85709V18.8571C20.2856 19.236 20.1351 19.5993 19.8672 19.8672C19.5992 20.1352 19.2359 20.2857 18.857 20.2857H14.5713",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.1426 1.71423V8.85709H20.2854",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$Q = [];

/* style */
const __vue_inject_styles__$Q = undefined;
/* scoped */
const __vue_scope_id__$Q = undefined;
/* module identifier */
const __vue_module_identifier__$Q = undefined;
/* functional template */
const __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, {}, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

var mediumFileCode = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$Q
});

/* script */

/* template */
var __vue_render__$P = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.4286 17.1429C21.4286 17.5975 21.248 18.0336 20.9265 18.355C20.605 18.6765 20.169 18.8571 19.7143 18.8571H8.57146C8.11681 18.8571 7.68077 18.6765 7.35928 18.355C7.03779 18.0336 6.85718 17.5975 6.85718 17.1429V2.57143C6.85718 2.11678 7.03779 1.68074 7.35928 1.35925C7.68077 1.03776 8.11681 0.857147 8.57146 0.857147H16.2857L21.4286 6V17.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.2858 23.1429H4.28582C3.83116 23.1429 3.39513 22.9622 3.07364 22.6408C2.75214 22.3193 2.57153 21.8832 2.57153 21.4286V6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$P = [];

/* style */
const __vue_inject_styles__$P = undefined;
/* scoped */
const __vue_scope_id__$P = undefined;
/* module identifier */
const __vue_module_identifier__$P = undefined;
/* functional template */
const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, {}, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

var mediumFileDouble = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$P
});

/* script */

/* template */
var __vue_render__$O = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.9991 18.857L6.85655 18.8571L6.85645 13.7142",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.85571 18.8571L12.8557 12.8571",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2.67749 21.4284V2.57393C2.67749 1.62716 3.44501 0.85965 4.39178 0.85965H14.5469C15.3911 0.85965 16.2008 1.19503 16.7978 1.79201L20.3901 5.46336C20.9871 6.06034 21.3225 6.87001 21.3225 7.71428V21.4284C21.3225 22.3752 20.555 23.1427 19.6082 23.1427H4.39178C3.44501 23.1427 2.67749 22.3752 2.67749 21.4284Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5713 0.857147V7.71429H21.2616",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$O = [];

/* style */
const __vue_inject_styles__$O = undefined;
/* scoped */
const __vue_scope_id__$O = undefined;
/* module identifier */
const __vue_module_identifier__$O = undefined;
/* functional template */
const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, {}, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

var mediumFileRequest = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$O
});

/* script */

/* template */
var __vue_render__$N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "21",
      "viewBox": "0 0 20 21",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-file-search"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M16.4282 6.92858V6.21429L11.4282 1.21429H2.14244C1.76355 1.21429 1.4002 1.3648 1.13229 1.63271C0.864377 1.90062 0.713867 2.26398 0.713867 2.64287V18.3572C0.713867 18.736 0.864377 19.0994 1.13229 19.3673C1.4002 19.6352 1.76355 19.7857 2.14244 19.7857H9.2853M19.2853 19.7857L16.7853 17.2857M13.571 18.3572C15.938 18.3572 17.8567 16.4384 17.8567 14.0714C17.8567 11.7045 15.938 9.78572 13.571 9.78572C11.2041 9.78572 9.2853 11.7045 9.2853 14.0714C9.2853 16.4384 11.2041 18.3572 13.571 18.3572Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$N = [];

/* style */
const __vue_inject_styles__$N = undefined;
/* scoped */
const __vue_scope_id__$N = undefined;
/* module identifier */
const __vue_module_identifier__$N = undefined;
/* functional template */
const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, {}, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

var mediumFileSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$N
});

/* script */

/* template */
var __vue_render__$M = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "21",
      "viewBox": "0 0 20 21",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-file-settings-3"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M16.4282 8.00007V6.21436L11.4282 1.21436H2.14244C1.76355 1.21436 1.4002 1.36487 1.13229 1.63277C0.864377 1.90068 0.713867 2.26404 0.713867 2.64293V18.3572C0.713867 18.7361 0.864377 19.0995 1.13229 19.3674C1.4002 19.6352 1.76355 19.7858 2.14244 19.7858H8.33289M13.0142 11.7069L13.323 10.9098C13.3751 10.7748 13.4667 10.6587 13.5859 10.5767C13.7051 10.4947 13.8462 10.4506 13.9909 10.4502H14.5797C14.7244 10.4506 14.8655 10.4947 14.9847 10.5767C15.1039 10.6587 15.1955 10.7748 15.2476 10.9098L15.5564 11.7069L16.6048 12.3101L17.4522 12.1809C17.5933 12.1617 17.7369 12.1849 17.8648 12.2476C17.9927 12.3103 18.099 12.4095 18.1703 12.5328L18.4576 13.0354C18.5312 13.1606 18.5651 13.3052 18.5549 13.4501C18.5446 13.595 18.4907 13.7333 18.4001 13.8469L17.8759 14.5148V15.7212L18.4145 16.3891C18.505 16.5026 18.559 16.6411 18.5692 16.7859C18.5795 16.9308 18.5456 17.0754 18.472 17.2005L18.1847 17.7032C18.1134 17.8265 18.007 17.9258 17.8792 17.9884C17.7513 18.0511 17.6077 18.0742 17.4666 18.0551L16.6192 17.9259L15.5707 18.5291L15.2619 19.3262C15.2099 19.4612 15.1182 19.5772 14.9991 19.6592C14.8799 19.7412 14.7388 19.7854 14.5941 19.7858H13.9909C13.8462 19.7854 13.7051 19.7412 13.5859 19.6592C13.4667 19.5772 13.3751 19.4612 13.323 19.3262L13.0142 18.5291L11.9658 17.9259L11.1184 18.0551C10.9773 18.0742 10.8337 18.0511 10.7058 17.9884C10.5779 17.9258 10.4716 17.8265 10.4002 17.7032L10.113 17.2005C10.0394 17.0754 10.0055 16.9308 10.0157 16.7859C10.026 16.6411 10.0799 16.5026 10.1705 16.3891L10.6947 15.7212V14.5148L10.1561 13.8469C10.0656 13.7333 10.0116 13.595 10.0014 13.4501C9.99112 13.3052 10.025 13.1606 10.0986 13.0354L10.3859 12.5328C10.4572 12.4095 10.5636 12.3103 10.6914 12.2476C10.8193 12.1849 10.9629 12.1617 11.104 12.1809L11.9514 12.3101L13.0142 11.7069ZM13.571 15.1172C13.571 15.3067 13.6463 15.4883 13.7802 15.6223C13.9142 15.7562 14.0959 15.8315 14.2853 15.8315C14.4747 15.8315 14.6564 15.7562 14.7904 15.6223C14.9243 15.4883 14.9996 15.3067 14.9996 15.1172C14.9996 14.9278 14.9243 14.7461 14.7904 14.6121C14.6564 14.4782 14.4747 14.4029 14.2853 14.4029C14.0959 14.4029 13.9142 14.4782 13.7802 14.6121C13.6463 14.7461 13.571 14.9278 13.571 15.1172Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs')]);
};
var __vue_staticRenderFns__$M = [];

/* style */
const __vue_inject_styles__$M = undefined;
/* scoped */
const __vue_scope_id__$M = undefined;
/* module identifier */
const __vue_module_identifier__$M = undefined;
/* functional template */
const __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, {}, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

var mediumFileSettings3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$M
});

/* script */

/* template */
var __vue_render__$L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.857178 18V19.7143C0.857178 20.6236 1.2184 21.4957 1.86138 22.1387C2.50436 22.7816 3.37644 23.1429 4.28575 23.1429H19.7143C20.6236 23.1429 21.4957 22.7816 22.1387 22.1387C22.7817 21.4957 23.1429 20.6236 23.1429 19.7143V18",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.85718 6.85714L12 0.85714L17.1429 6.85714",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 0.85714V16.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$L = [];

/* style */
const __vue_inject_styles__$L = undefined;
/* scoped */
const __vue_scope_id__$L = undefined;
/* module identifier */
const __vue_module_identifier__$L = undefined;
/* functional template */
const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, {}, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

var mediumFileUpload = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$L
});

/* script */

/* template */
var __vue_render__$K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "22",
      "height": "24",
      "viewBox": "0 0 22 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "zip-file--file-common-zip"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M20.4287 21.4284C20.4287 21.883 20.2481 22.3191 19.9266 22.6405C19.6051 22.962 19.169 23.1426 18.7144 23.1426H3.28582C2.83116 23.1426 2.39513 22.962 2.07364 22.6405C1.75214 22.3191 1.57153 21.883 1.57153 21.4284V2.57122C1.57153 2.11656 1.75214 1.68053 2.07364 1.35904C2.39513 1.03755 2.83116 0.856934 3.28582 0.856934H13.5715L20.4287 7.71408V21.4284Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_2",
      "d": "M5.85718 6H11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_3",
      "d": "M5.85718 11.1426H11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_4",
      "d": "M5.85718 16.2856H11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_5",
      "d": "M8.42871 0.856934V17.9998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$K = [];

/* style */
const __vue_inject_styles__$K = undefined;
/* scoped */
const __vue_scope_id__$K = undefined;
/* module identifier */
const __vue_module_identifier__$K = undefined;
/* functional template */
const __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, {}, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

var mediumFileZip = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$K
});

/* script */

/* template */
var __vue_render__$J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.4287 21.4286C21.4287 21.8832 21.2481 22.3193 20.9266 22.6408C20.6051 22.9622 20.169 23.1429 19.7144 23.1429H4.28582C3.83116 23.1429 3.39513 22.9622 3.07364 22.6408C2.75214 22.3193 2.57153 21.8832 2.57153 21.4286V2.57143C2.57153 2.11678 2.75214 1.68074 3.07364 1.35925C3.39513 1.03776 3.83116 0.857147 4.28582 0.857147H12.8572L21.4287 9.42858V21.4286Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.8572 0.857147V9.42858H21.4286",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$J = [];

/* style */
const __vue_inject_styles__$J = undefined;
/* scoped */
const __vue_scope_id__$J = undefined;
/* module identifier */
const __vue_module_identifier__$J = undefined;
/* functional template */
const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, {}, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var mediumFile = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$J
});

/* script */

/* template */
var __vue_render__$I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.3333 5H1.66663",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.8333 10H4.16663",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.3333 15H6.66663",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$I = [];

/* style */
const __vue_inject_styles__$I = undefined;
/* scoped */
const __vue_scope_id__$I = undefined;
/* module identifier */
const __vue_module_identifier__$I = undefined;
/* functional template */
const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, {}, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var mediumFilter3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$I
});

/* script */

/* template */
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-graph-2"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M5.71429 14.8571H1.14286V8.57139H5.71429V14.8571ZM5.71429 14.8571V5.14282H10.2857V14.8571M5.71429 14.8571H10.2857M10.2857 14.8571V1.14282H14.8571V14.8571H10.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_6187_1310"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$H = [];

/* style */
const __vue_inject_styles__$H = undefined;
/* scoped */
const __vue_scope_id__$H = undefined;
/* module identifier */
const __vue_module_identifier__$H = undefined;
/* functional template */
const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, {}, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

var mediumGraph2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$H
});

/* script */

/* template */
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "20",
      "viewBox": "0 0 24 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "hamburger-menu-1--button-parallel-horizontal-lines-menu-navigation-three-hamburger"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M23.1429 1.42847H0.857178",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_2",
      "d": "M23.1429 10H0.857178",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_3",
      "d": "M23.1429 18.5713H0.857178",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$G = [];

/* style */
const __vue_inject_styles__$G = undefined;
/* scoped */
const __vue_scope_id__$G = undefined;
/* module identifier */
const __vue_module_identifier__$G = undefined;
/* functional template */
const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, {}, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

var mediumHamburger = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$G
});

/* script */

/* template */
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.9914 11.7037C20.9873 11.1812 20.774 10.6832 20.4024 10.3159L13.3971 3.39014C12.6179 2.61983 11.364 2.61983 10.5849 3.39014L3.59388 10.3017C3.21386 10.6775 3 11.1895 3 11.7239C3 13.8133 3 17.6541 3 20.0022C3 21.1068 3.89543 22 5 22H18.9913C20.0922 22 20.986 21.1128 20.9898 20.0119C20.9979 17.6491 21.0073 13.7675 20.9914 11.7037Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$F = [];

/* style */
const __vue_inject_styles__$F = undefined;
/* scoped */
const __vue_scope_id__$F = undefined;
/* module identifier */
const __vue_module_identifier__$F = undefined;
/* functional template */
const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, {}, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

var mediumHome = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$F
});

/* script */

/* template */
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.1429 8.57132C23.1429 8.11667 22.9623 7.68063 22.6408 7.35914C22.3193 7.03765 21.8833 6.85704 21.4286 6.85704H18L15.4286 3.42847H8.57146L6.00003 6.85704H2.57146C2.11681 6.85704 1.68077 7.03765 1.35928 7.35914C1.03779 7.68063 0.857178 8.11667 0.857178 8.57132V18.857C0.857178 19.3117 1.03779 19.7477 1.35928 20.0692C1.68077 20.3907 2.11681 20.5713 2.57146 20.5713H21.4286C21.8833 20.5713 22.3193 20.3907 22.6408 20.0692C22.9623 19.7477 23.1429 19.3117 23.1429 18.857V8.57132Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 16.7143C14.1302 16.7143 15.8571 14.9874 15.8571 12.8571C15.8571 10.7269 14.1302 9 12 9C9.86972 9 8.14282 10.7269 8.14282 12.8571C8.14282 14.9874 9.86972 16.7143 12 16.7143Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$E = [];

/* style */
const __vue_inject_styles__$E = undefined;
/* scoped */
const __vue_scope_id__$E = undefined;
/* module identifier */
const __vue_module_identifier__$E = undefined;
/* functional template */
const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, {}, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

var mediumImageCamera = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$E
});

/* script */

/* template */
var __vue_render__$D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.4286 5.14282H2.57146C1.62469 5.14282 0.857178 5.91033 0.857178 6.85711V17.1428C0.857178 18.0896 1.62469 18.8571 2.57146 18.8571H21.4286C22.3754 18.8571 23.1429 18.0896 23.1429 17.1428V6.85711C23.1429 5.91033 22.3754 5.14282 21.4286 5.14282Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.4286 14.5715H12",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.71436 9.42847V14.5713",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.14282 9.42847H10.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$D = [];

/* style */
const __vue_inject_styles__$D = undefined;
/* scoped */
const __vue_scope_id__$D = undefined;
/* module identifier */
const __vue_module_identifier__$D = undefined;
/* functional template */
const __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, {}, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

var mediumInputTextField = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$D
});

/* script */

/* template */
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_8_1632)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.85711 11.1257L1.35425 16.5771C1.19357 16.7365 1.06604 16.9261 0.979008 17.135C0.891976 17.3439 0.847168 17.568 0.847168 17.7943C0.847168 18.0206 0.891976 18.2447 0.979008 18.4536C1.06604 18.6625 1.19357 18.8521 1.35425 19.0114L4.98854 22.6457C5.1479 22.8064 5.3375 22.9339 5.54641 23.021C5.75531 23.108 5.97937 23.1528 6.20568 23.1528C6.43199 23.1528 6.65605 23.108 6.86495 23.021C7.07386 22.9339 7.26346 22.8064 7.42282 22.6457L12.8743 17.1429",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.1429 12.8743L22.5943 7.42285C22.755 7.26349 22.8825 7.07389 22.9695 6.86498C23.0566 6.65608 23.1014 6.43202 23.1014 6.20571C23.1014 5.9794 23.0566 5.75534 22.9695 5.54644C22.8825 5.33753 22.755 5.14793 22.5943 4.98857L19.0114 1.35428C18.8521 1.1936 18.6625 1.06607 18.4536 0.979039C18.2447 0.892007 18.0206 0.847198 17.7943 0.847198C17.568 0.847198 17.3439 0.892007 17.135 0.979039C16.9261 1.06607 16.7365 1.1936 16.5772 1.35428L11.1257 6.85714",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.4287 8.57143L8.57153 15.4286",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_8_1632"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$C = [];

/* style */
const __vue_inject_styles__$C = undefined;
/* scoped */
const __vue_scope_id__$C = undefined;
/* module identifier */
const __vue_module_identifier__$C = undefined;
/* functional template */
const __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, {}, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

var mediumInterfaceLink = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$C
});

/* script */

/* template */
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_4740_3485)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0.800049",
      "y": "0.799805",
      "width": "14.4",
      "height": "14.4",
      "rx": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4.80005 0.799805L4.80005 15.1998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.19971 8L12.7997 8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.19971 10L7.19971 8L9.19971 6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_4740_3485"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$B = [];

/* style */
const __vue_inject_styles__$B = undefined;
/* scoped */
const __vue_scope_id__$B = undefined;
/* module identifier */
const __vue_module_identifier__$B = undefined;
/* functional template */
const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, {}, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

var mediumLayoutColumnLeftHide = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$B
});

/* script */

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_4740_3477)"
    }
  }, [_c('rect', {
    attrs: {
      "width": "14.4",
      "height": "14.4",
      "rx": "2",
      "transform": "matrix(-1 0 0 1 15.2 0.799805)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.2 0.799805L11.2 15.1998",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.80029 8L3.20029 8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.80029 10L8.80029 8L6.80029 6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_4740_3477"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white",
      "transform": "matrix(-1 0 0 1 16 0)"
    }
  })])])]);
};
var __vue_staticRenderFns__$A = [];

/* style */
const __vue_inject_styles__$A = undefined;
/* scoped */
const __vue_scope_id__$A = undefined;
/* module identifier */
const __vue_module_identifier__$A = undefined;
/* functional template */
const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, {}, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var mediumLayoutColumnRightHide = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$A
});

/* script */

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.857178 5C0.857178 3.89543 1.75261 3 2.85718 3H21.1429C22.2475 3 23.1429 3.89543 23.1429 5V19C23.1429 20.1046 22.2475 21 21.1429 21H2.85718C1.75261 21 0.857178 20.1046 0.857178 19V5Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0.857178 5.16846L10.8943 13.6387C11.2036 13.8998 11.5953 14.043 12 14.043C12.4048 14.043 12.7965 13.8998 13.1057 13.6387L23.1429 5.16846",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$z = [];

/* style */
const __vue_inject_styles__$z = undefined;
/* scoped */
const __vue_scope_id__$z = undefined;
/* module identifier */
const __vue_module_identifier__$z = undefined;
/* functional template */
const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, {}, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

var mediumMailEnvelope = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$z
});

/* script */

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_4740_3515)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.1428 0.571289L2.85709 0.571289C2.22591 0.571289 1.71423 1.08296 1.71423 1.71415L1.71423 14.2856C1.71423 14.9168 2.22591 15.4284 2.85709 15.4284L13.1428 15.4284C13.774 15.4284 14.2857 14.9168 14.2857 14.2856L14.2857 1.71415C14.2857 1.08296 13.774 0.571289 13.1428 0.571289Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.71423 6.28516L14.2857 6.28516",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M4.85714 8.57129C4.68762 8.57129 4.5219 8.62156 4.38094 8.71574C4.23998 8.80993 4.13012 8.9438 4.06525 9.10042C4.00037 9.25704 3.9834 9.42938 4.01647 9.59565C4.04954 9.76192 4.13118 9.91465 4.25105 10.0345C4.37093 10.1544 4.52365 10.236 4.68992 10.2691C4.85619 10.3022 5.02854 10.2852 5.18516 10.2203C5.34178 10.1555 5.47565 10.0456 5.56983 9.90463C5.66402 9.76368 5.71429 9.59796 5.71429 9.42843C5.71133 9.20202 5.62007 8.98572 5.45996 8.82561C5.29985 8.6655 5.08355 8.57425 4.85714 8.57129Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M7.99997 8.57129C7.83044 8.57129 7.66472 8.62156 7.52376 8.71574C7.38281 8.80993 7.27294 8.9438 7.20807 9.10042C7.14319 9.25704 7.12622 9.42938 7.15929 9.59565C7.19237 9.76192 7.274 9.91465 7.39387 10.0345C7.51375 10.1544 7.66648 10.236 7.83275 10.2691C7.99901 10.3022 8.17136 10.2852 8.32798 10.2203C8.4846 10.1555 8.61847 10.0456 8.71265 9.90463C8.80684 9.76368 8.85711 9.59796 8.85711 9.42843C8.85415 9.20202 8.76289 8.98572 8.60278 8.82561C8.44268 8.6655 8.22637 8.57425 7.99997 8.57129Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M11.1428 8.57129C10.9733 8.57129 10.8075 8.62156 10.6666 8.71574C10.5256 8.80993 10.4158 8.9438 10.3509 9.10042C10.286 9.25704 10.269 9.42938 10.3021 9.59565C10.3352 9.76192 10.4168 9.91465 10.5367 10.0345C10.6566 10.1544 10.8093 10.236 10.9756 10.2691C11.1418 10.3022 11.3142 10.2852 11.4708 10.2203C11.6274 10.1555 11.7613 10.0456 11.8555 9.90463C11.9497 9.76368 11.9999 9.59796 11.9999 9.42843C11.997 9.20202 11.9057 8.98572 11.7456 8.82561C11.5855 8.6655 11.3692 8.57425 11.1428 8.57129Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M4.85714 11.4287C4.68762 11.4287 4.5219 11.479 4.38094 11.5732C4.23998 11.6673 4.13012 11.8012 4.06525 11.9578C4.00037 12.1145 3.9834 12.2868 4.01647 12.4531C4.04954 12.6193 4.13118 12.7721 4.25105 12.8919C4.37093 13.0118 4.52365 13.0935 4.68992 13.1265C4.85619 13.1596 5.02854 13.1426 5.18516 13.0777C5.34178 13.0129 5.47565 12.903 5.56983 12.7621C5.66402 12.6211 5.71429 12.4554 5.71429 12.2859C5.71133 12.0594 5.62007 11.8431 5.45996 11.683C5.29985 11.5229 5.08355 11.4317 4.85714 11.4287Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M7.99997 11.4287C7.83044 11.4287 7.66472 11.479 7.52376 11.5732C7.38281 11.6673 7.27294 11.8012 7.20807 11.9578C7.14319 12.1145 7.12622 12.2868 7.15929 12.4531C7.19237 12.6193 7.274 12.7721 7.39387 12.8919C7.51375 13.0118 7.66648 13.0935 7.83275 13.1265C7.99901 13.1596 8.17136 13.1426 8.32798 13.0777C8.4846 13.0129 8.61847 12.903 8.71265 12.7621C8.80684 12.6211 8.85711 12.4554 8.85711 12.2859C8.85415 12.0594 8.76289 11.8431 8.60278 11.683C8.44268 11.5229 8.22637 11.4317 7.99997 11.4287Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M11.1428 11.4287C10.9733 11.4287 10.8075 11.479 10.6666 11.5732C10.5256 11.6673 10.4158 11.8012 10.3509 11.9578C10.286 12.1145 10.269 12.2868 10.3021 12.4531C10.3352 12.6193 10.4168 12.7721 10.5367 12.8919C10.6566 13.0118 10.8093 13.0935 10.9756 13.1265C11.1418 13.1596 11.3142 13.1426 11.4708 13.0777C11.6274 13.0129 11.7613 12.903 11.8555 12.7621C11.9497 12.6211 11.9999 12.4554 11.9999 12.2859C11.997 12.0594 11.9057 11.8431 11.7456 11.683C11.5855 11.5229 11.3692 11.4317 11.1428 11.4287Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.4285 3.42871H10.2856",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_4740_3515"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$y = [];

/* style */
const __vue_inject_styles__$y = undefined;
/* scoped */
const __vue_scope_id__$y = undefined;
/* module identifier */
const __vue_module_identifier__$y = undefined;
/* functional template */
const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, {}, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var mediumMoneyCalculator = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$y
});

/* script */

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_428_539)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.4286 12.8571C19.6891 12.8571 23.1429 11.3221 23.1429 9.42857C23.1429 7.53502 19.6891 6 15.4286 6C11.1682 6 7.71436 7.53502 7.71436 9.42857C7.71436 11.3221 11.1682 12.8571 15.4286 12.8571Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.71436 9.42847V19.7142C7.71436 21.5999 11.1429 23.1428 15.4286 23.1428C19.7144 23.1428 23.1429 21.5999 23.1429 19.7142V9.42847",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23.1429 14.5715C23.1429 16.4572 19.7144 18.0001 15.4286 18.0001C11.1429 18.0001 7.71436 16.4572 7.71436 14.5715",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.2572 2.57137C13.254 1.33516 10.9223 0.737285 8.57146 0.857086C4.30289 0.857086 0.857178 2.39994 0.857178 4.28566C0.857178 5.29709 1.85146 6.20566 3.42861 6.85709",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.42861 17.1428C1.85146 16.4914 0.857178 15.5828 0.857178 14.5714V4.28564",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.42861 11.9999C1.85146 11.3485 0.857178 10.4399 0.857178 9.42847",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_428_539"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$x = [];

/* style */
const __vue_inject_styles__$x = undefined;
/* scoped */
const __vue_scope_id__$x = undefined;
/* module identifier */
const __vue_module_identifier__$x = undefined;
/* functional template */
const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, {}, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var mediumMoneyCoins = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$x
});

/* script */

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-money-graph-bar-increase-square",
      "clip-path": "url(#clip0_6165_681)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M11.5 21H6V15H11.5V21ZM11.5 21V11H16.5V21M11.5 21H16.5M16.5 21L16.5 7H22V21H16.5ZM25 1H3C1.89543 1 1 1.89543 1 3V25C1 26.1046 1.89543 27 3 27H25C26.1046 27 27 26.1046 27 25V3C27 1.89543 26.1046 1 25 1Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_6165_681"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "28",
      "height": "28",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$w = [];

/* style */
const __vue_inject_styles__$w = undefined;
/* scoped */
const __vue_scope_id__$w = undefined;
/* module identifier */
const __vue_module_identifier__$w = undefined;
/* functional template */
const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, {}, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

var mediumMoneyGraphBarIncreaseSquare = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$w
});

/* script */

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_2000_483)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.714233 19.2856H19.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.42852 19.2857V0.714233H0.714233V19.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.1428 19.2856V9.28564H6.42847V19.2856",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.8571 19.2857V5H12.1428V19.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2000_483"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$v = [];

/* style */
const __vue_inject_styles__$v = undefined;
/* scoped */
const __vue_scope_id__$v = undefined;
/* module identifier */
const __vue_module_identifier__$v = undefined;
/* functional template */
const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, {}, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

var mediumMoneyGraphBar = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$v
});

/* script */

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M19 14C20.1046 14 21 13.1046 21 12C21 10.8954 20.1046 10 19 10C17.8954 10 17 10.8954 17 12C17 13.1046 17.8954 14 19 14Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
      "fill": "black"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "d": "M5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14Z",
      "fill": "black"
    }
  })]);
};
var __vue_staticRenderFns__$u = [];

/* style */
const __vue_inject_styles__$u = undefined;
/* scoped */
const __vue_scope_id__$u = undefined;
/* module identifier */
const __vue_module_identifier__$u = undefined;
/* functional template */
const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, {}, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var mediumMoreMenuHorizontal = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$u
});

/* script */

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "17",
      "viewBox": "0 0 16 17",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-more-menu-vertical"
    }
  }, [_c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector",
      "d": "M7.99935 5.16667C8.73573 5.16667 9.33268 4.56971 9.33268 3.83333C9.33268 3.09695 8.73573 2.5 7.99935 2.5C7.26297 2.5 6.66602 3.09695 6.66602 3.83333C6.66602 4.56971 7.26297 5.16667 7.99935 5.16667Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector_2",
      "d": "M7.99935 9.83317C8.73573 9.83317 9.33268 9.23622 9.33268 8.49984C9.33268 7.76346 8.73573 7.1665 7.99935 7.1665C7.26297 7.1665 6.66602 7.76346 6.66602 8.49984C6.66602 9.23622 7.26297 9.83317 7.99935 9.83317Z",
      "fill": "#687076"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fill-override",
    attrs: {
      "id": "Vector_3",
      "d": "M7.99935 14.5002C8.73573 14.5002 9.33268 13.9032 9.33268 13.1668C9.33268 12.4304 8.73573 11.8335 7.99935 11.8335C7.26297 11.8335 6.66602 12.4304 6.66602 13.1668C6.66602 13.9032 7.26297 14.5002 7.99935 14.5002Z",
      "fill": "#687076"
    }
  })])]);
};
var __vue_staticRenderFns__$t = [];

/* style */
const __vue_inject_styles__$t = undefined;
/* scoped */
const __vue_scope_id__$t = undefined;
/* module identifier */
const __vue_module_identifier__$t = undefined;
/* functional template */
const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, {}, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var mediumMoreMenuVertical = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$t
});

/* script */

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-network-cluster",
      "clip-path": "url(#clip0_2000_468)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Vector",
      "d": "M2.85709 4.99995C4.04056 4.99995 4.99995 4.04056 4.99995 2.85709C4.99995 1.67362 4.04056 0.714233 2.85709 0.714233C1.67362 0.714233 0.714233 1.67362 0.714233 2.85709C0.714233 4.04056 1.67362 4.99995 2.85709 4.99995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_2",
      "d": "M10 4.99995C11.1835 4.99995 12.1429 4.04056 12.1429 2.85709C12.1429 1.67362 11.1835 0.714233 10 0.714233C8.81657 0.714233 7.85718 1.67362 7.85718 2.85709C7.85718 4.04056 8.81657 4.99995 10 4.99995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_3",
      "d": "M17.1429 4.99995C18.3263 4.99995 19.2857 4.04056 19.2857 2.85709C19.2857 1.67362 18.3263 0.714233 17.1429 0.714233C15.9594 0.714233 15 1.67362 15 2.85709C15 4.04056 15.9594 4.99995 17.1429 4.99995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_4",
      "d": "M2.85709 12.1429C4.04056 12.1429 4.99995 11.1835 4.99995 10C4.99995 8.81657 4.04056 7.85718 2.85709 7.85718C1.67362 7.85718 0.714233 8.81657 0.714233 10C0.714233 11.1835 1.67362 12.1429 2.85709 12.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_5",
      "d": "M10 12.1429C11.1835 12.1429 12.1429 11.1835 12.1429 10C12.1429 8.81657 11.1835 7.85718 10 7.85718C8.81657 7.85718 7.85718 8.81657 7.85718 10C7.85718 11.1835 8.81657 12.1429 10 12.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_6",
      "d": "M17.1429 12.1429C18.3263 12.1429 19.2857 11.1835 19.2857 10C19.2857 8.81657 18.3263 7.85718 17.1429 7.85718C15.9594 7.85718 15 8.81657 15 10C15 11.1835 15.9594 12.1429 17.1429 12.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_7",
      "d": "M2.85709 19.2857C4.04056 19.2857 4.99995 18.3263 4.99995 17.1429C4.99995 15.9594 4.04056 15 2.85709 15C1.67362 15 0.714233 15.9594 0.714233 17.1429C0.714233 18.3263 1.67362 19.2857 2.85709 19.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_8",
      "d": "M10 19.2857C11.1835 19.2857 12.1429 18.3263 12.1429 17.1429C12.1429 15.9594 11.1835 15 10 15C8.81657 15 7.85718 15.9594 7.85718 17.1429C7.85718 18.3263 8.81657 19.2857 10 19.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_9",
      "d": "M17.1429 19.2857C18.3263 19.2857 19.2857 18.3263 19.2857 17.1429C19.2857 15.9594 18.3263 15 17.1429 15C15.9594 15 15 15.9594 15 17.1429C15 18.3263 15.9594 19.2857 17.1429 19.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_10",
      "d": "M4.37146 4.37146L8.48575 8.48575",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_11",
      "d": "M4.37146 15.6286L8.48575 11.5143",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "Vector_12",
      "d": "M11.5143 8.48575L15.6286 4.37146",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2000_468"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$s = [];

/* style */
const __vue_inject_styles__$s = undefined;
/* scoped */
const __vue_scope_id__$s = undefined;
/* module identifier */
const __vue_module_identifier__$s = undefined;
/* functional template */
const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, {}, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var mediumNetworkCluster = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$s
});

/* script */

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 12H20",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$r = [];

/* style */
const __vue_inject_styles__$r = undefined;
/* scoped */
const __vue_scope_id__$r = undefined;
/* module identifier */
const __vue_module_identifier__$r = undefined;
/* functional template */
const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, {}, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

var mediumRemove1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$r
});

/* script */

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_2000_499)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.47142 3.21423L8.0857 1.62852C8.1893 1.36004 8.37157 1.12911 8.60863 0.965965C8.8457 0.802825 9.1265 0.715083 9.41428 0.714233H10.5857C10.8735 0.715083 11.1543 0.802825 11.3913 0.965965C11.6284 1.12911 11.8107 1.36004 11.9143 1.62852L12.5286 3.21423L14.6143 4.41423L16.3 4.15709C16.5807 4.11899 16.8664 4.1652 17.1207 4.28984C17.3751 4.41448 17.5867 4.61193 17.7286 4.85709L18.3 5.85709C18.4464 6.10616 18.5139 6.39378 18.4935 6.68198C18.4731 6.97018 18.3658 7.24542 18.1857 7.47138L17.1428 8.79995V11.1999L18.2143 12.5285C18.3943 12.7545 18.5016 13.0297 18.522 13.3179C18.5425 13.6061 18.475 13.8937 18.3286 14.1428L17.7571 15.1428C17.6152 15.388 17.4037 15.5854 17.1493 15.7101C16.8949 15.8347 16.6093 15.8809 16.3286 15.8428L14.6428 15.5857L12.5571 16.7857L11.9428 18.3714C11.8392 18.6399 11.657 18.8708 11.4199 19.0339C11.1829 19.1971 10.902 19.2848 10.6143 19.2857H9.41428C9.1265 19.2848 8.8457 19.1971 8.60863 19.0339C8.37157 18.8708 8.1893 18.6399 8.0857 18.3714L7.47142 16.7857L5.3857 15.5857L3.69999 15.8428C3.4193 15.8809 3.13362 15.8347 2.87925 15.7101C2.62488 15.5854 2.41331 15.388 2.27142 15.1428L1.69999 14.1428C1.55356 13.8937 1.4861 13.6061 1.5065 13.3179C1.52691 13.0297 1.63422 12.7545 1.81428 12.5285L2.85713 11.1999V8.79995L1.7857 7.47138C1.60565 7.24542 1.49834 6.97018 1.47793 6.68198C1.45753 6.39378 1.52499 6.10616 1.67142 5.85709L2.24285 4.85709C2.38474 4.61193 2.59631 4.41448 2.85068 4.28984C3.10505 4.1652 3.39073 4.11899 3.67142 4.15709L5.35713 4.41423L7.47142 3.21423ZM7.14285 9.99995C7.14285 10.565 7.31042 11.1174 7.62436 11.5873C7.93831 12.0571 8.38453 12.4234 8.90661 12.6396C9.42868 12.8559 10.0032 12.9124 10.5574 12.8022C11.1116 12.6919 11.6207 12.4198 12.0203 12.0203C12.4199 11.6207 12.692 11.1116 12.8022 10.5573C12.9125 10.0031 12.8559 9.42864 12.6396 8.90657C12.4234 8.38449 12.0572 7.93827 11.5873 7.62432C11.1175 7.31037 10.5651 7.14281 9.99999 7.14281C9.24223 7.14281 8.5155 7.44382 7.97969 7.97964C7.44387 8.51546 7.14285 9.24219 7.14285 9.99995V9.99995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2000_499"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$q = [];

/* style */
const __vue_inject_styles__$q = undefined;
/* scoped */
const __vue_scope_id__$q = undefined;
/* module identifier */
const __vue_module_identifier__$q = undefined;
/* functional template */
const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, {}, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var mediumSettingCog = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$q
});

/* script */

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-setting-slider-horizontal-square"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M4.2853 6.42864H11.4282M11.4282 6.42864C11.4282 7.61211 12.3875 8.5715 13.571 8.5715C14.7545 8.5715 15.7139 7.61211 15.7139 6.42864C15.7139 5.24517 14.7545 4.28578 13.571 4.28578C12.3875 4.28578 11.4282 5.24517 11.4282 6.42864ZM15.7139 13.5715H11.4282M11.4282 13.5715C11.4282 14.755 10.4688 15.7144 9.2853 15.7144C8.10183 15.7144 7.14244 14.755 7.14244 13.5715M11.4282 13.5715C11.4282 12.388 10.4688 11.4286 9.2853 11.4286C8.10183 11.4286 7.14244 12.388 7.14244 13.5715M7.14244 13.5715H4.2853M2.14244 0.714355H17.8567C18.6457 0.714355 19.2853 1.35395 19.2853 2.14293V17.8572C19.2853 18.6462 18.6457 19.2858 17.8567 19.2858H2.14244C1.35346 19.2858 0.713867 18.6462 0.713867 17.8572V2.14293C0.713867 1.35395 1.35346 0.714355 2.14244 0.714355Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1119_228"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$p = [];

/* style */
const __vue_inject_styles__$p = undefined;
/* scoped */
const __vue_scope_id__$p = undefined;
/* module identifier */
const __vue_module_identifier__$p = undefined;
/* functional template */
const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, {}, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

var mediumSettingSliderHorizontalSquare = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$p
});

/* script */

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.42861 10.2857C4.84877 10.2857 6.00003 9.13444 6.00003 7.71428C6.00003 6.29412 4.84877 5.14285 3.42861 5.14285C2.00845 5.14285 0.857178 6.29412 0.857178 7.71428C0.857178 9.13444 2.00845 10.2857 3.42861 10.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.42871 10.2857V23.1428",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.42871 0.857147V5.14286",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5714 10.2857C21.9916 10.2857 23.1429 9.13444 23.1429 7.71428C23.1429 6.29412 21.9916 5.14285 20.5714 5.14285C19.1513 5.14285 18 6.29412 18 7.71428C18 9.13444 19.1513 10.2857 20.5714 10.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5715 5.14286V0.857147",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20.5715 23.1428V10.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.0001 14.5714C13.4203 14.5714 14.5716 13.4202 14.5716 12C14.5716 10.5799 13.4203 9.42859 12.0001 9.42859C10.58 9.42859 9.42871 10.5799 9.42871 12C9.42871 13.4202 10.58 14.5714 12.0001 14.5714Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 0.857147V9.42858",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 14.5714V23.1429",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$o = [];

/* style */
const __vue_inject_styles__$o = undefined;
/* scoped */
const __vue_scope_id__$o = undefined;
/* module identifier */
const __vue_module_identifier__$o = undefined;
/* functional template */
const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, {}, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

var mediumSettingSlider = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$o
});

/* script */

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-upload-1",
      "clip-path": "url(#clip0_2691_247)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M0.85714 18V19.7143C0.85714 20.6236 1.21836 21.4956 1.86134 22.1386C2.50433 22.7816 3.3764 23.1428 4.28571 23.1428H19.7143C20.6236 23.1428 21.4957 22.7816 22.1386 22.1386C22.7816 21.4956 23.1429 20.6236 23.1429 19.7143V18M6.85714 6.85712L12 0.857117M12 0.857117L17.1429 6.85712M12 0.857117V16.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2691_247"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$n = [];

/* style */
const __vue_inject_styles__$n = undefined;
/* scoped */
const __vue_scope_id__$n = undefined;
/* module identifier */
const __vue_module_identifier__$n = undefined;
/* functional template */
const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, {}, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

var mediumUpload1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$n
});

/* script */

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_8_1616)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.5715 8.5714C10.7017 8.5714 12.4286 6.8445 12.4286 4.71426C12.4286 2.58402 10.7017 0.857117 8.5715 0.857117C6.44126 0.857117 4.71436 2.58402 4.71436 4.71426C4.71436 6.8445 6.44126 8.5714 8.5715 8.5714Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5714 23.1429C20.6484 23.1429 23.1429 20.6484 23.1429 17.5714C23.1429 14.4944 20.6484 12 17.5714 12C14.4944 12 12 14.4944 12 17.5714C12 20.6484 14.4944 23.1429 17.5714 23.1429Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.6287 21.5143L21.5144 13.6286",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.2858 11.3314C9.15538 11.0705 7.9806 11.0684 6.84927 11.3254C5.71795 11.5824 4.65935 12.0918 3.75263 12.8155C2.8459 13.5392 2.1145 14.4586 1.61312 15.5048C1.11173 16.551 0.853325 17.697 0.857221 18.8571V21.4286",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_8_1616"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$m = [];

/* style */
const __vue_inject_styles__$m = undefined;
/* scoped */
const __vue_scope_id__$m = undefined;
/* module identifier */
const __vue_module_identifier__$m = undefined;
/* functional template */
const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, {}, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

var mediumUserBlock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$m
});

/* script */

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-user-delete"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M0.713868 17.8572V15.7144C0.713516 14.5885 1.00883 13.4823 1.57027 12.5065C2.1317 11.5307 2.93957 10.7194 3.91303 10.1538C4.88649 9.58824 5.99141 9.28824 7.11723 9.28382C8.24305 9.27941 9.35029 9.57073 10.3282 10.1286M19.2853 13.2286L13.2282 19.2858M13.2282 13.2286L19.2853 19.2858M10.3567 3.92864C10.3567 5.70384 8.91764 7.14293 7.14244 7.14293C5.36724 7.14293 3.92815 5.70384 3.92815 3.92864C3.92815 2.15344 5.36724 0.714355 7.14244 0.714355C8.91764 0.714355 10.3567 2.15344 10.3567 3.92864Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1119_1225"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$l = [];

/* style */
const __vue_inject_styles__$l = undefined;
/* scoped */
const __vue_scope_id__$l = undefined;
/* module identifier */
const __vue_module_identifier__$l = undefined;
/* functional template */
const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, {}, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var mediumUserDelete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$l
});

/* script */

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-user-multiple",
      "clip-path": "url(#clip0_2000_460)"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M7.14287 8.57139C8.91808 8.57139 10.3572 7.13231 10.3572 5.35711C10.3572 3.58191 8.91808 2.14282 7.14287 2.14282C5.36767 2.14282 3.92859 3.58191 3.92859 5.35711C3.92859 7.13231 5.36767 8.57139 7.14287 8.57139Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M13.5714 19.2857V17.8572C13.5714 16.1522 12.8941 14.5171 11.6885 13.3115C10.4829 12.1059 8.84777 11.4286 7.14281 11.4286C5.43784 11.4286 3.80271 12.1059 2.59712 13.3115C1.39153 14.5171 0.714233 16.1522 0.714233 17.8572V19.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_3",
      "d": "M12.8572 2.14282C13.7097 2.14282 14.5272 2.48147 15.13 3.08426C15.7328 3.68706 16.0715 4.50463 16.0715 5.35711C16.0715 6.20959 15.7328 7.02716 15.13 7.62995C14.5272 8.23275 13.7097 8.57139 12.8572 8.57139",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_4",
      "d": "M15.1428 11.7C16.3597 12.1629 17.4074 12.9844 18.1472 14.0558C18.8869 15.1272 19.284 16.398 19.2857 17.7V19.2857",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2000_460"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$k = [];

/* style */
const __vue_inject_styles__$k = undefined;
/* scoped */
const __vue_scope_id__$k = undefined;
/* module identifier */
const __vue_module_identifier__$k = undefined;
/* functional template */
const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, {}, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var mediumUserMultiple = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$k
});

/* script */

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-user-profile-focus"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M12.7829 13.2857C11.7386 12.3633 10.3933 11.8543 9.00001 11.8543C7.60672 11.8543 6.26143 12.3633 5.21716 13.2857M16.4286 13V15.2857C16.4286 15.5888 16.3082 15.8795 16.0938 16.0938C15.8795 16.3081 15.5888 16.4286 15.2857 16.4286H13M13 1.57141H15.2857C15.5888 1.57141 15.8795 1.69182 16.0938 1.90615C16.3082 2.12047 16.4286 2.41116 16.4286 2.71427V4.99998M1.57144 4.99998V2.71427C1.57144 2.41116 1.69185 2.12047 1.90618 1.90615C2.1205 1.69182 2.41119 1.57141 2.7143 1.57141H5.00001M5.00001 16.4286H2.7143C2.41119 16.4286 2.1205 16.3081 1.90618 16.0938C1.69185 15.8795 1.57144 15.5888 1.57144 15.2857V13M11.8572 7.2857C11.8572 8.86365 10.578 10.1428 9.00001 10.1428C7.42206 10.1428 6.14287 8.86365 6.14287 7.2857C6.14287 5.70774 7.42206 4.42855 9.00001 4.42855C10.578 4.42855 11.8572 5.70774 11.8572 7.2857Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]);
};
var __vue_staticRenderFns__$j = [];

/* style */
const __vue_inject_styles__$j = undefined;
/* scoped */
const __vue_scope_id__$j = undefined;
/* module identifier */
const __vue_module_identifier__$j = undefined;
/* functional template */
const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, {}, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

var mediumUserProfileFocus = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$j
});

/* script */

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "medium-user-single",
      "clip-path": "url(#clip0_2000_697)"
    }
  }, [_c('path', {
    attrs: {
      "id": "vector",
      "d": "M8.00005 7.99998C10.0514 7.99998 11.7143 6.33704 11.7143 4.2857C11.7143 2.23435 10.0514 0.571411 8.00005 0.571411C5.94871 0.571411 4.28577 2.23435 4.28577 4.2857C4.28577 6.33704 5.94871 7.99998 8.00005 7.99998Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "vector_2",
      "d": "M15.0628 15.4285C14.5831 13.9324 13.6405 12.6272 12.3712 11.7013C11.1018 10.7753 9.5712 10.2764 7.99999 10.2764C6.42879 10.2764 4.89817 10.7753 3.62881 11.7013C2.35945 12.6272 1.41693 13.9324 0.937134 15.4285",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_2000_697"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "16",
      "height": "16",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$i = [];

/* style */
const __vue_inject_styles__$i = undefined;
/* scoped */
const __vue_scope_id__$i = undefined;
/* module identifier */
const __vue_module_identifier__$i = undefined;
/* functional template */
const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, {}, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var mediumUserSingle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$i
});

/* script */

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 8.57141V13.7143",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 19.7143C12.4734 19.7143 12.8571 19.3305 12.8571 18.8571C12.8571 18.3838 12.4734 18 12 18C11.5266 18 11.1428 18.3838 11.1428 18.8571C11.1428 19.3305 11.5266 19.7143 12 19.7143Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.5257 1.79995C13.3818 1.51915 13.1633 1.28349 12.8941 1.11894C12.6249 0.954381 12.3155 0.86731 12 0.86731C11.6845 0.86731 11.3751 0.954381 11.1059 1.11894C10.8367 1.28349 10.6181 1.51915 10.4743 1.79995L1.04569 20.6571C0.914186 20.9181 0.851577 21.2083 0.863807 21.5003C0.876037 21.7922 0.962701 22.0762 1.11557 22.3253C1.26844 22.5743 1.48243 22.7802 1.73723 22.9233C1.99203 23.0663 2.27918 23.1419 2.5714 23.1428H21.4285C21.7208 23.1419 22.0079 23.0663 22.2627 22.9233C22.5175 22.7802 22.7315 22.5743 22.8844 22.3253C23.0372 22.0762 23.1239 21.7922 23.1361 21.5003C23.1484 21.2083 23.0858 20.9181 22.9543 20.6571L13.5257 1.79995Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$h = [];

/* style */
const __vue_inject_styles__$h = undefined;
/* scoped */
const __vue_scope_id__$h = undefined;
/* module identifier */
const __vue_module_identifier__$h = undefined;
/* functional template */
const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, {}, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

var mediumWarningTriangle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$h
});

/* script */

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "large-ai-spark-document"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M1.81836 30.4755C5.86798 29.6615 9.12841 26.3613 9.94376 22.207C10.7591 26.3613 14.0187 29.6615 18.0683 30.4755M18.0683 30.4803C14.0187 31.2943 10.7583 34.5945 9.94296 38.7488C9.12761 34.5945 5.86798 31.2943 1.81836 30.4803M17.2253 38.75H34.849C36.6898 38.75 38.1823 37.2577 38.1823 35.4167V13.535C38.1822 12.8724 37.919 12.237 37.4507 11.7683L27.664 1.98167C27.1953 1.5133 26.5598 1.25014 25.8973 1.25H8.18229C6.82063 1.25 5.68229 2.38833 5.68229 3.75V17.779M38.1823 13.75H28.1823C27.5193 13.75 26.8833 13.4866 26.4145 13.0178C25.9457 12.5489 25.6823 11.913 25.6823 11.25V1.25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1123_3196"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "40",
      "height": "40",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$g = [];

/* style */
const __vue_inject_styles__$g = undefined;
/* scoped */
const __vue_scope_id__$g = undefined;
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, {}, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

var largeAiSparkDocument = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$g
});

/* script */

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1 9.00781H41",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.03198 5.50781C6.75584 5.50781 6.53198 5.28395 6.53198 5.00781C6.53198 4.73167 6.75584 4.50781 7.03198 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.03198 5.50781C7.30812 5.50781 7.53198 5.28395 7.53198 5.00781C7.53198 4.73167 7.30812 4.50781 7.03198 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.032 5.50781C10.7558 5.50781 10.532 5.28395 10.532 5.00781C10.532 4.73167 10.7558 4.50781 11.032 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.032 5.50781C11.3081 5.50781 11.532 5.28395 11.532 5.00781C11.532 4.73167 11.3081 4.50781 11.032 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.032 5.50781C14.7558 5.50781 14.532 5.28395 14.532 5.00781C14.532 4.73167 14.7558 4.50781 15.032 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.032 5.50781C15.3081 5.50781 15.532 5.28395 15.532 5.00781C15.532 4.73167 15.3081 4.50781 15.032 4.50781"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.5 33H5C3.93914 33 2.92172 32.5786 2.17158 31.8284C1.42143 31.0782 1 30.0608 1 29V5C1 3.93914 1.42143 2.92172 2.17158 2.17158C2.92172 1.42143 3.93914 1 5 1H37C38.0608 1 39.0782 1.42143 39.8284 2.17158C40.5786 2.92172 41 3.93914 41 5V18.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45 41C45.183 40.9978 45.362 40.9455 45.5173 40.8487C45.6726 40.7518 45.7984 40.6142 45.8809 40.4509C45.9634 40.2875 45.9995 40.1046 45.9853 39.9221C45.971 39.7396 45.9069 39.5645 45.8 39.416C44.6344 37.9788 43.9989 36.1844 44 34.334V31.334C44.0338 29.3035 43.3159 27.3321 41.9843 25.7989C40.6526 24.2657 38.8012 23.2788 36.786 23.028C35.6737 22.9181 34.5506 23.0426 33.4893 23.3934C32.4281 23.7442 31.4521 24.3135 30.6243 25.0646C29.7965 25.8157 29.1353 26.7319 28.6833 27.7542C28.2313 28.7765 27.9985 29.8822 28 31V34.334C28.0012 36.1844 27.3656 37.9788 26.2 39.416C26.0931 39.5645 26.029 39.7396 26.0148 39.9221C26.0005 40.1046 26.0366 40.2875 26.1191 40.4509C26.2016 40.6142 26.3274 40.7518 26.4827 40.8487C26.6381 40.9455 26.817 40.9978 27 41H45Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33.428 45C33.5735 45.5717 33.9053 46.0787 34.3711 46.4407C34.8369 46.8028 35.41 46.9994 36 46.9994C36.5899 46.9994 37.1631 46.8028 37.6288 46.4407C38.0946 46.0787 38.4265 45.5717 38.572 45",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$f = [];

/* style */
const __vue_inject_styles__$f = undefined;
/* scoped */
const __vue_scope_id__$f = undefined;
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, {}, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var largeBrowserNotification = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$f
});

/* script */

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_115_1229)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 17H28",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 23H21",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 11H23",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 29H17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 35H17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 47H3C2.46957 47 1.96086 46.7893 1.58579 46.4142C1.21071 46.0391 1 45.5304 1 45V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H29.586C30.1164 1.00011 30.625 1.2109 31 1.586L38.414 9C38.7891 9.37499 38.9999 9.88361 39 10.414V17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 35C23 38.1826 24.2643 41.2348 26.5147 43.4853C28.7652 45.7357 31.8174 47 35 47C38.1826 47 41.2348 45.7357 43.4853 43.4853C45.7357 41.2348 47 38.1826 47 35C47 31.8174 45.7357 28.7652 43.4853 26.5147C41.2348 24.2643 38.1826 23 35 23C31.8174 23 28.7652 24.2643 26.5147 26.5147C24.2643 28.7652 23 31.8174 23 35Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.3479 31.512L34.5379 39.258C34.4086 39.4296 34.2441 39.5716 34.0554 39.6744C33.8666 39.7771 33.6581 39.8382 33.4437 39.8536C33.2294 39.8689 33.0143 39.8382 32.8128 39.7634C32.6114 39.6886 32.4283 39.5715 32.2759 39.42L29.2759 36.42",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_115_1229"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = undefined;
/* scoped */
const __vue_scope_id__$e = undefined;
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, {}, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var largeCommonFileTextCheck = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$e
});

/* script */

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "40",
      "height": "41",
      "viewBox": "0 0 40 41",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "large-file-search"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M39.1663 39.6667L33.753 34.2533M19.1663 39.6667H2.49967C2.05765 39.6667 1.63372 39.4911 1.32116 39.1785C1.0086 38.866 0.833008 38.442 0.833008 38V3.00001C0.833008 2.55798 1.0086 2.13406 1.32116 1.8215C1.63372 1.50894 2.05765 1.33334 2.49967 1.33334H24.6547C25.0967 1.33344 25.5205 1.50909 25.833 1.82168L32.0113 8.00001C32.3239 8.3125 32.4996 8.73635 32.4997 9.17834V16.3333M20.833 28.8817C20.833 30.8836 21.6283 32.8036 23.0439 34.2192C24.4595 35.6347 26.3794 36.43 28.3813 36.43C30.3833 36.43 32.3032 35.6347 33.7188 34.2192C35.1344 32.8036 35.9297 30.8836 35.9297 28.8817C35.9297 26.8797 35.1344 24.9598 33.7188 23.5442C32.3032 22.1286 30.3833 21.3333 28.3813 21.3333C26.3794 21.3333 24.4595 22.1286 23.0439 23.5442C21.6283 24.9598 20.833 26.8797 20.833 28.8817Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1123_47"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "40",
      "height": "40",
      "fill": "white",
      "transform": "translate(0 0.5)"
    }
  })])])]);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = undefined;
/* scoped */
const __vue_scope_id__$d = undefined;
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, {}, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

var largeFileSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$d
});

/* script */

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "id": "large-file-settings"
    }
  }, [_c('path', {
    attrs: {
      "id": "Icon",
      "d": "M17.4997 39.1666H2.49967C2.05765 39.1666 1.63372 38.991 1.32116 38.6784C1.0086 38.3659 0.833008 37.9419 0.833008 37.4999V2.49992C0.833008 2.05789 1.0086 1.63397 1.32116 1.32141C1.63372 1.00885 2.05765 0.833252 2.49967 0.833252H24.6547C25.0967 0.833346 25.5205 1.009 25.833 1.32159L32.0113 7.49992C32.3239 7.81241 32.4996 8.23626 32.4997 8.67825V14.1666M27.1815 28.2772C27.1815 28.9124 27.4339 29.5216 27.883 29.9707C28.3322 30.4199 28.9413 30.6722 29.5765 30.6722C30.2117 30.6722 30.8209 30.4199 31.2701 29.9707C31.7192 29.5216 31.9715 28.9124 31.9715 28.2772C31.9715 27.642 31.7192 27.0328 31.2701 26.5837C30.8209 26.1345 30.2117 25.8822 29.5765 25.8822C28.9413 25.8822 28.3322 26.1345 27.883 26.5837C27.4339 27.0328 27.1815 27.642 27.1815 28.2772ZM31.6115 19.0089L32.3182 21.3289C32.434 21.7142 32.692 22.041 33.0399 22.2431C33.3878 22.4452 33.7995 22.5074 34.1915 22.4172L36.5449 21.8722C36.9906 21.7718 37.4567 21.8167 37.875 22.0004C38.2933 22.1842 38.6418 22.4971 38.8693 22.8933C39.0969 23.2895 39.1915 23.7481 39.1394 24.202C39.0873 24.6559 38.8912 25.0812 38.5799 25.4156L36.9332 27.1906C36.6615 27.4859 36.5106 27.8726 36.5106 28.2739C36.5106 28.6752 36.6615 29.0619 36.9332 29.3572L38.5799 31.1322C38.8912 31.4666 39.0873 31.8918 39.1394 32.3457C39.1915 32.7997 39.0969 33.2583 38.8693 33.6545C38.6418 34.0507 38.2933 34.3636 37.875 34.5473C37.4567 34.7311 36.9906 34.776 36.5449 34.6756L34.1915 34.1289C33.7996 34.0422 33.3894 34.1071 33.0434 34.3106C32.6974 34.514 32.4413 34.8409 32.3265 35.2256L31.6199 37.5456C31.4883 37.983 31.2194 38.3664 30.8528 38.6389C30.4863 38.9115 30.0416 39.0587 29.5849 39.0587C29.1281 39.0587 28.6835 38.9115 28.3169 38.6389C27.9504 38.3664 27.6814 37.983 27.5499 37.5456L26.8349 35.2256C26.7184 34.8407 26.4602 34.5144 26.1126 34.3124C25.7649 34.1104 25.3535 34.0478 24.9615 34.1372L22.6082 34.6839C22.1625 34.7843 21.6963 34.7394 21.278 34.5557C20.8597 34.3719 20.5113 34.059 20.2837 33.6628C20.0562 33.2666 19.9615 32.808 20.0136 32.3541C20.0657 31.9002 20.2618 31.4749 20.5732 31.1406L22.2199 29.3656C22.4916 29.0702 22.6424 28.6835 22.6424 28.2822C22.6424 27.8809 22.4916 27.4942 22.2199 27.1989L20.5732 25.4239C20.2618 25.0895 20.0657 24.6643 20.0136 24.2104C19.9615 23.7565 20.0562 23.2978 20.2837 22.9016C20.5113 22.5054 20.8597 22.1925 21.278 22.0088C21.6963 21.825 22.1625 21.7801 22.6082 21.8806L24.9615 22.4256C25.3536 22.5158 25.7653 22.4535 26.1132 22.2514C26.461 22.0493 26.719 21.7225 26.8349 21.3372L27.5415 19.0172C27.6722 18.5795 27.9403 18.1956 28.3063 17.9223C28.6723 17.649 29.1167 17.5009 29.5734 17.4999C30.0302 17.499 30.4751 17.6453 30.8422 17.9171C31.2094 18.1889 31.4791 18.5717 31.6115 19.0089Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs')]);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = undefined;
/* scoped */
const __vue_scope_id__$c = undefined;
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, {}, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

var largeFileSettings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$c
});

/* script */

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_115_1226)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M25 34.058C25 36.4603 25.9543 38.7643 27.653 40.463C29.3517 42.1617 31.6557 43.116 34.058 43.116C36.4603 43.116 38.7643 42.1617 40.463 40.463C42.1617 38.7643 43.116 36.4603 43.116 34.058C43.116 31.6557 42.1617 29.3517 40.463 27.653C38.7643 25.9543 36.4603 25 34.058 25C31.6557 25 29.3517 25.9543 27.653 27.653C25.9543 29.3517 25 31.6557 25 34.058V34.058Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M47 46.9999L40.504 40.5039",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 17H28",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 23H21",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 11H23",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 29H17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 35H17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M25 47H3C2.46957 47 1.96086 46.7893 1.58579 46.4142C1.21071 46.0391 1 45.5304 1 45V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H29.586C30.1164 1.00011 30.625 1.2109 31 1.586L38.414 9C38.7891 9.37499 38.9999 9.88361 39 10.414V19",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_115_1226"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = undefined;
/* scoped */
const __vue_scope_id__$b = undefined;
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, {}, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var largeFileTextSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$b
});

/* script */

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_115_1510)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 17H28",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 23H28",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 11H23",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 29H23",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 35H18",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17 47H3C2.46956 47 1.96086 46.7892 1.58579 46.4142C1.21071 46.0392 1 45.5304 1 45V3C1 2.46956 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46956 1 3 1H29.586C30.1164 1.00011 30.625 1.2109 31 1.586L38.414 9C38.7892 9.37498 38.9998 9.8836 39 10.414V17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 37V31",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M36.676 25.0001C36.5138 24.6965 36.2724 24.4427 35.9772 24.2657C35.682 24.0885 35.3442 23.9951 35 23.9951C34.6558 23.9951 34.318 24.0885 34.0228 24.2657C33.7278 24.4427 33.4862 24.6965 33.324 25.0001L23.212 44.2701C23.0626 44.5539 22.9898 44.8717 23.0006 45.1923C23.0116 45.5129 23.1058 45.8251 23.274 46.0981C23.4444 46.3725 23.6822 46.5989 23.9646 46.7557C24.247 46.9127 24.565 46.9947 24.888 46.9941H45.112C45.435 46.9947 45.753 46.9127 46.0354 46.7557C46.3178 46.5989 46.5556 46.3725 46.726 46.0981C46.8942 45.8251 46.9884 45.5129 46.9994 45.1923C47.0102 44.8717 46.9374 44.5539 46.788 44.2701L36.676 25.0001Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 42C34.7238 42 34.5 41.7762 34.5 41.5C34.5 41.2238 34.7238 41 35 41"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 42C35.2762 42 35.5 41.7762 35.5 41.5C35.5 41.2238 35.2762 41 35 41"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_115_1510"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = undefined;
/* scoped */
const __vue_scope_id__$a = undefined;
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, {}, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var largeFileTextWarning = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$a
});

/* script */

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 35C23 38.1826 24.2643 41.2348 26.5147 43.4853C28.7652 45.7357 31.8174 47 35 47C38.1826 47 41.2348 45.7357 43.4853 43.4853C45.7357 41.2348 47 38.1826 47 35C47 31.8174 45.7357 28.7652 43.4853 26.5147C41.2348 24.2643 38.1826 23 35 23C31.8174 23 28.7652 24.2643 26.5147 26.5147C24.2643 28.7652 23 31.8174 23 35Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 41V29",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 29L30.5 33.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M35 29L39.5 33.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 47H3C2.46957 47 1.96086 46.7893 1.58579 46.4142C1.21071 46.0391 1 45.5304 1 45V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H29.586C30.1164 1.00011 30.625 1.2109 31 1.586L38.414 9C38.7891 9.37499 38.9999 9.88361 39 10.414V17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = undefined;
/* scoped */
const __vue_scope_id__$9 = undefined;
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, {}, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var largeFileUpload = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$9
});

/* script */

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1330_645)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M41 17V9C41 8.46957 40.7893 7.96086 40.4142 7.58579C40.0391 7.21071 39.5304 7 39 7H19.236C18.8647 6.9998 18.5007 6.89623 18.1849 6.7009C17.8692 6.50556 17.614 6.22616 17.448 5.894L15.552 2.106C15.386 1.77384 15.1308 1.49444 14.8151 1.2991C14.4993 1.10377 14.1353 1.0002 13.764 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V33C1 33.5304 1.21071 34.0391 1.58579 34.4142C1.96086 34.7893 2.46957 35 3 35H17",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 35C23 38.1826 24.2643 41.2348 26.5147 43.4853C28.7652 45.7357 31.8174 47 35 47C38.1826 47 41.2348 45.7357 43.4853 43.4853C45.7357 41.2348 47 38.1826 47 35C47 31.8174 45.7357 28.7652 43.4853 26.5147C41.2348 24.2643 38.1826 23 35 23C31.8174 23 28.7652 24.2643 26.5147 26.5147C24.2643 28.7652 23 31.8174 23 35Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M40.848 31L34 39.488L30 35.988",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1330_645"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = undefined;
/* scoped */
const __vue_scope_id__$8 = undefined;
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, {}, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var largeFolderCheck = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$8
});

/* script */

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_1330_606)"
    }
  }, [_c('path', {
    attrs: {
      "opacity": "0.99",
      "d": "M44.9221 24H3.0781C2.80894 23.9998 2.54251 24.0539 2.29477 24.1592C2.04703 24.2644 1.82307 24.4186 1.63633 24.6124C1.44958 24.8062 1.30389 25.0358 1.20797 25.2873C1.11205 25.5388 1.06788 25.807 1.0781 26.076L3.2081 45.076C3.22777 45.5932 3.44713 46.0825 3.8201 46.4413C4.19306 46.8001 4.69058 47.0004 5.2081 47H42.8881C43.4056 47.0004 43.9031 46.8001 44.2761 46.4413C44.6491 46.0825 44.8684 45.5932 44.8881 45.076L46.9221 26.076C46.9323 25.807 46.8882 25.5388 46.7922 25.2873C46.6963 25.0358 46.5506 24.8062 46.3639 24.6124C46.1771 24.4186 45.9532 24.2644 45.7054 24.1592C45.4577 24.0539 45.1913 23.9998 44.9221 24Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.99",
      "d": "M45.0779 20.01V8.00001C45.0779 7.46958 44.8672 6.96087 44.4921 6.5858C44.117 6.21072 43.6083 6.00001 43.0779 6.00001H22.6779L20.0259 1.92201C19.8444 1.64212 19.5958 1.41207 19.3028 1.25278C19.0097 1.09349 18.6814 1.01004 18.3479 1.01001H5.07788C4.54745 1.01001 4.03874 1.22072 3.66367 1.5958C3.28859 1.97087 3.07788 2.47958 3.07788 3.01001V20.01",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.99",
      "d": "M40.0759 20.01V15.01C40.0759 14.4796 39.8652 13.9709 39.4901 13.5958C39.1151 13.2207 38.6064 13.01 38.0759 13.01H10.0759C9.54549 13.01 9.03679 13.2207 8.66171 13.5958C8.28664 13.9709 8.07593 14.4796 8.07593 15.01V20.01",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_1330_606"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$7 = [];

/* style */
const __vue_inject_styles__$7 = undefined;
/* scoped */
const __vue_scope_id__$7 = undefined;
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, {}, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var largeFolderOpen1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$7
});

/* script */

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_315_504)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 40C9 39.7348 8.89464 39.4804 8.70711 39.2929C8.51957 39.1054 8.26522 39 8 39H4C3.73478 39 3.48043 39.1054 3.29289 39.2929C3.10536 39.4804 3 39.7348 3 40V47H9V40Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 30C21 29.7348 20.8946 29.4804 20.7071 29.2929C20.5196 29.1054 20.2652 29 20 29H16C15.7348 29 15.4804 29.1054 15.2929 29.2929C15.1054 29.4804 15 29.7348 15 30V47H21V30Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M33 36C33 35.7348 32.8946 35.4804 32.7071 35.2929C32.5196 35.1054 32.2652 35 32 35H28C27.7348 35 27.4804 35.1054 27.2929 35.2929C27.1054 35.4804 27 35.7348 27 36V47H33V36Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M45 20C45 19.7348 44.8946 19.4804 44.7071 19.2929C44.5196 19.1054 44.2652 19 44 19H40C39.7348 19 39.4804 19.1054 39.2929 19.2929C39.1054 19.4804 39 19.7348 39 20V47H45V20Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.00806 47H47.0081",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7.83606 17.1721L13.1801 11.8281",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.464 11.0161L24.552 13.9841",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.1541 13.5282L38.8621 7.47217",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.0081 5C38.0081 6.06087 38.4295 7.07828 39.1796 7.82843C39.9298 8.57857 40.9472 9 42.0081 9C43.0689 9 44.0863 8.57857 44.8365 7.82843C45.5866 7.07828 46.0081 6.06087 46.0081 5C46.0081 3.93913 45.5866 2.92172 44.8365 2.17157C44.0863 1.42143 43.0689 1 42.0081 1C40.9472 1 39.9298 1.42143 39.1796 2.17157C38.4295 2.92172 38.0081 3.93913 38.0081 5V5Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.0081 16C24.0081 17.0609 24.4295 18.0783 25.1796 18.8284C25.9298 19.5786 26.9472 20 28.0081 20C29.0689 20 30.0863 19.5786 30.8365 18.8284C31.5866 18.0783 32.0081 17.0609 32.0081 16C32.0081 14.9391 31.5866 13.9217 30.8365 13.1716C30.0863 12.4214 29.0689 12 28.0081 12C26.9472 12 25.9298 12.4214 25.1796 13.1716C24.4295 13.9217 24.0081 14.9391 24.0081 16Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.0081 9C12.0081 10.0609 12.4295 11.0783 13.1796 11.8284C13.9298 12.5786 14.9472 13 16.0081 13C17.0689 13 18.0863 12.5786 18.8365 11.8284C19.5866 11.0783 20.0081 10.0609 20.0081 9C20.0081 7.93913 19.5866 6.92172 18.8365 6.17157C18.0863 5.42143 17.0689 5 16.0081 5C14.9472 5 13.9298 5.42143 13.1796 6.17157C12.4295 6.92172 12.0081 7.93913 12.0081 9V9Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1.00806 20C1.00806 20.5253 1.11152 21.0454 1.31254 21.5307C1.51356 22.016 1.8082 22.457 2.17963 22.8284C2.55106 23.1999 2.99202 23.4945 3.47732 23.6955C3.96263 23.8965 4.48277 24 5.00806 24C5.53334 24 6.05349 23.8965 6.53879 23.6955C7.02409 23.4945 7.46505 23.1999 7.83648 22.8284C8.20792 22.457 8.50256 22.016 8.70357 21.5307C8.90459 21.0454 9.00806 20.5253 9.00806 20C9.00806 19.4747 8.90459 18.9546 8.70357 18.4693C8.50256 17.984 8.20792 17.543 7.83648 17.1716C7.46505 16.8001 7.02409 16.5055 6.53879 16.3045C6.05349 16.1035 5.53334 16 5.00806 16C4.48277 16 3.96263 16.1035 3.47732 16.3045C2.99202 16.5055 2.55106 16.8001 2.17963 17.1716C1.8082 17.543 1.51356 17.984 1.31254 18.4693C1.11152 18.9546 1.00806 19.4747 1.00806 20V20Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_315_504"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$6 = [];

/* style */
const __vue_inject_styles__$6 = undefined;
/* scoped */
const __vue_scope_id__$6 = undefined;
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, {}, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var largeGraph2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$6
});

/* script */

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2.5 11.5L17.172 28C17.5309 28.3962 18.0282 28.6393 18.5613 28.6791C19.0943 28.7189 19.6223 28.5524 20.036 28.214L28.964 20.774C29.3774 20.4356 29.9054 20.2696 30.4381 20.3106C30.9708 20.3516 31.4672 20.5964 31.824 20.994L45.5 36.494",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31.624 36.5H45.5V24.542",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = undefined;
/* scoped */
const __vue_scope_id__$5 = undefined;
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, {}, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

var largeGraphStatsDescend = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$5
});

/* script */

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 7.99805V2.99805",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 16.998H5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.636 10.6341L9.09998 7.1001",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21.868 38.1521L15.068 44.9521C13.7533 46.2605 11.9739 46.995 10.119 46.995C8.26418 46.995 6.48479 46.2605 5.17003 44.9521L3.04803 42.8321C1.74049 41.5165 1.00659 39.7369 1.00659 37.8821C1.00659 36.0272 1.74049 34.2477 3.04803 32.9321L9.84803 26.1321",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M31 17H39.754C41.6499 17.0311 43.4609 17.7917 44.8104 19.1237C46.16 20.4557 46.9442 22.2566 47 24.152V28.152C46.9209 30.0205 46.1131 31.7836 44.7497 33.0637C43.3863 34.3437 41.5757 35.0388 39.706 35H31",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$4 = [];

/* style */
const __vue_inject_styles__$4 = undefined;
/* scoped */
const __vue_scope_id__$4 = undefined;
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, {}, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var largeLinkBroken = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$4
});

/* script */

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24 32C25.1046 32 26 31.1046 26 30C26 28.8954 25.1046 28 24 28C22.8954 28 22 28.8954 22 30C22 31.1046 22.8954 32 24 32Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24 32V38",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M39 19H9C7.89543 19 7 19.8954 7 21V45C7 46.1046 7.89543 47 9 47H39C40.1046 47 41 46.1046 41 45V21C41 19.8954 40.1046 19 39 19Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13 12C13 9.08262 14.1589 6.28473 16.2218 4.22183C18.2847 2.15893 21.0826 1 24 1C26.9174 1 29.7153 2.15893 31.7782 4.22183C33.8411 6.28473 35 9.08262 35 12V19H13V12Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__$3 = [];

/* style */
const __vue_inject_styles__$3 = undefined;
/* scoped */
const __vue_scope_id__$3 = undefined;
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var largeLock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$3
});

/* script */

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_72_4658)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 39.121H5C3.93914 39.121 2.92172 38.6996 2.17158 37.9496C1.42143 37.1994 1 36.182 1 35.121V5.1211C1 4.06022 1.42143 3.04282 2.17158 2.29266C2.92172 1.54252 3.93914 1.12109 5 1.12109H43C44.0608 1.12109 45.0782 1.54252 45.8284 2.29266C46.5786 3.04282 47 4.06022 47 5.1211V19.1211",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 11.1211H47",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 29.121H8C7.73478 29.121 7.48042 29.0158 7.2929 28.8282C7.10536 28.6406 7 28.3864 7 28.121V22.121C7 21.8558 7.10536 21.6016 7.2929 21.414C7.48042 21.2264 7.73478 21.121 8 21.121H37",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.8101 40.333C32.4605 40.6826 32.0149 40.9206 31.5301 41.017C31.0451 41.1134 30.5425 41.0638 30.0857 40.8746C29.6289 40.6854 29.2385 40.365 28.9639 39.9538C28.6891 39.5426 28.5425 39.0594 28.5425 38.565C28.5425 38.0706 28.6891 37.5872 28.9639 37.176C29.2385 36.765 29.6289 36.4446 30.0857 36.2554C30.5425 36.066 31.0451 36.0166 31.5301 36.113C32.0149 36.2094 32.4605 36.4474 32.8101 36.797C33.2787 37.266 33.5417 37.902 33.5417 38.565C33.5417 39.228 33.2787 39.8638 32.8101 40.333Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M38.0959 35.755L46.9999 26.871V22.871H42.9999L33.8519 31.513C32.1425 30.7888 30.2343 30.6818 28.4547 31.21C26.6749 31.7384 25.1343 32.8692 24.0967 34.4088C23.0593 35.9484 22.5897 37.801 22.7683 39.6488C22.9469 41.4968 23.7625 43.225 25.0757 44.5374C26.3887 45.85 28.1173 46.6648 29.9653 46.8426C31.8133 47.0202 33.6657 46.5498 35.2047 45.5116C36.7439 44.4734 37.8741 42.9322 38.4015 41.1522C38.9289 39.3722 38.8209 37.4642 38.0959 35.755Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6.6211C7.72386 6.6211 7.5 6.39724 7.5 6.1211C7.5 5.84496 7.72386 5.6211 8 5.6211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 6.6211C8.27614 6.6211 8.5 6.39724 8.5 6.1211C8.5 5.84496 8.27614 5.6211 8 5.6211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 6.6211C13.7239 6.6211 13.5 6.39724 13.5 6.1211C13.5 5.84496 13.7239 5.6211 14 5.6211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 6.6211C14.2761 6.6211 14.5 6.39724 14.5 6.1211C14.5 5.84496 14.2761 5.6211 14 5.6211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 6.6211C19.7239 6.6211 19.5 6.39724 19.5 6.1211C19.5 5.84496 19.7239 5.6211 20 5.6211"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M20 6.6211C20.2762 6.6211 20.5 6.39724 20.5 6.1211C20.5 5.84496 20.2762 5.6211 20 5.6211"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_72_4658"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = undefined;
/* scoped */
const __vue_scope_id__$2 = undefined;
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var largePasswordKey = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$2
});

/* script */

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_72_4660)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M29 47C29 44.6131 29.9482 42.3239 31.636 40.636C33.3239 38.9482 35.6131 38 38 38C40.3869 38 42.6761 38.9482 44.364 40.636C46.0518 42.3239 47 44.6131 47 47",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.5 30.5C32.5 31.9587 33.0795 33.3576 34.1109 34.3891C35.1424 35.4205 36.5413 36 38 36C39.4587 36 40.8576 35.4205 41.8891 34.3891C42.9205 33.3576 43.5 31.9587 43.5 30.5C43.5 29.0413 42.9205 27.6424 41.8891 26.6109C40.8576 25.5795 39.4587 25 38 25C36.5413 25 35.1424 25.5795 34.1109 26.6109C33.0795 27.6424 32.5 29.0413 32.5 30.5Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M37.0001 19C37.0056 14.5709 35.3721 10.2965 32.4141 7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 23V29C0.999042 32.5403 2.04209 36.0022 3.99865 38.9527C5.95521 41.9032 8.7384 44.2112 12 45.588",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M28.0001 3.41199C25.3372 1.87462 22.3249 1.04501 19.2504 1.00229C16.1758 0.959562 13.1416 1.70514 10.4371 3.16793C7.73249 4.63072 5.44772 6.76195 3.80061 9.35839C2.15351 11.9548 1.19899 14.9299 1.02808 18",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14 8.088C15.8284 7.24994 17.8382 6.88491 19.8445 7.02646C21.8509 7.16802 23.7895 7.81161 25.4821 8.89809C27.1748 9.98457 28.5672 11.4791 29.5314 13.2443C30.4955 15.0094 31.0006 16.9887 31 19V21.852",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.944 37C26.3238 38.8113 24.1918 40.088 21.8301 40.6612C19.4684 41.2343 16.9884 41.0769 14.7181 40.2097C12.4478 39.3426 10.4944 37.8065 9.1162 35.8049C7.73802 33.8032 7.00007 31.4302 7.00001 29V19C6.99575 16.0474 8.08433 13.1978 10.056 11",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13 29C13 30.5913 13.6321 32.1174 14.7574 33.2426C15.8826 34.3679 17.4087 35 19 35C20.5913 35 22.1174 34.3679 23.2426 33.2426C24.3679 32.1174 25 30.5913 25 29V19C25 17.4087 24.3679 15.8826 23.2426 14.7574C22.1174 13.6321 20.5913 13 19 13C17.4087 13 15.8826 13.6321 14.7574 14.7574C13.6321 15.8826 13 17.4087 13 19V25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 19V25",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 29V31",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 47C20.7074 47.0014 22.4064 46.7603 24.046 46.284",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_72_4660"
    }
  }, [_c('rect', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "fill": "white"
    }
  })])])]);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = undefined;
/* scoped */
const __vue_scope_id__$1 = undefined;
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var largeTouchIdUser = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__$1
});

/* script */

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "fill-override",
    attrs: {
      "width": "48",
      "height": "48",
      "viewBox": "0 0 48 48",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.5 15.5C6.5 17.7543 7.39553 19.9163 8.98959 21.5104C10.5837 23.1045 12.7457 24 15 24C17.2543 24 19.4163 23.1045 21.0104 21.5104C22.6045 19.9163 23.5 17.7543 23.5 15.5C23.5 13.2457 22.6045 11.0837 21.0104 9.48959C19.4163 7.89553 17.2543 7 15 7C12.7457 7 10.5837 7.89553 8.98959 9.48959C7.39553 11.0837 6.5 13.2457 6.5 15.5V15.5Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 41C1 37.287 2.475 33.726 5.10051 31.1005C7.72601 28.475 11.287 27 15 27C18.713 27 22.274 28.475 24.8995 31.1005C27.525 33.726 29 37.287 29 41",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M46.9998 40.9998C46.9998 39.112 46.5139 37.256 45.5889 35.6103C44.6639 33.9646 43.331 32.5847 41.7184 31.6033C40.1057 30.6219 38.2676 30.072 36.381 30.0066C34.4943 29.9412 32.6225 30.3624 30.9458 31.2298",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M29.3882 20.5C29.3882 21.3536 29.5563 22.1988 29.883 22.9874C30.2096 23.7761 30.6884 24.4926 31.292 25.0962C31.8956 25.6998 32.6121 26.1786 33.4007 26.5052C34.1894 26.8319 35.0346 27 35.8882 27C36.7418 27 37.587 26.8319 38.3756 26.5052C39.1642 26.1786 39.8808 25.6998 40.4844 25.0962C41.088 24.4926 41.5667 23.7761 41.8934 22.9874C42.2201 22.1988 42.3882 21.3536 42.3882 20.5C42.3882 19.6464 42.2201 18.8012 41.8934 18.0126C41.5667 17.2239 41.088 16.5074 40.4844 15.9038C39.8808 15.3002 39.1642 14.8214 38.3756 14.4948C37.587 14.1681 36.7418 14 35.8882 14C35.0346 14 34.1894 14.1681 33.4007 14.4948C32.6121 14.8214 31.8956 15.3002 31.292 15.9038C30.6884 16.5074 30.2096 17.2239 29.883 18.0126C29.5563 18.8012 29.3882 19.6464 29.3882 20.5V20.5Z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, {}, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var largeUserMultiple = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': __vue_component__
});

export { IToggleSizes, closeModal, install as default, getModal, __vue_component__$2I as iAccordion, __vue_component__$2H as iAccordionItem, iAccordionItemSizes, __vue_component__$2$ as iAlertIcon, __vue_component__$2F as iAlertMessage, __vue_component__$2P as iAmountRangeFilter, __vue_component__$2O as iBadge, iBadgeColours, iBadgeDotSizes, __vue_component__$32 as iButton, __vue_component__$30 as iButtonsGroup, iButtonsGroupTypes, __vue_component__$2W as iCheckbox, __vue_component__$2V as iCheckboxGroup, __vue_component__$2Z as iCopyInput, __vue_component__$2z as iDropzone, iDropzoneTypes, __vue_component__$2_ as iFeaturedIcon, iFeaturedIconSizes, iFeaturedIconTypes, __vue_component__$2Q as iFilter, __vue_component__$34 as iIcon, __vue_component__$31 as iIconButton, __vue_component__$2J as iIconToggle, __vue_component__$2Y as iInlineInput, __vue_component__$2M as iMenu, __vue_component__$2L as iMenuItem, iMenuTriggerAlignOptions, __vue_component__$2E as iModal, __vue_component__$2D as iPanel, __vue_component__$2X as iRadio, __vue_component__$2U as iSearchInput, __vue_component__$2T as iSelect, __vue_component__$2N as iSort, __vue_component__$33 as iSpinner, __vue_component__$2A as iStepper, iStepperSizes, __vue_component__$2S as iSwitch, __vue_component__$2R as iTextInput, iTextInputModes, iTextInputSizes, __vue_component__$2G as iTitleBanner, __vue_component__$2C as iToast, __vue_component__$2K as iToggle, __vue_component__$2B as iTooltip, iTooltipAlignmentMode, iTooltipBackgroundMode, iTooltipInfoTypes, iTooltipToggleMode, openModal, positionMenu };
